<!-- src\components\Screen8.vue -->
<template>
  <div class="container-center-horizontal">
    <div
      class="u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 screen"
    >
      <div
        class="x-39 chat-disabled"
        :class="{
          'chat-collapsed': !chatBlock.isExpanded.value,
          'screen8-loading-active': isLoading,
        }"
        :style="{ '--sidebar-height': `${sidebarHeight}px` }"
      >
        <!-- Бургер-кнопка для мобильных -->
        <button
          class="burger-menu-toggle"
          :class="{ 'is-active': isSidebarOpen }"
          @click="toggleSidebar"
          aria-label="Открыть меню"
          :aria-expanded="isSidebarOpen"
        >
          <span class="burger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <!-- Оверлей для закрытия сайдбара -->
        <div
          class="sidebar-overlay"
          :class="{ 'is-visible': isSidebarOpen }"
          @click="closeSidebar"
        ></div>

        <div
          v-if="isLoading"
          class="screen8-loading-overlay"
          role="status"
          aria-live="polite"
        >
          <div class="screen8-loading-card">
            <div class="screen8-loading-ring"></div>
            <div class="screen8-loading-title">Загружаем модуль</div>
            <div class="screen8-loading-subtitle">
              Готовим материалы и прогресс
            </div>
            <div class="screen8-loading-dots">
              <span class="screen8-loading-dot"></span>
              <span class="screen8-loading-dot"></span>
              <span class="screen8-loading-dot"></span>
            </div>
          </div>
        </div>
        <div class="view-414">
          <ModuleLoadError v-if="loadError" :on-retry="refreshModuleData" />

          <transition name="content-switch" mode="out-in">
            <div
              v-if="!isLoading && !loadError && hasNoModuleData"
              key="empty-module-content"
              class="screen8-module-status screen8-module-status--empty"
            >
              В этом модуле пока нет материалов.
            </div>
            <!-- Видеоплеер (по умолчанию) -->
            <div
              v-else-if="contentMode === 'video'"
              key="video-content"
              class="video-content-wrapper"
            >
              <div
                class="player-container"
                :class="{
                  'player-container-collapsed': !chatBlock.isExpanded.value,
                }"
              >
                <div class="view-415">
                  <div
                    v-if="isYouTubeVideo"
                    class="video-embed-frame"
                    :class="{
                      'video-embed-frame--bitrix-fullscreen':
                        isBitrixMode && isBitrixYoutubeFullscreen,
                    }"
                  >
                    <button
                      v-if="isBitrixMode"
                      type="button"
                      class="bitrix-video-fullscreen-btn"
                      :title="
                        isBitrixYoutubeFullscreen
                          ? 'Свернуть видео'
                          : 'Открыть видео на весь экран'
                      "
                      @click="toggleBitrixYoutubeFullscreen"
                    >
                      {{ isBitrixYoutubeFullscreen ? 'Свернуть' : 'На весь экран' }}
                    </button>
                    <iframe
                      :src="youtubeEmbedUrl"
                      title="Video"
                      allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </div>
                  <video-player
                    v-else-if="videoSource"
                    :video-source="videoSource"
                    :poster-image="view2"
                    :custom-fullscreen-handler="
                      isBitrixMode ? openCurrentVideoInBitrixSlider : null
                    "
                    :current-time="videoCurrentTime"
                    :on-time-update="onVideoTimeUpdate"
                    :on-play="onVideoPlay"
                    :on-pause="onVideoPause"
                    :on-ended="onVideoEnded"
                    :on-loaded-metadata="onVideoLoadedMetadata"
                  />
                  <div v-else class="video-missing">Видео недоступно</div>
                </div>

                <!-- Прогресс-бар для видео -->
                <div v-if="videoDuration > 0" class="video-progress-bar">
                  <div
                    class="video-progress-fill"
                    :style="{ width: `${videoProgress}%` }"
                  ></div>
                </div>
              </div>
              <div class="video-content-header">
                <div class="video-content-title poppins-semi-bold-black-25px">
                  {{ selectedLessonTitle }}
                </div>
                <div
                  v-if="sanitizedVideoDescription"
                  class="video-content-description poppins-normal-black-20px"
                  @click="handleRichMediaLinkClick"
                  v-html="sanitizedVideoDescription"
                ></div>
              </div>

              <div v-if="hasLessonMaterials" class="lesson-materials-block">
                <div
                  v-if="lessonMainMaterials.length"
                  class="lesson-materials-group"
                >
                  <div class="lesson-materials-header">
                    <div class="materials-title poppins-semi-bold-black-20px">
                      <svg
                        class="screen8-inline-icon screen8-inline-icon--book"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M3 5.5A2.5 2.5 0 0 1 5.5 3H12v16H5.5A2.5 2.5 0 0 0 3 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 5.5A2.5 2.5 0 0 0 18.5 3H12v16h6.5A2.5 2.5 0 0 1 21 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Материалы к уроку
                    </div>
                    <div class="materials-subtitle">
                      Основные файлы для прохождения урока.
                    </div>
                    <span
                      v-if="isMainMaterialsDownloadDisabled"
                      class="materials-restriction"
                    >
                      Скачивание отключено преподавателем
                    </span>
                  </div>
                  <ul class="materials-list">
                    <li
                      v-for="(material, index) in lessonMainMaterials"
                      :key="`lesson-material-${index}`"
                      class="materials-item"
                    >
                      <router-link
                        v-if="getMaterialLink(material)"
                        :to="
                          getMaterialViewerRoute(
                            material,
                            isMainMaterialsDownloadDisabled
                          )
                        "
                        class="material-name material-name--link"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </router-link>
                      <span v-else class="material-name">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </span>
                      <a
                        v-if="
                          !isMainMaterialsDownloadDisabled &&
                          getMaterialLink(material)
                        "
                        :href="getMaterialLink(material)"
                        class="material-download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        :download="
                          getMaterialDownloadName(material) || undefined
                        "
                      >
                        Скачать
                      </a>
                    </li>
                  </ul>
                </div>

                <div
                  v-if="lessonAdditionalMaterials.length"
                  class="lesson-materials-group lesson-materials-group--additional"
                >
                  <div class="lesson-materials-header">
                    <div class="materials-title poppins-semi-bold-black-20px">
                      <svg
                        class="screen8-inline-icon screen8-inline-icon--book"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M3 5.5A2.5 2.5 0 0 1 5.5 3H12v16H5.5A2.5 2.5 0 0 0 3 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 5.5A2.5 2.5 0 0 0 18.5 3H12v16h6.5A2.5 2.5 0 0 1 21 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Дополнительные материалы
                    </div>
                    <div class="materials-subtitle">
                      Файлы для углубленного изучения темы.
                    </div>
                    <span
                      v-if="isAdditionalMaterialsDownloadDisabled"
                      class="materials-restriction"
                    >
                      Скачивание отключено преподавателем
                    </span>
                  </div>
                  <ul class="materials-list">
                    <li
                      v-for="(material, index) in lessonAdditionalMaterials"
                      :key="`lesson-additional-material-${index}`"
                      class="materials-item"
                    >
                      <router-link
                        v-if="getMaterialLink(material)"
                        :to="
                          getMaterialViewerRoute(
                            material,
                            isAdditionalMaterialsDownloadDisabled
                          )
                        "
                        class="material-name material-name--link"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </router-link>
                      <span v-else class="material-name">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </span>
                      <a
                        v-if="
                          !isAdditionalMaterialsDownloadDisabled &&
                          getMaterialLink(material)
                        "
                        :href="getMaterialLink(material)"
                        class="material-download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        :download="
                          getMaterialDownloadName(material) || undefined
                        "
                      >
                        Скачать
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="lesson-actions">
                <button
                  class="lesson-complete-button"
                  type="button"
                  :disabled="isCompleting || !canCompleteLesson"
                  @click="markLessonCompleted"
                >
                  <span
                    v-if="isCompleting"
                    class="loading-spinner-small"
                  ></span>
                  <span v-else>{{
                    canCompleteLesson ? "Завершить урок" : "Урок завершен"
                  }}</span>
                </button>
              </div>
            </div>

            <!-- Контент статьи -->
            <div
              v-else-if="contentMode === 'article'"
              key="article-content"
              class="article-content-wrapper"
            >
              <div class="article-content-header">
                <div class="article-content-title poppins-semi-bold-black-25px">
                  {{ selectedLessonTitle }}
                </div>
              </div>
              <div
                v-if="
                  hasArticleContent
                "
                class="article-content-toc-inline"
              >
                <div class="article-content-toc-inline__title">Содержание</div>
                <div
                  v-if="articleTocItems.length === 0"
                  class="article-content-toc-inline__empty"
                >
                  Оглавление отсутствует
                </div>
                <nav
                  v-else
                  class="article-content-toc-inline__list"
                  aria-label="Содержание статьи"
                >
                  <button
                    v-for="item in articleInlineTocVisibleItems"
                    :key="`inline-${item.id}`"
                    type="button"
                    class="article-content-toc-inline__item"
                    :class="`article-content-toc-inline__item--level-${item.level}`"
                    @click="onArticleTocItemClick(item.id)"
                  >
                    {{ item.text }}
                  </button>
                </nav>
                <button
                  v-if="hasArticleInlineTocOverflow"
                  type="button"
                  class="article-content-toc-inline__toggle"
                  @click="toggleArticleInlineToc"
                >
                  {{
                    isArticleInlineTocExpanded ? "Свернуть" : "Показать ещё"
                  }}
                </button>
              </div>

              <div
                v-if="hasArticleContent"
                class="article-content-body-shell"
                ref="articleContentBodyShellRef"
              >
                <div
                  v-if="articleTocItems.length"
                  class="article-content-nav-indicator"
                  :class="{
                    'article-content-nav-indicator--hidden':
                      !isArticleNavIndicatorVisible,
                  }"
                  @mouseenter="openArticleToc"
                  @mouseleave="scheduleCloseArticleToc"
                  @focusin="openArticleToc"
                  @focusout="handleArticleTocFocusOut"
                >
                  <div
                    class="article-content-nav-indicator__headers"
                    ref="articleContentNavHeadersRef"
                    aria-label="Оглавление статьи"
                  >
                    <button
                      v-for="(item, index) in articleTocItems"
                      :key="`indicator-${item.id}`"
                      type="button"
                      class="article-content-nav-indicator__line"
                      :class="[
                        `article-content-nav-indicator__line--level-${item.level}`,
                        {
                          'article-content-nav-indicator__line--show':
                            isArticleTocOpen,
                        },
                      ]"
                      :style="{ transitionDelay: `${index * 50}ms` }"
                      :aria-label="`Перейти к разделу: ${item.text}`"
                      @click="onArticleTocItemClick(item.id)"
                    ></button>
                  </div>

                  <aside
                    class="article-content-toc article-content-toc--floating"
                    :class="{ 'article-content-toc--open': isArticleTocOpen }"
                    @mouseenter="openArticleToc"
                    @mouseleave="scheduleCloseArticleToc"
                  >
                    <div class="article-content-toc__title">Содержание</div>
                    <nav class="article-content-toc__list" aria-label="Содержание статьи">
                      <button
                        v-for="item in articleTocItems"
                        :key="`floating-${item.id}`"
                        type="button"
                        class="article-content-toc__item"
                        :class="`article-content-toc__item--level-${item.level}`"
                        @click="onArticleTocItemClick(item.id)"
                      >
                        {{ item.text }}
                      </button>
                    </nav>
                  </aside>
                </div>
                <CollapsibleArticle
                  class="article-content-body ck-content"
                  :content="sanitizedArticleContent"
                  :collapsible-headings="articleCollapsibleHeadings"
                  :enable-bitrix-video-slider="isBitrixMode"
                  @open-media="openBitrixMediaInSlider"
                />
              </div>

              <div v-if="hasLessonMaterials" class="lesson-materials-block">
                <div
                  v-if="lessonMainMaterials.length"
                  class="lesson-materials-group"
                >
                  <div class="lesson-materials-header">
                    <div class="materials-title poppins-semi-bold-black-20px">
                      <svg
                        class="screen8-inline-icon screen8-inline-icon--book"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M3 5.5A2.5 2.5 0 0 1 5.5 3H12v16H5.5A2.5 2.5 0 0 0 3 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 5.5A2.5 2.5 0 0 0 18.5 3H12v16h6.5A2.5 2.5 0 0 1 21 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Материалы к уроку
                    </div>
                    <div class="materials-subtitle">
                      Основные файлы для прохождения урока.
                    </div>
                    <span
                      v-if="isMainMaterialsDownloadDisabled"
                      class="materials-restriction"
                    >
                      Скачивание отключено преподавателем
                    </span>
                  </div>
                  <ul class="materials-list">
                    <li
                      v-for="(material, index) in lessonMainMaterials"
                      :key="`article-material-${index}`"
                      class="materials-item"
                    >
                      <router-link
                        v-if="getMaterialLink(material)"
                        :to="
                          getMaterialViewerRoute(
                            material,
                            isMainMaterialsDownloadDisabled
                          )
                        "
                        class="material-name material-name--link"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </router-link>
                      <span v-else class="material-name">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </span>
                      <a
                        v-if="
                          !isMainMaterialsDownloadDisabled &&
                          getMaterialLink(material)
                        "
                        :href="getMaterialLink(material)"
                        class="material-download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        :download="
                          getMaterialDownloadName(material) || undefined
                        "
                      >
                        Скачать
                      </a>
                    </li>
                  </ul>
                </div>

                <div
                  v-if="lessonAdditionalMaterials.length"
                  class="lesson-materials-group lesson-materials-group--additional"
                >
                  <div class="lesson-materials-header">
                    <div class="materials-title poppins-semi-bold-black-20px">
                      <svg
                        class="screen8-inline-icon screen8-inline-icon--book"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <path
                          d="M3 5.5A2.5 2.5 0 0 1 5.5 3H12v16H5.5A2.5 2.5 0 0 0 3 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M21 5.5A2.5 2.5 0 0 0 18.5 3H12v16h6.5A2.5 2.5 0 0 1 21 21V5.5Z"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Дополнительные материалы
                    </div>
                    <div class="materials-subtitle">
                      Файлы для углубленного изучения темы.
                    </div>
                    <span
                      v-if="isAdditionalMaterialsDownloadDisabled"
                      class="materials-restriction"
                    >
                      Скачивание отключено преподавателем
                    </span>
                  </div>
                  <ul class="materials-list">
                    <li
                      v-for="(material, index) in lessonAdditionalMaterials"
                      :key="`article-additional-material-${index}`"
                      class="materials-item"
                    >
                      <router-link
                        v-if="getMaterialLink(material)"
                        :to="
                          getMaterialViewerRoute(
                            material,
                            isAdditionalMaterialsDownloadDisabled
                          )
                        "
                        class="material-name material-name--link"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </router-link>
                      <span v-else class="material-name">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </span>
                      <a
                        v-if="
                          !isAdditionalMaterialsDownloadDisabled &&
                          getMaterialLink(material)
                        "
                        :href="getMaterialLink(material)"
                        class="material-download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        :download="
                          getMaterialDownloadName(material) || undefined
                        "
                      >
                        Скачать
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="lesson-actions">
                <button
                  class="lesson-complete-button"
                  type="button"
                  :disabled="isCompleting || !canCompleteLesson"
                  @click="markLessonCompleted"
                >
                  <span
                    v-if="isCompleting"
                    class="loading-spinner-small"
                  ></span>
                  <span v-else>{{
                    canCompleteLesson ? "Завершить урок" : "Урок завершен"
                  }}</span>
                </button>
              </div>
            </div>

            <!-- Практика -->
            <div
              v-else-if="contentMode === 'practice'"
              key="practice-content"
              class="practice-content-wrapper"
            >
              <div class="practice-content-header">
                <div
                  class="practice-content-title poppins-semi-bold-black-25px"
                >
                  {{ selectedPracticeTitle }}
                </div>
              </div>
              <div class="practice-content-body">
                <div
                  v-if="sanitizedPracticeDescription"
                  class="practice-section rich-text-content"
                  v-html="sanitizedPracticeDescription"
                ></div>
                <div
                  v-if="sanitizedPracticeInstructions"
                  class="practice-section rich-text-content"
                  v-html="sanitizedPracticeInstructions"
                ></div>

                <div
                  v-if="
                    practiceSteps.length ||
                    practiceQuestions.length ||
                    practiceAttachedTest
                  "
                  class="practice-split"
                  :class="{ 'practice-split--single': !practiceAttachedTest }"
                >
                  <div
                    v-if="practiceSteps.length || practiceQuestions.length"
                    class="practice-split-main"
                  >
                    <div v-if="practiceSteps.length" class="practice-section">
                      <div
                        class="practice-section-title poppins-semi-bold-black-20px"
                      >
                        Шаги
                      </div>
                      <ol class="practice-list">
                        <li
                          v-for="(step, index) in practiceSteps"
                          :key="`practice-step-${index}`"
                        >
                          {{ getPracticeListText(step) }}
                        </li>
                      </ol>
                    </div>

                    <div
                      v-if="practiceQuestions.length"
                      class="practice-section"
                    >
                      <div
                        class="practice-section-title poppins-semi-bold-black-25px"
                      >
                        Вопросы
                      </div>
                      <ul class="practice-list">
                        <li
                          v-for="(question, index) in practiceQuestions"
                          :key="`practice-question-${index}`"
                        >
                          {{ getPracticeListText(question) }}
                        </li>
                      </ul>
                    </div>

                    <!-- ОБНОВЛЁННЫЙ БЛОК МИНИ-ТЕСТА -->
                  </div>
                  <div v-if="practiceAttachedTest" class="practice-split-aside">
                    <div class="practice-section practice-test-section">
                      <div class="practice-test-card practice-test-inline">
                        <div class="practice-test-heading">
                          <span class="practice-test-label">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Мини-тест для проверки своих знаний
                          </span>
                        </div>
                        <div class="practice-test-title">
                          <svg
                            class="screen8-inline-icon screen8-inline-icon--flask"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M9 3h6M10 3v4.5l-4.7 7.8A3 3 0 0 0 7.9 20h8.2a3 3 0 0 0 2.6-4.7L14 7.5V3"
                              stroke="currentColor"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8 13h8"
                              stroke="currentColor"
                              stroke-width="1.8"
                              stroke-linecap="round"
                            />
                          </svg>
                          {{ getItemTitle(practiceAttachedTest, "Тест") }}
                        </div>
                        <div class="practice-test-meta">
                          <span
                            v-if="practiceAttachedTest.questions_count"
                            class="practice-test-meta-item"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M8 14A6 6 0 108 2a6 6 0 000 12z"
                                stroke="currentColor"
                                stroke-width="1.5"
                              />
                              <path
                                d="M6 6.5a2 2 0 113.5 1.5c-.5.5-1.5 1-1.5 2"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                              <circle
                                cx="8"
                                cy="12"
                                r="0.5"
                                fill="currentColor"
                              />
                            </svg>
                            {{ practiceAttachedTest.questions_count }} вопросов
                          </span>
                          <span
                            v-if="practiceAttachedTest.passing_score"
                            class="practice-test-meta-item"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M8 1l2 4 4.5.5-3.25 3 .75 4.5L8 11l-4 2 .75-4.5L1.5 5.5 6 5l2-4z"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Проходной балл:
                            {{ practiceAttachedTest.passing_score }}
                          </span>
                          <span class="practice-test-note">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <circle
                                cx="8"
                                cy="8"
                                r="6.5"
                                stroke="currentColor"
                                stroke-width="1.5"
                              />
                              <path
                                d="M8 5v4"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                              <circle
                                cx="8"
                                cy="11"
                                r="0.75"
                                fill="currentColor"
                              />
                            </svg>
                            Самопроверка, прогресс не меняется
                          </span>
                        </div>

                        <!-- Quiz Body -->
                        <div class="practice-quiz-body">
                          <div
                            v-for="(question, qIndex) in practiceQuizQuestions"
                            :key="question.id || qIndex"
                            class="practice-quiz-question"
                            :class="{
                              'is-correct':
                                practiceQuizChecked &&
                                isPracticeQuestionCorrect(question),
                              'is-wrong':
                                practiceQuizChecked &&
                                !isPracticeQuestionCorrect(question),
                            }"
                          >
                            <!-- Question Header -->
                            <div class="practice-quiz-question-header">
                              <span class="practice-quiz-question-number">{{
                                qIndex + 1
                              }}</span>
                              <span class="practice-quiz-question-type">
                                <template v-if="question.type === 'single'">
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <circle
                                      cx="7"
                                      cy="7"
                                      r="6"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                    <circle
                                      cx="7"
                                      cy="7"
                                      r="3"
                                      fill="currentColor"
                                    />
                                  </svg>
                                  Один ответ
                                </template>
                                <template
                                  v-else-if="question.type === 'multiple'"
                                >
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <rect
                                      x="1"
                                      y="1"
                                      width="12"
                                      height="12"
                                      rx="2"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                    <path
                                      d="M4 7l2 2 4-4"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Несколько ответов
                                </template>
                                <template v-else>
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <rect
                                      x="1"
                                      y="4"
                                      width="12"
                                      height="6"
                                      rx="1"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                    <path
                                      d="M3 7h2"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                    />
                                  </svg>
                                  Текстовый ответ
                                </template>
                              </span>
                            </div>

                            <!-- Question Text -->
                            <div class="practice-quiz-question-title">
                              {{ question.text }}
                            </div>

                            <!-- Single Choice Answers -->
                            <div
                              v-if="question.type === 'single'"
                              class="practice-quiz-answers"
                            >
                              <label
                                v-for="answer in question.answers"
                                :key="answer.id"
                                class="practice-quiz-answer"
                                :class="{
                                  'is-selected':
                                    practiceQuizAnswers[question.id] ===
                                    answer.id,
                                  'is-correct-answer':
                                    practiceQuizChecked && answer.isCorrect,
                                  'is-wrong-answer':
                                    practiceQuizChecked &&
                                    !answer.isCorrect &&
                                    practiceQuizAnswers[question.id] ===
                                      answer.id,
                                  'is-disabled': practiceQuizChecked,
                                }"
                              >
                                <span
                                  class="practice-quiz-answer-indicator practice-quiz-answer-radio"
                                >
                                  <span
                                    class="practice-quiz-answer-radio-dot"
                                  ></span>
                                </span>
                                <input
                                  type="radio"
                                  :name="`practice-q-${question.id}`"
                                  :value="answer.id"
                                  :checked="
                                    practiceQuizAnswers[question.id] ===
                                    answer.id
                                  "
                                  @change="
                                    setPracticeSingleAnswer(question, answer.id)
                                  "
                                  :disabled="practiceQuizChecked"
                                  class="practice-quiz-input-hidden"
                                />
                                <span class="practice-quiz-answer-text">{{
                                  answer.text
                                }}</span>
                                <span
                                  v-if="practiceQuizChecked && answer.isCorrect"
                                  class="practice-quiz-answer-status practice-quiz-answer-status--correct"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M13.5 4.5L6 12L2.5 8.5"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                                <span
                                  v-if="
                                    practiceQuizChecked &&
                                    !answer.isCorrect &&
                                    practiceQuizAnswers[question.id] ===
                                      answer.id
                                  "
                                  class="practice-quiz-answer-status practice-quiz-answer-status--wrong"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M12 4L4 12M4 4l8 8"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                              </label>
                            </div>

                            <!-- Multiple Choice Answers -->
                            <div
                              v-else-if="question.type === 'multiple'"
                              class="practice-quiz-answers"
                            >
                              <label
                                v-for="answer in question.answers"
                                :key="answer.id"
                                class="practice-quiz-answer"
                                :class="{
                                  'is-selected': (
                                    practiceQuizAnswers[question.id] || []
                                  ).includes(answer.id),
                                  'is-correct-answer':
                                    practiceQuizChecked && answer.isCorrect,
                                  'is-wrong-answer':
                                    practiceQuizChecked &&
                                    !answer.isCorrect &&
                                    (
                                      practiceQuizAnswers[question.id] || []
                                    ).includes(answer.id),
                                  'is-disabled': practiceQuizChecked,
                                }"
                              >
                                <span
                                  class="practice-quiz-answer-indicator practice-quiz-answer-checkbox"
                                >
                                  <svg
                                    v-if="
                                      (
                                        practiceQuizAnswers[question.id] || []
                                      ).includes(answer.id)
                                    "
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M10 3L4.5 9L2 6.5"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                                <input
                                  type="checkbox"
                                  :name="`practice-q-${question.id}`"
                                  :value="answer.id"
                                  :checked="
                                    (
                                      practiceQuizAnswers[question.id] || []
                                    ).includes(answer.id)
                                  "
                                  @change="
                                    togglePracticeMultiAnswer(
                                      question,
                                      answer.id
                                    )
                                  "
                                  :disabled="practiceQuizChecked"
                                  class="practice-quiz-input-hidden"
                                />
                                <span class="practice-quiz-answer-text">{{
                                  answer.text
                                }}</span>
                                <span
                                  v-if="practiceQuizChecked && answer.isCorrect"
                                  class="practice-quiz-answer-status practice-quiz-answer-status--correct"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M13.5 4.5L6 12L2.5 8.5"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                                <span
                                  v-if="
                                    practiceQuizChecked &&
                                    !answer.isCorrect &&
                                    (
                                      practiceQuizAnswers[question.id] || []
                                    ).includes(answer.id)
                                  "
                                  class="practice-quiz-answer-status practice-quiz-answer-status--wrong"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                  >
                                    <path
                                      d="M12 4L4 12M4 4l8 8"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                              </label>
                            </div>

                            <!-- Text Answer -->
                            <div v-else class="practice-quiz-text-answer">
                              <div class="practice-quiz-text-wrapper">
                                <input
                                  type="text"
                                  class="practice-quiz-text-input"
                                  :class="{
                                    'is-correct':
                                      practiceQuizChecked &&
                                      isPracticeQuestionCorrect(question),
                                    'is-wrong':
                                      practiceQuizChecked &&
                                      !isPracticeQuestionCorrect(question),
                                  }"
                                  placeholder="Введите ваш ответ..."
                                  :value="
                                    practiceQuizAnswers[question.id] || ''
                                  "
                                  @input="
                                    setPracticeTextAnswer(
                                      question,
                                      $event.target.value
                                    )
                                  "
                                  :disabled="practiceQuizChecked"
                                />
                                <span
                                  v-if="practiceQuizChecked"
                                  class="practice-quiz-text-status"
                                >
                                  <svg
                                    v-if="isPracticeQuestionCorrect(question)"
                                    class="practice-quiz-text-status--correct"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <circle
                                      cx="11"
                                      cy="11"
                                      r="10"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                    <path
                                      d="M15 8L9.5 14L7 11.5"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  <svg
                                    v-else
                                    class="practice-quiz-text-status--wrong"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 22 22"
                                    fill="none"
                                  >
                                    <circle
                                      cx="11"
                                      cy="11"
                                      r="10"
                                      stroke="currentColor"
                                      stroke-width="1.5"
                                    />
                                    <path
                                      d="M14 8L8 14M8 8l6 6"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                              </div>
                              <div
                                v-if="
                                  practiceQuizChecked &&
                                  !isPracticeQuestionCorrect(question) &&
                                  question.correctText
                                "
                                class="practice-quiz-correct-answer"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <path
                                    d="M13.5 4.5L6 12L2.5 8.5"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                Правильный ответ:
                                <strong>{{ question.correctText }}</strong>
                              </div>
                            </div>

                            <!-- Explanation Block -->
                            <div
                              v-if="practiceQuizChecked"
                              class="practice-quiz-explanation"
                            >
                              <div class="practice-quiz-explanation-header">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                >
                                  <circle
                                    cx="9"
                                    cy="9"
                                    r="7.5"
                                    stroke="currentColor"
                                    stroke-width="1.5"
                                  />
                                  <path
                                    d="M9 8v5"
                                    stroke="currentColor"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                  />
                                  <circle
                                    cx="9"
                                    cy="5.5"
                                    r="0.75"
                                    fill="currentColor"
                                  />
                                </svg>
                                <span>Пояснение</span>
                              </div>
                              <div class="practice-quiz-explanation-content">
                                <template v-if="question.explanation">
                                  {{ question.explanation }}
                                </template>
                                <template v-else>
                                  <span class="practice-quiz-explanation-empty"
                                    >Пояснение не добавлено</span
                                  >
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Quiz Actions -->
                        <div class="practice-quiz-actions">
                          <div class="practice-quiz-actions-left">
                            <div
                              v-if="practiceQuizChecked"
                              class="practice-quiz-result"
                              :class="{
                                'practice-quiz-result--success':
                                  practiceQuizCorrectCount /
                                    practiceQuizTotal >=
                                  0.7,
                                'practice-quiz-result--warning':
                                  practiceQuizCorrectCount /
                                    practiceQuizTotal >=
                                    0.4 &&
                                  practiceQuizCorrectCount / practiceQuizTotal <
                                    0.7,
                                'practice-quiz-result--fail':
                                  practiceQuizCorrectCount / practiceQuizTotal <
                                  0.4,
                              }"
                            >
                              <div class="practice-quiz-result-icon">
                                <svg
                                  v-if="
                                    practiceQuizCorrectCount /
                                      practiceQuizTotal >=
                                    0.7
                                  "
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="2"
                                  />
                                  <path
                                    d="M8 12l3 3 5-6"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                <svg
                                  v-else
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="2"
                                  />
                                  <path
                                    d="M12 8v4"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <circle
                                    cx="12"
                                    cy="15"
                                    r="1"
                                    fill="currentColor"
                                  />
                                </svg>
                              </div>
                              <div class="practice-quiz-result-info">
                                <div class="practice-quiz-result-title">
                                  Результат
                                </div>
                                <div class="practice-quiz-result-score">
                                  <span class="practice-quiz-result-value">{{
                                    practiceQuizCorrectCount
                                  }}</span>
                                  <span class="practice-quiz-result-separator"
                                    >/</span
                                  >
                                  <span class="practice-quiz-result-total">{{
                                    practiceQuizTotal
                                  }}</span>
                                  <span class="practice-quiz-result-percent"
                                    >({{
                                      Math.round(
                                        (practiceQuizCorrectCount /
                                          practiceQuizTotal) *
                                          100
                                      )
                                    }}%)</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="practice-quiz-actions-right">
                            <button
                              v-if="!practiceQuizChecked"
                              type="button"
                              class="practice-quiz-btn practice-quiz-btn--check"
                              @click="checkPracticeQuiz"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M16.5 5.5L7.5 14.5L3.5 10.5"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Проверить ответы
                            </button>
                            <button
                              v-if="practiceQuizChecked"
                              type="button"
                              class="practice-quiz-btn practice-quiz-btn--reset"
                              @click="resetPracticeQuiz"
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M3.5 3.5V8H8"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M3.98 12.5a7 7 0 1 0 1.27-5.27L3.5 8"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Пройти заново
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- КОНЕЦ ОБНОВЛЁННОГО БЛОКА МИНИ-ТЕСТА -->
                  </div>
                </div>
                <div
                  v-if="practiceMaterials.length"
                  class="practice-section materials-section"
                >
                  <div
                    class="practice-section-title poppins-semi-bold-black-20px"
                  >
                    Материалы
                  </div>
                  <ul class="materials-list">
                    <li
                      v-for="(material, index) in practiceMaterials"
                      :key="`practice-material-${index}`"
                      class="materials-item"
                    >
                      <router-link
                        v-if="getMaterialLink(material)"
                        :to="getMaterialViewerRoute(material)"
                        class="material-name material-name--link"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </router-link>
                      <span v-else class="material-name">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </span>
                      <a
                        v-if="getMaterialLink(material)"
                        :href="getMaterialLink(material)"
                        class="material-download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        :download="
                          getMaterialDownloadName(material) || undefined
                        "
                      >
                        Скачать
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="lesson-actions">
                <button
                  class="lesson-complete-button"
                  type="button"
                  :disabled="isCompletingPractice || !canCompletePractice"
                  @click="markPracticeCompleted"
                >
                  <span
                    v-if="isCompletingPractice"
                    class="loading-spinner-small"
                  ></span>
                  <span v-else>{{
                    canCompletePractice
                      ? "Завершить практику"
                      : "Практика завершена"
                  }}</span>
                </button>
              </div>
            </div>

            <!-- Тест -->
            <div
              v-else-if="contentMode === 'test'"
              key="test-content"
              class="test-content-wrapper"
            >
              <div class="test-content-header">
                <div class="test-content-title poppins-semi-bold-black-25px">
                  {{ selectedTestTitle }}
                </div>
              </div>
              <div class="test-content-body">
                <div
                  v-if="sanitizedTestDescription"
                  class="test-section"
                  v-html="sanitizedTestDescription"
                ></div>

                <div v-if="testMeta.length" class="test-section">
                  <ul class="test-meta">
                    <li
                      v-for="(item, index) in testMeta"
                      :key="`test-meta-${index}`"
                    >
                      <span class="test-meta-label">{{ item.label }}:</span>
                      <span class="test-meta-value">{{ item.value }}</span>
                    </li>
                  </ul>
                </div>

                <div v-if="selectedTestResults" class="test-results-block">
                  <div class="test-results-header">
                    <div class="test-results-title">
                      <svg
                        class="screen8-inline-icon screen8-inline-icon--check-circle"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="9"
                          stroke="currentColor"
                          stroke-width="1.8"
                        />
                        <path
                          d="M8.5 12.3 11 14.8l4.8-4.9"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Результаты теста
                    </div>
                    <button
                      type="button"
                      class="test-results-refresh"
                      :disabled="isRefreshingTestResults"
                      @click="refreshSelectedTestResults"
                    >
                      {{
                        isRefreshingTestResults ? "Обновляем..." : "Обновить"
                      }}
                    </button>
                  </div>
                  <div class="test-results-grid">
                    <div
                      v-if="testIsReviewedByTeacher"
                      class="test-results-item"
                    >
                      <span class="test-results-label">Оценка:</span>

                      <span class="test-results-value">
                        {{ testGradeLabel }}
                      </span>
                    </div>
                    <div class="test-results-item">
                      <span class="test-results-label">Процент:</span>
                      <span class="test-results-value"
                        >{{ selectedTestResults.percentage }}%</span
                      >
                    </div>
                    <div class="test-results-item">
                      <span class="test-results-label">Статус:</span>
                      <span
                        class="test-results-value"
                        :class="
                          selectedTestResults.passed
                            ? 'test-results-value--success'
                            : 'test-results-value--fail'
                        "
                      >
                        {{ selectedTestResults.passed ? "Сдан" : "Не сдан" }}
                      </span>
                    </div>
                    <div v-if="testStartTimeValue" class="test-results-item">
                      <span class="test-results-label">Начало:</span>
                      <span class="test-results-value">{{
                        formatTestDateTime(testStartTimeValue)
                      }}</span>
                    </div>
                    <div v-if="testEndTimeValue" class="test-results-item">
                      <span class="test-results-label">Окончание:</span>
                      <span class="test-results-value">{{
                        formatTestDateTime(testEndTimeValue)
                      }}</span>
                    </div>
                    <div
                      v-if="
                        selectedTestResults.totalTime !== null &&
                        selectedTestResults.totalTime !== undefined
                      "
                      class="test-results-item"
                    >
                      <span class="test-results-label">Время:</span>
                      <span class="test-results-value">{{
                        formatTestDuration(selectedTestResults.totalTime)
                      }}</span>
                    </div>
                    <div class="test-results-item">
                      <span class="test-results-label">Правильные:</span>
                      <span class="test-results-value">{{
                        selectedTestResults.correct
                      }}</span>
                    </div>
                    <div class="test-results-item">
                      <span class="test-results-label">Неправильные:</span>
                      <span class="test-results-value">{{
                        selectedTestResults.wrong
                      }}</span>
                    </div>
                    <div class="test-results-item">
                      <span class="test-results-label">Пропущено:</span>
                      <span class="test-results-value">{{
                        selectedTestResults.unanswered
                      }}</span>
                    </div>
                  </div>
                </div>

                <div
                  v-if="testReviewIsAvailable"
                  class="test-section test-section--review"
                >
                  <div class="test-section-title poppins-semi-bold-black-20px">
                    Отзыв
                  </div>

                  <div class="homework-review-table">
                    <table>
                      <tbody>
                        <tr
                          :class="[
                            'homework-review-row',
                            'homework-review-row--grade',
                            { 'test-review-row--low': testReviewIsFailing },
                          ]"
                        >
                          <th scope="row">Оценка</th>

                          <td>{{ testReviewGradeLabel }}</td>
                        </tr>

                        <tr>
                          <th scope="row">Оценено в</th>

                          <td>{{ testReviewGradedAtLabel }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  v-if="testMaterials.length"
                  class="test-section materials-section"
                >
                  <div class="test-section-title poppins-semi-bold-black-20px">
                    Материалы
                  </div>
                  <ul class="materials-list">
                    <li
                      v-for="(material, index) in testMaterials"
                      :key="`test-material-${index}`"
                      class="materials-item"
                    >
                      <router-link
                        v-if="getMaterialLink(material)"
                        :to="getMaterialViewerRoute(material)"
                        class="material-name material-name--link"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </router-link>
                      <span v-else class="material-name">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </span>
                      <a
                        v-if="getMaterialLink(material)"
                        :href="getMaterialLink(material)"
                        class="material-download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        :download="
                          getMaterialDownloadName(material) || undefined
                        "
                      >
                        Скачать
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div
                v-if="isSelectedTestFinal && !finalTestAccessAllowed"
                class="final-test-access"
              >
                <div class="final-test-access__title">
                  Финальный тест пока недоступен
                </div>
                <ul class="final-test-access__list">
                  <li v-if="finalTestMissingItems.length">
                    Нужно завершить:
                    <span class="final-test-access__items">
                      {{
                        finalTestMissingItems
                          .map(
                            (item) =>
                              `${item.label} (${item.completed}/${item.total})`
                          )
                          .join(", ")
                      }}
                    </span>
                  </li>
                  <li v-if="finalTestMissingGrades.length">
                    Нужна оценка за тесты:
                    <span class="final-test-access__items">
                      {{
                        finalTestMissingGrades
                          .map((item) => item.title)
                          .join(", ")
                      }}
                    </span>
                  </li>
                  <li
                    v-if="
                      finalTestWindowStatus === 'upcoming' &&
                      finalTestWindowStart
                    "
                  >
                    Тест станет доступен
                    {{ formatDateTime(finalTestWindowStart) }}
                  </li>
                  <li
                    v-if="
                      finalTestWindowStatus === 'expired' && finalTestWindowEnd
                    "
                  >
                    Окно доступа завершилось
                    {{ formatDateTime(finalTestWindowEnd) }}
                  </li>
                </ul>
              </div>
              <div class="lesson-actions">
                <button
                  class="lesson-complete-button"
                  type="button"
                  :disabled="!canStartTest"
                  @click="openTestRunner()"
                >
                  <span>{{ testStartLabel }}</span>
                </button>
                <div v-if="testAttemptsLimit" class="test-attempts-info">
                  Попытки: {{ testAttemptsUsed }}/{{ testAttemptsLimit }}
                </div>
              </div>
            </div>

            <!-- Домашнее задание -->
            <div
              v-else-if="contentMode === 'homework'"
              key="homework-content"
              class="homework-content-wrapper"
            >
              <div class="homework-content-header">
                <div
                  class="homework-content-title poppins-semi-bold-black-25px"
                >
                  {{ selectedHomeworkTitle }}
                </div>
              </div>
              <div class="homework-content-body">
                <div
                  v-if="sanitizedHomeworkDescription"
                  class="homework-section homework-section--description rich-text-content"
                  v-html="sanitizedHomeworkDescription"
                ></div>

                <div
                  v-if="homeworkRequirements.length"
                  class="homework-section"
                >
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Требования
                  </div>
                  <ul class="homework-list">
                    <li
                      v-for="(requirement, index) in homeworkRequirements"
                      :key="`homework-requirement-${index}`"
                    >
                      {{ getHomeworkListText(requirement) }}
                    </li>
                  </ul>
                </div>

                <div
                  v-if="homeworkMaterials.length"
                  class="homework-section materials-section"
                >
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Материалы
                  </div>
                  <ul class="materials-list">
                    <li
                      v-for="(material, index) in homeworkMaterials"
                      :key="`homework-material-${index}`"
                      class="materials-item"
                    >
                      <router-link
                        v-if="getMaterialLink(material)"
                        :to="getMaterialViewerRoute(material)"
                        class="material-name material-name--link"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </router-link>
                      <span v-else class="material-name">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--file"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M8 3h6l5 5v13H8V3Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M14 3v5h5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {{ getMaterialTitle(material) }}
                      </span>
                      <a
                        v-if="getMaterialLink(material)"
                        :href="getMaterialLink(material)"
                        class="material-download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        :download="
                          getMaterialDownloadName(material) || undefined
                        "
                      >
                        Скачать
                      </a>
                    </li>
                  </ul>
                </div>

                <div v-if="homeworkMeta.length" class="homework-section">
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Информация
                  </div>
                  <ul class="homework-meta">
                    <li
                      v-for="(item, index) in homeworkMeta"
                      :key="`homework-meta-${index}`"
                    >
                      <span class="homework-meta-label">{{ item.label }}:</span>
                      <span class="homework-meta-value">{{ item.value }}</span>
                    </li>
                  </ul>
                </div>

                <div class="homework-section homework-section--status">
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Состояние ответа
                  </div>
                  <div class="homework-status-table">
                    <table>
                      <tbody>
                        <tr>
                          <th scope="row">Состояние ответа на задание</th>
                          <td>{{ homeworkAnswerStateLabel }}</td>
                        </tr>
                        <tr>
                          <th scope="row">Состояние оценивания</th>
                          <td>{{ homeworkGradingStateLabel }}</td>
                        </tr>
                        <tr :class="homeworkTimingRowClass">
                          <th scope="row">Оставшееся время</th>
                          <td>{{ homeworkTimingLabel }}</td>
                        </tr>
                        <tr>
                          <th scope="row">Последнее изменение</th>
                          <td>{{ homeworkLastChangeLabel }}</td>
                        </tr>
                        <tr>
                          <th scope="row">Ответ в виде файла</th>
                          <td>
                            <ul
                              v-if="homeworkAnswerFiles.length"
                              class="homework-status-files"
                            >
                              <li
                                v-for="file in homeworkAnswerFiles"
                                :key="file.key"
                                class="homework-status-file"
                              >
                                <a
                                  v-if="file.url"
                                  :href="file.url"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="homework-status-file-link"
                                >
                                  {{ file.name }}
                                </a>
                                <span
                                  v-else
                                  class="homework-status-file-name"
                                  >{{ file.name }}</span
                                >
                              </li>
                            </ul>
                            <span v-else class="homework-status-empty"
                              >Файлы не загружены</span
                            >
                          </td>
                        </tr>
                        <tr class="homework-status-row--comments">
                          <th scope="row">Комментарии к ответу</th>
                          <td>
                            <button
                              type="button"
                              class="homework-status-comments"
                              @click="openHomeworkCommentModal"
                            >
                              Комментарии ({{ homeworkCommentsCount }})
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  v-if="homeworkRevisionRequested"
                  class="homework-section homework-section--revision"
                >
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Доработка от преподавателя
                  </div>
                  <div class="homework-review-table">
                    <table>
                      <tbody>
                        <tr>
                          <th scope="row">Комментарий</th>
                          <td class="homework-review-feedback">
                            {{
                              homeworkRevisionRequestText ||
                              "Комментарий не указан."
                            }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Файлы</th>
                          <td>
                            <ul
                              v-if="homeworkRevisionRequestFiles.length"
                              class="homework-status-files"
                            >
                              <li
                                v-for="file in homeworkRevisionRequestFiles"
                                :key="file.file_path || file.url || file.name"
                                class="homework-status-file"
                              >
                                <a
                                  v-if="getHomeworkSubmissionFileUrl(file)"
                                  :href="getHomeworkSubmissionFileUrl(file)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  class="homework-status-file-link"
                                >
                                  {{ getHomeworkSubmissionFileName(file) }}
                                </a>
                                <span v-else class="homework-status-file-name">
                                  {{ getHomeworkSubmissionFileName(file) }}
                                </span>
                              </li>
                            </ul>
                            <span v-else class="homework-status-empty">
                              Файлы не приложены
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Запрошено</th>
                          <td>
                            {{
                              formatHomeworkDateTimeLong(
                                homeworkRevisionRequestedAt
                              ) || "—"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div
                  v-if="homeworkIsGraded"
                  class="homework-section homework-section--review"
                >
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Отзыв
                  </div>
                  <div class="homework-review-table">
                    <table>
                      <tbody>
                        <tr
                          class="homework-review-row homework-review-row--grade"
                        >
                          <th scope="row">Оценка</th>
                          <td>{{ homeworkGradeLabel }}</td>
                        </tr>
                        <tr>
                          <th scope="row">Отзыв</th>
                          <td class="homework-review-feedback">
                            {{ homeworkFeedbackLabel }}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Оценено в</th>
                          <td>{{ homeworkGradedAtLabel }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="homework-section homework-section--upload">
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Загрузка / управление ответом
                  </div>
                  <div class="homework-upload">
                    <div
                      v-if="homeworkEditingBlocked"
                      class="homework-upload-blocked"
                    >
                      <svg
                        class="screen8-inline-icon screen8-inline-icon--lock"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <rect
                          x="5"
                          y="10"
                          width="14"
                          height="10"
                          rx="2.5"
                          stroke="currentColor"
                          stroke-width="1.8"
                        />
                        <path
                          d="M8.5 10V7.8a3.5 3.5 0 0 1 7 0V10"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                      </svg>
                      {{ homeworkEditingBlockedLabel }}
                    </div>

                    <div
                      v-else-if="
                        homeworkHasSubmission &&
                        !isHomeworkUploadExpanded &&
                        !homeworkFiles.length
                      "
                      class="homework-upload-compact"
                    >
                      <div class="homework-upload-compact-text">
                        Ответ уже отправлен. При необходимости обновите файлы.
                      </div>
                      <button
                        type="button"
                        class="homework-upload-secondary"
                        @click="expandHomeworkUpload"
                      >
                        Изменить ответ
                      </button>
                    </div>

                    <div v-else class="homework-upload-body">
                      <input
                        ref="homeworkFileInput"
                        type="file"
                        class="homework-file-input"
                        multiple
                        @change="onHomeworkFileChange"
                      />

                      <div class="homework-upload-actions">
                        <button
                          type="button"
                          class="homework-upload-button"
                          @click="openHomeworkFileDialog"
                        >
                          Выбрать файлы
                        </button>
                        <span class="homework-upload-hint"
                          >или перетащите их в область ниже</span
                        >
                      </div>

                      <div
                        class="homework-upload-zone"
                        :class="{
                          'homework-upload-zone--drag': isHomeworkDragging,
                        }"
                        @dragover.prevent="onHomeworkDragOver"
                        @dragleave.prevent="onHomeworkDragLeave"
                        @drop.prevent="onHomeworkDrop"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--upload"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M12 15V5m0 0-3.5 3.5M12 5l3.5 3.5M4 16.5V19h16v-2.5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Перетащите файлы сюда
                      </div>
                      <p class="homework-upload-formats">
                        Допустимые форматы: изображения (.jpg, .jpeg, .png,
                        .gif, .webp, .svg), документы (.pdf, .doc, .docx,
                        .xls, .xlsx, .ppt, .pptx, .txt, .csv), архивы (.zip,
                        .rar, .7z), медиа (.mp3, .wav, .mp4, .webm).
                      </p>

                      <ul
                        v-if="homeworkExistingFiles.length"
                        class="homework-files-list homework-files-list--existing"
                      >
                        <li
                          v-for="(file, index) in homeworkExistingFiles"
                          :key="`homework-existing-file-${index}`"
                          class="homework-file-item"
                        >
                          <a
                            v-if="getHomeworkSubmissionFileUrl(file)"
                            :href="getHomeworkSubmissionFileUrl(file)"
                            class="homework-file-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {{ getHomeworkSubmissionFileName(file) }}
                          </a>
                          <span v-else class="homework-file-name">
                            <svg
                              class="screen8-inline-icon screen8-inline-icon--file"
                              viewBox="0 0 24 24"
                              fill="none"
                              aria-hidden="true"
                            >
                              <path
                                d="M8 3h6l5 5v13H8V3Z"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14 3v5h5"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            {{ getHomeworkSubmissionFileName(file) }}
                          </span>
                          <button
                            type="button"
                            class="homework-file-remove"
                            @click="removeHomeworkExistingFile(index)"
                          >
                            Удалить
                          </button>
                        </li>
                      </ul>

                      <ul
                        v-if="homeworkFiles.length"
                        class="homework-files-list"
                      >
                        <li
                          v-for="(file, index) in homeworkFiles"
                          :key="`homework-file-${file.name}-${file.lastModified}`"
                          class="homework-file-item"
                        >
                          <span class="homework-file-name">
                            <svg
                              class="screen8-inline-icon screen8-inline-icon--file"
                              viewBox="0 0 24 24"
                              fill="none"
                              aria-hidden="true"
                            >
                              <path
                                d="M8 3h6l5 5v13H8V3Z"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14 3v5h5"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            {{ file.name }}
                          </span>
                          <button
                            type="button"
                            class="homework-file-remove"
                            @click="removeHomeworkFile(index)"
                          >
                            Удалить
                          </button>
                        </li>
                      </ul>

                      <div class="homework-upload-status">
                        <span
                          v-if="homeworkSubmissionError"
                          class="homework-upload-error"
                        >
                          <svg
                            class="screen8-inline-icon screen8-inline-icon--error"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="9"
                              stroke="currentColor"
                              stroke-width="1.8"
                            />
                            <path
                              d="M9.2 9.2 14.8 14.8M14.8 9.2l-5.6 5.6"
                              stroke="currentColor"
                              stroke-width="1.8"
                              stroke-linecap="round"
                            />
                          </svg>
                          {{ homeworkSubmissionError }}
                        </span>
                      </div>

                      <div class="homework-upload-footer">
                        <button
                          v-if="homeworkHasSubmission"
                          type="button"
                          class="homework-upload-cancel"
                          @click="cancelHomeworkUpload"
                        >
                          Отменить
                        </button>
                        <button
                          type="button"
                          class="homework-submit-button"
                          :disabled="isSubmittingHomework || !canSubmitHomework"
                          @click="submitHomework"
                        >
                          {{ homeworkSubmitButtonLabel }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="homeworkRevisionRequested"
                  class="homework-section homework-section--revision-upload"
                >
                  <div
                    class="homework-section-title poppins-semi-bold-black-20px"
                  >
                    Исправленное задание
                  </div>

                  <div class="homework-upload">
                    <div
                      v-if="
                        homeworkRevisionRequestText ||
                        homeworkRevisionRequestFiles.length
                      "
                      class="homework-existing-files"
                    >
                      <div class="homework-existing-title">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--folder"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Комментарий преподавателя
                      </div>
                      <p class="homework-review-feedback">
                        {{
                          homeworkRevisionRequestText ||
                          "Комментарий не указан."
                        }}
                      </p>
                      <ul
                        v-if="homeworkRevisionRequestFiles.length"
                        class="homework-files-list homework-files-list--existing"
                      >
                        <li
                          v-for="file in homeworkRevisionRequestFiles"
                          :key="file.file_path || file.url || file.name"
                          class="homework-file-item"
                        >
                          <a
                            v-if="getHomeworkSubmissionFileUrl(file)"
                            :href="getHomeworkSubmissionFileUrl(file)"
                            class="homework-file-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {{ getHomeworkSubmissionFileName(file) }}
                          </a>
                          <span v-else class="homework-file-name">
                            <svg
                              class="screen8-inline-icon screen8-inline-icon--file"
                              viewBox="0 0 24 24"
                              fill="none"
                              aria-hidden="true"
                            >
                              <path
                                d="M8 3h6l5 5v13H8V3Z"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14 3v5h5"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            {{ getHomeworkSubmissionFileName(file) }}
                          </span>
                        </li>
                      </ul>
                      <span v-else class="homework-status-empty">
                        Файлы не приложены
                      </span>
                    </div>

                    <div
                      v-if="homeworkRevisionHasSubmission"
                      class="homework-existing-files"
                    >
                      <div class="homework-existing-title">
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--folder"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Отправленные файлы
                      </div>
                      <ul
                        class="homework-files-list homework-files-list--existing"
                      >
                        <li
                          v-for="(
                            file, index
                          ) in homeworkRevisionSubmissionFiles"
                          :key="`homework-revision-existing-${index}`"
                          class="homework-file-item"
                        >
                          <a
                            v-if="getHomeworkSubmissionFileUrl(file)"
                            :href="getHomeworkSubmissionFileUrl(file)"
                            class="homework-file-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {{ getHomeworkSubmissionFileName(file) }}
                          </a>
                          <span v-else class="homework-file-name">
                            <svg
                              class="screen8-inline-icon screen8-inline-icon--file"
                              viewBox="0 0 24 24"
                              fill="none"
                              aria-hidden="true"
                            >
                              <path
                                d="M8 3h6l5 5v13H8V3Z"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14 3v5h5"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            {{ getHomeworkSubmissionFileName(file) }}
                          </span>
                          <button
                            v-if="!homeworkRevisionEditingBlocked"
                            type="button"
                            class="homework-file-remove"
                            @click="removeRevisionExistingFile(index)"
                          >
                            Удалить
                          </button>
                        </li>
                      </ul>
                      <div
                        class="homework-submitted-at"
                        v-if="homeworkRevisionSubmittedAt"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--check-circle"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="9"
                            stroke="currentColor"
                            stroke-width="1.8"
                          />
                          <path
                            d="M8.5 12.3 11 14.8l4.8-4.9"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Исправление отправлено:
                        {{ formatDateTime(homeworkRevisionSubmittedAt) || "" }}
                      </div>
                    </div>

                    <div
                      v-if="homeworkRevisionEditingBlocked"
                      class="homework-upload-blocked"
                    >
                      <svg
                        class="screen8-inline-icon screen8-inline-icon--lock"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                      >
                        <rect
                          x="5"
                          y="10"
                          width="14"
                          height="10"
                          rx="2.5"
                          stroke="currentColor"
                          stroke-width="1.8"
                        />
                        <path
                          d="M8.5 10V7.8a3.5 3.5 0 0 1 7 0V10"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                        />
                      </svg>
                      Работа уже оценена. Доработка недоступна.
                    </div>

                    <div v-else class="homework-upload-body">
                      <div class="homework-upload-header">
                        <label class="text-sm font-semibold text-[#3a3430]">
                          Комментарий к исправлению
                        </label>
                        <textarea
                          v-model="revisionText"
                          class="homework-comment-modal__textarea"
                          rows="3"
                          placeholder="Опишите, что вы исправили"
                        ></textarea>
                      </div>

                      <input
                        ref="revisionFileInput"
                        type="file"
                        class="homework-file-input"
                        multiple
                        @change="onRevisionFileChange"
                      />
                      <div class="homework-upload-actions">
                        <button
                          type="button"
                          class="homework-upload-button"
                          @click="openRevisionFileDialog"
                        >
                          Добавить файлы
                        </button>
                        <span class="homework-upload-hint">
                          или перетащите их в область ниже
                        </span>
                      </div>

                      <div
                        class="homework-upload-zone"
                        :class="{
                          'homework-upload-zone--drag': isRevisionDragging,
                        }"
                        @dragover.prevent="onRevisionDragOver"
                        @dragleave.prevent="onRevisionDragLeave"
                        @drop.prevent="onRevisionDrop"
                      >
                        <svg
                          class="screen8-inline-icon screen8-inline-icon--upload"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M12 15V5m0 0-3.5 3.5M12 5l3.5 3.5M4 16.5V19h16v-2.5"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Перетащите файлы сюда
                      </div>

                      <ul
                        v-if="revisionFiles.length"
                        class="homework-files-list"
                      >
                        <li
                          v-for="(file, index) in revisionFiles"
                          :key="`homework-revision-file-${file.name}-${file.lastModified}`"
                          class="homework-file-item"
                        >
                          <span class="homework-file-name">
                            <svg
                              class="screen8-inline-icon screen8-inline-icon--file"
                              viewBox="0 0 24 24"
                              fill="none"
                              aria-hidden="true"
                            >
                              <path
                                d="M8 3h6l5 5v13H8V3Z"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M14 3v5h5"
                                stroke="currentColor"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            {{ file.name }}
                          </span>
                          <button
                            type="button"
                            class="homework-file-remove"
                            @click="removeRevisionFile(index)"
                          >
                            Удалить
                          </button>
                        </li>
                      </ul>

                      <div class="homework-upload-status">
                        <span
                          v-if="revisionSubmissionError"
                          class="homework-upload-error"
                        >
                          <svg
                            class="screen8-inline-icon screen8-inline-icon--error"
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="9"
                              stroke="currentColor"
                              stroke-width="1.8"
                            />
                            <path
                              d="M9.2 9.2 14.8 14.8M14.8 9.2l-5.6 5.6"
                              stroke="currentColor"
                              stroke-width="1.8"
                              stroke-linecap="round"
                            />
                          </svg>
                          {{ revisionSubmissionError }}
                        </span>
                      </div>

                      <div class="homework-upload-footer">
                        <button
                          type="button"
                          class="homework-submit-button"
                          :disabled="
                            isSubmittingRevision ||
                            !canSubmitRevision ||
                            homeworkRevisionHasSubmission
                          "
                          @click="submitRevision"
                        >
                          {{
                            isSubmittingRevision
                              ? "Отправка..."
                              : "Отправить исправление"
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <teleport to="body">
            <transition name="fade">
              <div
                v-if="homeworkCommentModalOpen"
                class="homework-comment-modal"
              >
                <div
                  class="homework-comment-modal__backdrop"
                  @click="closeHomeworkCommentModal"
                ></div>
                <div class="homework-comment-modal__card" role="dialog">
                  <div class="homework-comment-modal__header">
                    <h4>Комментарий к ответу</h4>
                    <button
                      type="button"
                      class="homework-comment-modal__close"
                      @click="closeHomeworkCommentModal"
                    >
                      ?
                    </button>
                  </div>
                  <textarea
                    v-model="homeworkCommentDraft"
                    class="homework-comment-modal__textarea"
                    :disabled="homeworkEditingBlocked"
                    placeholder="Напишите комментарий для преподавателя"
                  ></textarea>
                  <p class="homework-comment-modal__note">
                    Комментарий отправится преподавателю вместе с файлом при
                    отправке задания.
                  </p>
                  <div class="homework-comment-modal__actions">
                    <button
                      type="button"
                      class="homework-comment-modal__cancel"
                      @click="closeHomeworkCommentModal"
                    >
                      Закрыть
                    </button>
                    <button
                      type="button"
                      class="homework-comment-modal__submit"
                      :disabled="homeworkEditingBlocked"
                      @click="saveHomeworkComment"
                    >
                      Добавить комментарий
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </teleport>

          <div
            class="view-419"
            :class="{ 'view-419-collapsed': !chatBlock.isExpanded.value }"
          >
            <view632
              :title="moduleTitle"
              :subtitle="moduleSubtitle"
              :className="
                !chatBlock.isExpanded.value
                  ? 'view-129-collapsed'
                  : view632Props.className
              "
            />
          </div>
        </div>

        <!-- Chat disabled for now -->
        <div
          v-if="false"
          class="view-404"
          :class="{ 'chat-collapsed': !chatBlock.isExpanded.value }"
        >
          <!-- Триггер сворачивания -->
          <div
            v-show="chatBlock.isExpanded.value"
            class="view-413 chat-toggle-trigger"
            @click="toggleChat"
          >
            <div class="text-378">{{ text378 }}</div>
            <div v-html="text377" class="text-377"></div>
          </div>

          <!-- Развернутое состояние чата -->
          <transition
            name="chat-expand"
            @enter="enter"
            @after-enter="afterEnter"
            @leave="leave"
          >
            <div
              v-show="chatBlock.isExpanded.value"
              class="chat-expanded-content"
            >
              <div class="view-410">
                <div class="view-411"></div>
                <div class="view-412">
                  <img
                    class="vector-285"
                    src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-594.svg"
                    alt="Vector"
                  />
                  <img
                    class="vector-287"
                    src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-595.svg"
                    alt="Vector"
                  />
                  <img
                    class="vector-291"
                    src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-596.svg"
                    alt="Vector"
                  />
                </div>
                <div class="text-376">{{ text376 }}</div>
              </div>

              <div class="view-405">
                <!-- <ChatComponent /> -->
              </div>

              <div class="view-408">
                <div class="view-409"></div>
                <div
                  class="x4-5"
                  :style="{ 'background-image': 'url(' + x4 + ')' }"
                ></div>
                <view512 />
                <div class="x2-13">
                  <div class="rectangle-82-36"></div>
                  <img class="image-12-16" :src="image12" alt="image 12" />
                  <view612 :className="view612Props.className" />
                </div>
                <div class="x3-20"></div>
                <div
                  class="x1-50"
                  :style="{ 'background-image': 'url(' + x1 + ')' }"
                >
                  <div class="rectangle-82-37"></div>
                </div>
              </div>
            </div>
          </transition>

          <!-- Свернутое состояние чата -->
          <transition
            name="chat-collapse"
            @enter="enter"
            @after-enter="afterEnter"
            @leave="leave"
          >
            <div
              v-show="!chatBlock.isExpanded.value"
              class="chat-collapsed-content"
            >
              <div class="view-112-collapsed" @click="toggleChat">
                <div class="view-113-collapsed">
                  <div class="view-114-collapsed">
                    <img
                      class="vector-114-collapsed"
                      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-573.svg"
                      alt="Vector"
                    />
                    <img
                      class="vector-115-collapsed"
                      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-573.svg"
                      alt="Vector"
                    />
                    <img
                      class="vector-116-collapsed"
                      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-575.svg"
                      alt="Vector"
                    />
                  </div>
                  <div class="view-115-collapsed">
                    <div class="rectangle-82-collapsed"></div>
                    <div class="x1-6-collapsed">2</div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <Sidebar_Screen8
          v-bind="$props"
          :class="{ 'is-open': isSidebarOpen }"
          :lessons="moduleLessons"
          :practice="modulePractice"
          :tests="moduleTests"
          :homework="moduleHomework"
          :final-test-id="finalTestId"
          :content-mode="contentMode"
          :selected-lesson-key="selectedLessonKey"
          :selected-practice-key="selectedPracticeKey"
          :selected-test-key="selectedTestKey"
          :selected-homework-key="selectedHomeworkKey"
          @update:contentMode="contentMode = $event"
          @update:sidebarHeight="sidebarHeight = $event"
          @update:selectedLessonKey="onSidebarLessonSelect"
          @update:selectedPracticeKey="onSidebarPracticeSelect"
          @update:selectedTestKey="onSidebarTestSelect"
          @update:selectedHomeworkKey="onSidebarHomeworkSelect"
        />

        <div class="header-2-4">
          <div class="rectangle-207-5"></div>
          <div v-html="text415" class="text-415"></div>
          <router-link :to="backRoute">
            <div class="text-416">Вернуться назад</div>
          </router-link>
          <div class="header-progress">
            <!-- Индикаторы прогресса -->
            <div
              v-if="!isLoading && !loadError && !hasNoModuleData"
              class="progress-indicators progress-indicators--header"
            >
              <div class="progress-bar">
                <div
                  class="progress-fill"
                  :style="{ width: `${moduleProgress}%` }"
                ></div>
              </div>
              <div class="progress-meta">
                <div class="progress-text">
                  {{ Math.round(moduleProgress) }}% модуля завершено
                </div>
                <div class="progress-actions">
                  <button
                    class="progress-refresh-button"
                    type="button"
                    :disabled="isRefreshing"
                    @click="refreshModuleData"
                  >
                    <span
                      v-if="isRefreshing"
                      class="loading-spinner-small"
                    ></span>
                    <span v-else>Обновить</span>
                  </button>
                </div>
              </div>
              <div v-if="showFinalTestCapHint" class="progress-note">
                Финальный тест не пройден — прогресс ограничен до
                {{ finalTestCapPercent }}%
              </div>
            </div>
          </div>
        </div>

        <view722 :class="view722Props.className" />
      </div>
      <TestRunner
        v-if="showTestRunner"
        :test-data="testRunnerData"
        :questions="testRunnerQuestions"
        @close="closeTestRunner"
      />

      <!-- Toast-уведомления -->
      <div v-if="completionError" class="completion-error-toast">
        {{ completionError }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  computed,
  watch,
  nextTick,
  onMounted,
  onBeforeUnmount,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useCollapsible } from "../composables/useCollapsible";
import { useAppStore } from "@/stores/useAppStore";
import {
  modulesService,
  lessonsService,
  progressService,
  practicalService,
  homeworkService,
  testsService,
} from "@/services";
import { formatDateTime } from "@/utils/dateTime";
import VideoPlayer from "./VideoPlayer.vue";
import ChatComponent from "./ChatComponent.vue";
import View512 from "./View512";
import View612 from "./View612";
import View632 from "./View632";
import X1152 from "./X1152";
import X272 from "./X272";
import View702 from "./View702";
import X533 from "./X533";
import X6 from "./X6";
import View712 from "./View712";
import View722 from "./View722";
import View692 from "./View692";
import Writing from "./Writing";
import X282 from "./X282";
import Task from "./Task";
import Drawing from "./Drawing";
import Sidebar_Screen8 from "./Sidebar_Screen8";
import TestRunner from "@/views/teacher/TeacherDashboard/DivWrapperScreen/test-creation/TestRunner.vue";
import CollapsibleArticle from "@/components/common/CollapsibleArticle.vue";
import ModuleLoadError from "@/components/common/ModuleLoadError.vue";
import { isBitrix24Mode } from "@/utils/bitrixInternalNavigation";
import {
  isBitrixLaunchableMediaUrl,
  openBitrixVideoSlider,
} from "@/utils/bitrixVideoSlider";

// Импортируем DOMPurify для безопасной санитизации HTML
import DOMPurify from "dompurify";
import "ckeditor5/ckeditor5-content.css";

// Константы для размеров блоков
import { BLOCK_DIMENSIONS } from "@/constants/layout";

// Функция debounce для оптимизации частых вызовов
const debounce = (fn, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
};

export default {
  name: "Screen8",
  components: {
    VideoPlayer,
    ChatComponent,
    View512,
    View612,
    View632,
    X1152,
    X272,
    View702,
    X533,
    X6,
    View712,
    View722,
    View692,
    Writing,
    X282,
    Task,
    Drawing,
    TestRunner,
    Sidebar_Screen8,
    CollapsibleArticle,
    ModuleLoadError,
  },
  props: {
    image1: String,
    text_Label1: String,
    text_Label2: String,
    x4: String,
    image12: String,
    x1: String,
    text376: String,
    text378: String,
    text377: String,
    x011: String,
    x012: String,
    view2: String,
    text379: String,
    text380: String,
    x013: String,
    view3: String,
    image2: String,
    text409: String,
    x014: String,
    image3: String,
    text395: String,
    x015: String,
    image4: String,
    text394: String,
    x016: String,
    image5: String,
    text393: String,
    x017: String,
    text396: String,
    text397: String,
    image6: String,
    text390: String,
    x018: String,
    text391: String,
    text392: String,
    image7: String,
    text385: String,
    x019: String,
    image8: String,
    text384: String,
    x0110: String,
    image9: String,
    text383: String,
    x0111: String,
    text386: String,
    text387: String,
    text415: String,
    text416: String,
    view612Props: {
      type: Object,
      default: () => ({}),
    },
    view632Props: {
      type: Object,
      default: () => ({}),
    },
    x1152Props: {
      type: Object,
      default: () => ({}),
    },
    x272Props: {
      type: Object,
      default: () => ({}),
    },
    view702Props: {
      type: Object,
      default: () => ({}),
    },
    x5331Props: {
      type: Object,
      default: () => ({}),
    },
    x61Props: {
      type: Object,
      default: () => ({}),
    },
    x5332Props: {
      type: Object,
      default: () => ({}),
    },
    x62Props: {
      type: Object,
      default: () => ({}),
    },
    x63Props: {
      type: Object,
      default: () => ({}),
    },
    x5333Props: {
      type: Object,
      default: () => ({}),
    },
    view712Props: {
      type: Object,
      default: () => ({}),
    },
    writingProps: {
      type: Object,
      default: () => ({}),
    },
    x2821Props: {
      type: Object,
      default: () => ({}),
    },
    x2822Props: {
      type: Object,
      default: () => ({}),
    },
    taskProps: {
      type: Object,
      default: () => ({}),
    },
    drawingProps: {
      type: Object,
      default: () => ({}),
    },
    view722Props: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    // Инициализация сворачиваемых блоков
    const lessonsBlock = useCollapsible(true);
    const practiceBlock = useCollapsible(true);
    const testsBlock = useCollapsible(true);
    const homeworkBlock = useCollapsible(true);
    const sidebarHeight = ref(0);
    const isSidebarOpen = ref(false);
    const _keepBodyScrollLocked = ref(false);

    const isMobileViewport = () =>
      typeof window !== "undefined" && window.innerWidth <= 768;

    const toggleSidebar = () => {
      isSidebarOpen.value = !isSidebarOpen.value;
      if (typeof document !== "undefined") {
        const overflowValue = isSidebarOpen.value ? "hidden" : "";
        document.body.style.overflow = overflowValue;
        document.documentElement.style.overflow = overflowValue;
      }
    };

    const closeSidebar = () => {
      isSidebarOpen.value = false;
      if (typeof document !== "undefined") {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    };

    const route = useRoute();
    const router = useRouter();
    const appStore = useAppStore();
    const MODULE_AUTO_REFRESH_INTERVAL_MS = 30000;
    const moduleData = ref(null);
    const moduleProgressFromServer = ref(null);
    const isLoading = ref(false);
    const isRefreshing = ref(false);
    const loadError = ref(null);
    const now = ref(new Date());
    let nowIntervalId = null;
    let loadRequestId = 0;
    let progressRequestId = 0;
    let homeworkSubmissionRequestId = 0;
    let refreshRequestId = 0;
    let moduleAutoRefreshTimerId = null;

    const normalizePercent = (value) => {
      const parsed = Number(value);
      if (!Number.isFinite(parsed)) return null;
      return Math.max(0, Math.min(100, parsed));
    };

    // Новые ref'ы для улучшенной функциональности
    const isUnmounted = ref(false);
    const videoCurrentTime = ref(0);
    const videoDuration = ref(0);
    const watchTimerId = ref(null);
    const lastWatchAt = ref(null);
    const isVideoPlaying = ref(false);
    const trackedLessonId = ref(null);
    const trackedLessonIsVideo = ref(false);
    const tabTimerId = ref(null);
    const tabLastActiveAt = ref(null);
    const tabTrackingType = ref(null);
    const tabTrackingId = ref(null);
    const tabTrackingMode = ref(null);
    const completionError = ref(null);
    const isBitrixMode = ref(false);
    const isBitrixYoutubeFullscreen = ref(false);
    let previousBitrixHtmlOverflow = "";
    let previousBitrixBodyOverflow = "";
    let previousBitrixWindowScrollX = 0;
    let previousBitrixWindowScrollY = 0;
    let previousBitrixScrollableState = [];
    let bitrixExitScrollGuardRafId = null;
    let bitrixExitScrollGuardTimerId = null;

    const currentUser = computed(() => {
      const userRef = appStore.currentUser ?? appStore.user ?? null;
      return userRef?.value || userRef;
    });
    const practiceCompletionUserKey = computed(() => {
      const user = currentUser.value;
      const rawId =
        user?.id ??
        user?._id ??
        user?.userId ??
        user?.email ??
        user?.login ??
        null;
      return rawId ? String(rawId) : null;
    });
    const moduleId = computed(() => {
      const raw = route.query.moduleId;
      if (raw === undefined || raw === null || raw === "") {
        return null;
      }
      const parsed = Number(raw);
      return Number.isNaN(parsed) ? raw : parsed;
    });

    // Параметры для автоматического выбора ДЗ при переходе с главной
    const homeworkIdFromQuery = computed(() => {
      const raw = route.query.homeworkId;
      if (raw === undefined || raw === null || raw === "") return null;
      const parsed = Number(raw);
      return Number.isNaN(parsed) ? raw : parsed;
    });

    const sectionFromQuery = computed(() => route.query.section || null);

    const scrollPageToTop = () => {
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
      if (typeof document === "undefined") return;
      document.documentElement.scrollTop = 0;
      if (document.body) {
        document.body.scrollTop = 0;
      }
      const scrollContainers = document.querySelectorAll(
        ".u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074, .x-39, .view-414, .screen8-container"
      );
      scrollContainers.forEach((container) => {
        container.scrollTop = 0;
      });
    };

    const scheduleScrollPageToTop = () => {
      nextTick(() => {
        scrollPageToTop();
      });
    };

    const applyBitrixVideoFullscreenDocumentState = (active) => {
      if (typeof document === "undefined") return;

      const html = document.documentElement;
      const body = document.body;
      if (!html || !body) return;

      if (active) {
        previousBitrixHtmlOverflow = html.style.overflow;
        previousBitrixBodyOverflow = body.style.overflow;
        html.style.overflow = "hidden";
        body.style.overflow = "hidden";
        return;
      }

      html.style.overflow = previousBitrixHtmlOverflow;
      body.style.overflow = previousBitrixBodyOverflow;
    };

    const closeBitrixYoutubeFullscreen = () => {
      if (!isBitrixYoutubeFullscreen.value) return;
      isBitrixYoutubeFullscreen.value = false;
      applyBitrixVideoFullscreenDocumentState(false);
    };

    const toggleBitrixYoutubeFullscreen = () => {
      if (!isBitrixMode.value || !isYouTubeVideo.value) return;
      openCurrentVideoInBitrixSlider();
    };

    const handleBitrixVideoKeydown = (event) => {
      if (event.key === "Escape") {
        closeBitrixYoutubeFullscreen();
      }
    };

    const getBitrixScrollableElements = () => {
      if (typeof document === "undefined") return [];

      const selectors = [
        "#app",
        ".x-39",
        ".view-414",
        ".video-content-wrapper",
        ".article-content-wrapper",
        ".article-content-body-shell",
        ".u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074",
      ];

      const elements = selectors.flatMap((selector) =>
        Array.from(document.querySelectorAll(selector))
      );
      const uniqueElements = Array.from(new Set(elements));

      return uniqueElements.filter((element) => {
        if (!element) return false;
        return (
          element.scrollHeight > element.clientHeight ||
          element.scrollWidth > element.clientWidth
        );
      });
    };

    const restoreBitrixScrollableView = () => {
      if (typeof document === "undefined") return;

      const html = document.documentElement;
      const body = document.body;
      const appRoot = document.getElementById("app");

      if (html) {
        html.style.overflow = "hidden";
      }
      if (body) {
        body.style.overflow = "hidden";
      }
      if (appRoot) {
        appRoot.style.overflow = "auto";
        appRoot.style.height = "100%";
      }

      previousBitrixScrollableState.forEach(({ element, top, left }) => {
        if (!element || !element.isConnected) return;

        if (typeof element.scrollTo === "function") {
          element.scrollTo({
            top,
            left,
            behavior: "auto",
          });
          return;
        }

        element.scrollTop = top;
        element.scrollLeft = left;
      });

      window.scrollTo({
        top: previousBitrixWindowScrollY,
        left: previousBitrixWindowScrollX,
        behavior: "auto",
      });
      window.dispatchEvent(new Event("resize"));
    };

    const captureBitrixScrollableView = () => {
      if (typeof document === "undefined") return;

      previousBitrixWindowScrollX = window.scrollX || 0;
      previousBitrixWindowScrollY = window.scrollY || 0;
      previousBitrixScrollableState = getBitrixScrollableElements().map((element) => ({
        element,
        top: element.scrollTop || 0,
        left: element.scrollLeft || 0,
      }));
    };

    const clearBitrixExitScrollGuard = () => {
      if (typeof window === "undefined") return;

      if (bitrixExitScrollGuardRafId) {
        window.cancelAnimationFrame(bitrixExitScrollGuardRafId);
        bitrixExitScrollGuardRafId = null;
      }

      if (bitrixExitScrollGuardTimerId) {
        window.clearTimeout(bitrixExitScrollGuardTimerId);
        bitrixExitScrollGuardTimerId = null;
      }
    };

    const runBitrixExitScrollGuard = (deadline) => {
      restoreBitrixScrollableView();
      if (Date.now() >= deadline || typeof window === "undefined") {
        clearBitrixExitScrollGuard();
        return;
      }

      bitrixExitScrollGuardRafId = window.requestAnimationFrame(() => {
        runBitrixExitScrollGuard(deadline);
      });
    };

    const scheduleBitrixScrollRestore = () => {
      if (typeof window === "undefined") return;

      clearBitrixExitScrollGuard();
      const deadline = Date.now() + 1000;
      runBitrixExitScrollGuard(deadline);
      bitrixExitScrollGuardTimerId = window.setTimeout(() => {
        clearBitrixExitScrollGuard();
      }, 1120);
    };

    const openBitrixMediaInSlider = (payload = {}) => {
      if (!isBitrixMode.value) return false;

      const mediaUrl = payload.url || payload.src || "";
      if (!mediaUrl) return false;

      captureBitrixScrollableView();

      return openBitrixVideoSlider(
        router,
        {
          url: mediaUrl,
          title: payload.title || selectedLessonTitle.value || "Видео",
          poster: payload.poster || view2.value || "",
        },
        {
          title: payload.title || selectedLessonTitle.value || "Видео",
          leftBoundary: 0,
          closeCallback: scheduleBitrixScrollRestore,
        }
      );
    };

    const openCurrentVideoInBitrixSlider = () => {
      const mediaUrl = isYouTubeVideo.value
        ? videoCandidateUrl.value || youtubeEmbedUrl.value
        : videoSource.value;

      return openBitrixMediaInSlider({
        url: mediaUrl,
        title: selectedLessonTitle.value || "Видео",
        poster: view2.value || "",
      });
    };

    const handleRichMediaLinkClick = (event) => {
      if (!isBitrixMode.value) return;

      const link = event.target?.closest?.("a[href]");
      if (!link) return;

      const href = link.getAttribute("href") || "";
      if (!isBitrixLaunchableMediaUrl(href)) return;

      event.preventDefault();
      event.stopPropagation();
      openBitrixMediaInSlider({
        url: href,
        title: link.textContent?.trim() || selectedLessonTitle.value || "Видео",
      });
    };

    const PRACTICE_COMPLETION_STORAGE_PREFIX = "screen8_practice_completed";
    const practiceCompletedLocalIds = ref(new Set());

    const normalizeStorageId = (value) => {
      if (value === null || value === undefined) return null;
      return String(value);
    };

    const getPracticeCompletionStorageKey = () => {
      if (!moduleId.value || !practiceCompletionUserKey.value) return null;
      return `${PRACTICE_COMPLETION_STORAGE_PREFIX}_${practiceCompletionUserKey.value}_${moduleId.value}`;
    };

    const getPracticeIdForStorage = (item) =>
      item?.id ?? item?._id ?? item?.task_id ?? item?.practical_id ?? null;

    const loadPracticeCompletionFromStorage = () => {
      if (typeof window === "undefined") {
        practiceCompletedLocalIds.value = new Set();
        return;
      }
      const key = getPracticeCompletionStorageKey();
      if (!key) {
        practiceCompletedLocalIds.value = new Set();
        return;
      }
      try {
        const raw = window.localStorage.getItem(key);
        if (!raw) {
          practiceCompletedLocalIds.value = new Set();
          return;
        }
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          practiceCompletedLocalIds.value = new Set(
            parsed.map((item) => normalizeStorageId(item)).filter(Boolean)
          );
          return;
        }
      } catch (error) {
        console.warn("Failed to read practice completion from storage:", error);
      }
      practiceCompletedLocalIds.value = new Set();
    };

    const savePracticeCompletionToStorage = (taskId) => {
      if (typeof window === "undefined") return;
      const key = getPracticeCompletionStorageKey();
      const normalized = normalizeStorageId(taskId);
      if (!key || !normalized) return;
      const next = new Set(practiceCompletedLocalIds.value);
      next.add(normalized);
      practiceCompletedLocalIds.value = next;
      try {
        window.localStorage.setItem(key, JSON.stringify(Array.from(next)));
      } catch (error) {
        console.warn("Failed to write practice completion to storage:", error);
      }
    };

    const applyPracticeCompletionToModule = (data) => {
      if (!data || !Array.isArray(data.practice) || !data.practice.length)
        return data;
      if (!practiceCompletedLocalIds.value.size) return data;
      const updatedPractice = data.practice.map((item) => {
        const id = normalizeStorageId(getPracticeIdForStorage(item));
        if (!id || !practiceCompletedLocalIds.value.has(id)) return item;
        return {
          ...item,
          is_completed: true,
          isCompleted: true,
          completed: true,
          status: "completed",
          completion_percent: 100,
        };
      });
      return { ...data, practice: updatedPractice };
    };

    const backRoute = computed(() => {
      const from = route.query.from;
      const courseId = route.query.courseId;

      if (from === "course-page" && courseId) {
        return { name: "StudentCoursePage", params: { id: courseId } };
      }
      if (from === "modules") {
        return { path: "/student-dashboard", hash: "#modules" };
      }
      return { path: "/student-dashboard" };
    });

    const loadModule = async (options = {}) => {
      const { background = false } = options;
      const requestId = ++loadRequestId;
      if (!moduleId.value) {
        if (requestId !== loadRequestId || isUnmounted.value) return;
        moduleData.value = null;
        isLoading.value = false;
        loadError.value = null;
        return;
      }
      if (!background) {
        isLoading.value = true;
      }
      loadError.value = null;
      try {
        const data = await modulesService.getModuleWithElements(moduleId.value);
        if (requestId !== loadRequestId || isUnmounted.value) return;
        moduleData.value = applyPracticeCompletionToModule(data);
      } catch (error) {
        if (requestId !== loadRequestId || isUnmounted.value) return;
        console.warn("Ошибка загрузки модуля для Screen8:", error);
        moduleData.value = null;
        loadError.value = error;
      } finally {
        if (requestId === loadRequestId && !isUnmounted.value && !background) {
          isLoading.value = false;
        }
      }
    };

    const loadModuleProgress = async () => {
      const requestId = ++progressRequestId;
      if (!moduleId.value || !progressService?.getModuleProgress) {
        moduleProgressFromServer.value = null;
        return;
      }
      try {
        const progress = await progressService.getModuleProgress(
          moduleId.value
        );
        if (requestId !== progressRequestId || isUnmounted.value) return;
        const percent = normalizePercent(
          progress?.progress_percent ??
            progress?.completion_percent ??
            progress?.percentage ??
            progress?.progress
        );
        moduleProgressFromServer.value = percent;
      } catch (error) {
        if (requestId !== progressRequestId || isUnmounted.value) return;
        console.warn("Failed to load module progress:", error);
        moduleProgressFromServer.value = null;
      }
    };

    const refreshModuleData = async (options = {}) => {
      const { background = false } = options;
      const requestId = ++refreshRequestId;
      if (!background) {
        isRefreshing.value = true;
      }
      loadPracticeCompletionFromStorage();
      await loadModuleProgress();
      await loadModule({ background });
      if (requestId === refreshRequestId && !background) {
        isRefreshing.value = false;
      }
    };

    const runAutoModuleRefresh = () => {
      if (isUnmounted.value) return;
      if (!moduleId.value) return;
      if (typeof document !== "undefined" && document.visibilityState !== "visible") {
        return;
      }
      if (isLoading.value || isRefreshing.value) return;
      refreshModuleData({ background: true });
    };

    const handleVisibilityChange = () => {
      if (typeof document === "undefined") return;
      if (document.visibilityState === "visible") {
        runAutoModuleRefresh();
      }
    };

    const handleWindowFocus = () => {
      runAutoModuleRefresh();
    };

    const startModuleAutoRefresh = () => {
      if (typeof window === "undefined") return;
      if (moduleAutoRefreshTimerId) {
        window.clearInterval(moduleAutoRefreshTimerId);
      }
      moduleAutoRefreshTimerId = window.setInterval(() => {
        runAutoModuleRefresh();
      }, MODULE_AUTO_REFRESH_INTERVAL_MS);
    };

    const stopModuleAutoRefresh = () => {
      if (typeof window === "undefined") return;
      if (moduleAutoRefreshTimerId) {
        window.clearInterval(moduleAutoRefreshTimerId);
        moduleAutoRefreshTimerId = null;
      }
    };

    onMounted(() => {
      if (typeof window === "undefined") return;
      isBitrixMode.value = isBitrix24Mode();
      scrollPageToTop();
      if (typeof document !== "undefined") {
        document.addEventListener("visibilitychange", handleVisibilityChange);
        document.addEventListener("keydown", handleBitrixVideoKeydown);
      }
      window.addEventListener("focus", handleWindowFocus);
      window.addEventListener("resize", scheduleArticleNavIndicatorBoundsUpdate);
      window.addEventListener("scroll", scheduleArticleNavIndicatorBoundsUpdate, {
        passive: true,
      });
      nowIntervalId = window.setInterval(() => {
        now.value = new Date();
      }, 60000);
      startModuleAutoRefresh();
      nextTick(() => {
        reconnectArticleNavIndicatorObserver();
        scheduleArticleNavIndicatorBoundsUpdate();
      });
    });

    onBeforeUnmount(() => {
      isUnmounted.value = true;
      closeBitrixYoutubeFullscreen();
      stopWatchTimer({ flush: true });
      stopTabTimer({ flush: true });
      if (articleTocCloseTimer.value) {
        clearTimeout(articleTocCloseTimer.value);
        articleTocCloseTimer.value = null;
      }
      if (nowIntervalId) {
        window.clearInterval(nowIntervalId);
        nowIntervalId = null;
      }
      stopModuleAutoRefresh();
      if (typeof window !== "undefined") {
        window.removeEventListener("focus", handleWindowFocus);
        window.removeEventListener("resize", scheduleArticleNavIndicatorBoundsUpdate);
        window.removeEventListener("scroll", scheduleArticleNavIndicatorBoundsUpdate);
      }
      cancelArticleNavIndicatorBoundsUpdate();
      if (articleNavIndicatorResizeObserver) {
        articleNavIndicatorResizeObserver.disconnect();
        articleNavIndicatorResizeObserver = null;
      }
      if (typeof document !== "undefined") {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        document.removeEventListener("keydown", handleBitrixVideoKeydown);
      }
      if (typeof document !== "undefined") {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      }
    });

    watch(
      [moduleId, practiceCompletionUserKey],
      () => {
        refreshModuleData();
      },
      { immediate: true }
    );

    const moduleLessons = computed(() => moduleData.value?.lessons || []);
    const moduleTests = computed(() => moduleData.value?.tests || []);
    const modulePractice = computed(() => moduleData.value?.practice || []);
    const moduleHomework = computed(() => moduleData.value?.homework || []);

    // Проверка на полное отсутствие данных модуля
    const hasNoModuleData = computed(() => {
      if (isLoading.value || loadError.value) return false;
      return (
        moduleLessons.value.length === 0 &&
        moduleTests.value.length === 0 &&
        modulePractice.value.length === 0 &&
        moduleHomework.value.length === 0
      );
    });

    const normalizeBoolean = (value) => {
      if (value === null || value === undefined) return null;
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value !== 0;
      if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (["true", "1", "yes", "y", "да"].includes(normalized)) return true;
        if (["false", "0", "no", "n", "нет"].includes(normalized)) return false;
      }
      return Boolean(value);
    };

    const isItemCompleted = (item) => {
      if (!item) return false;
      if (item?.is_completed !== undefined)
        return normalizeBoolean(item.is_completed) === true;
      if (item?.isCompleted !== undefined)
        return normalizeBoolean(item.isCompleted) === true;
      if (item?.completed !== undefined)
        return normalizeBoolean(item.completed) === true;
      if (item?.status) return item.status === "completed";
      if (item?.completion_percent !== undefined) {
        return Number(item.completion_percent) >= 100;
      }
      return false;
    };

    // Вычисляемое свойство для прогресса модуля
    const moduleProgress = computed(() => {
      const localTotal =
        (moduleLessons.value.length || 0) +
        (modulePractice.value.length || 0) +
        (moduleTests.value.length || 0) +
        (moduleHomework.value.length || 0);
      const localCompleted = [
        ...moduleLessons.value.filter(isItemCompleted),
        ...modulePractice.value.filter(isItemCompleted),
        ...moduleTests.value.filter(isItemCompleted),
        ...moduleHomework.value.filter(isItemCompleted),
      ].length;
      const localValue =
        localTotal > 0 ? (localCompleted / localTotal) * 100 : 0;
      const serverValue = moduleProgressFromServer.value;
      if (serverValue !== null && serverValue !== undefined) {
        return Math.max(serverValue, localValue);
      }
      return localValue;
    });

    const parseCompletionPolicy = (rawPolicy) => {
      if (!rawPolicy) return null;
      if (typeof rawPolicy === "string") {
        try {
          return JSON.parse(rawPolicy);
        } catch (error) {
          return null;
        }
      }
      if (typeof rawPolicy === "object") return rawPolicy;
      return null;
    };

    const completionPolicy = computed(() =>
      parseCompletionPolicy(
        moduleData.value?.completion_policy ??
          moduleData.value?.completionPolicy ??
          null
      )
    );

    const finalTestId = computed(() => {
      const raw =
        completionPolicy.value?.final_test_id ??
        completionPolicy.value?.finalTestId ??
        null;
      const numeric = Number(raw);
      return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
    });

    const finalTestCapPercent = computed(() => {
      const raw =
        completionPolicy.value?.cap_percent ??
        completionPolicy.value?.capPercent ??
        95;
      const numeric = Number(raw);
      if (!Number.isFinite(numeric)) return 95;
      return Math.min(Math.max(Math.round(numeric), 0), 100);
    });

    const finalTestAccess = computed(
      () =>
        moduleData.value?.final_test_access ??
        moduleData.value?.finalTestAccess ??
        null
    );
    const finalTestAccessAllowedByRules = computed(() => {
      if (!finalTestId.value) return true;
      const access = finalTestAccess.value;
      if (!access) return true;
      return access.allowed !== false;
    });
    const finalTestAccessRequirements = computed(
      () => finalTestAccess.value?.requirements ?? null
    );
    const finalTestWindowStart = computed(() => {
      const raw =
        finalTestAccess.value?.start_at ?? finalTestAccess.value?.startAt;
      if (!raw) return null;
      const parsed = new Date(raw);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    });
    const finalTestWindowEnd = computed(() => {
      const raw = finalTestAccess.value?.end_at ?? finalTestAccess.value?.endAt;
      if (!raw) return null;
      const parsed = new Date(raw);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    });
    const finalTestWindowStatus = computed(() => {
      if (!finalTestWindowStart.value || !finalTestWindowEnd.value) return null;
      const nowValue = now.value ? new Date(now.value) : new Date();
      if (nowValue < finalTestWindowStart.value) return "upcoming";
      if (nowValue > finalTestWindowEnd.value) return "expired";
      return "active";
    });
    const finalTestMissingItems = computed(() => {
      const requirements = finalTestAccessRequirements.value;
      if (!requirements) return [];
      const labels = {
        lessons: "Уроки",
        practice: "Практики",
        homework: "Домашние задания",
        tests: "Тесты",
      };
      return Object.entries(requirements)
        .filter(([, entry]) => entry?.required && entry.completed < entry.total)
        .map(([key, entry]) => ({
          key,
          label: labels[key] || key,
          completed: entry.completed ?? 0,
          total: entry.total ?? 0,
        }));
    });
    const showFinalTestCapHint = computed(() => {
      if (!finalTestId.value) return false;
      if (finalTestCapPercent.value >= 100) return false;
      return (
        moduleProgress.value >= finalTestCapPercent.value &&
        Math.round(moduleProgress.value) < 100
      );
    });

    const moduleProgressStorageKey = computed(() =>
      moduleId.value ? `screen8:module-progress:${moduleId.value}` : null
    );

    const saveModuleProgressToStorage = (value) => {
      try {
        if (typeof window === "undefined" || !window.localStorage) return;
        const key = moduleProgressStorageKey.value;
        if (!key) return;
        const percent = Math.round(
          Math.min(Math.max(Number(value) || 0, 0), 100)
        );
        localStorage.setItem(
          key,
          JSON.stringify({
            progress: percent,
            updatedAt: new Date().toISOString(),
          })
        );
      } catch (error) {
        console.warn("Failed to store module progress:", error);
      }
    };

    watch(
      moduleProgress,
      (value) => {
        saveModuleProgressToStorage(value);
      },
      { immediate: true }
    );

    // Вычисляемое свойство для прогресса видео
    const videoProgress = computed(() => {
      if (videoDuration.value <= 0) return 0;
      return (videoCurrentTime.value / videoDuration.value) * 100;
    });

    const moduleTitle = computed(() => {
      const baseTitle =
        moduleData.value?.title ||
        moduleData.value?.name ||
        "";
      if (baseTitle) return String(baseTitle).trim();
      if (isLoading.value) return "Загрузка модуля...";
      if (loadError.value) return "Модуль недоступен";
      return "Модуль";
    });
    const moduleSubtitle = computed(() => moduleData.value?.subtitle || "");

    const getItemTitle = (item, fallback = "") =>
      item?.title || item?.name || fallback;

    const getDurationMinutes = (item) =>
      item?.duration_minutes ??
      item?.duration ??
      item?.time_limit_minutes ??
      null;

    const getLessonKey = (lesson, index) =>
      lesson?.id ?? lesson?._id ?? lesson?.lesson_id ?? index;

    const getLessonId = (lesson) =>
      lesson?.id ?? lesson?._id ?? lesson?.lesson_id ?? null;

    const getLessonType = (lesson) =>
      lesson?.lesson_type ||
      lesson?.type ||
      (lesson?.video_url || lesson?.videoUrl || lesson?.video_file_url
        ? "video"
        : "article");

    const isLessonCompleted = (lesson) => {
      if (!lesson) return false;
      if (lesson?.is_completed !== undefined)
        return normalizeBoolean(lesson.is_completed) === true;
      if (lesson?.isCompleted !== undefined)
        return normalizeBoolean(lesson.isCompleted) === true;
      if (lesson?.completed !== undefined)
        return normalizeBoolean(lesson.completed) === true;
      if (lesson?.status) return lesson.status === "completed";
      return false;
    };

    const isLessonVideo = (lesson) => getLessonType(lesson) === "video";
    const isLessonArticle = (lesson) => getLessonType(lesson) === "article";

    const getLessonOrder = (lesson) =>
      lesson?.order ??
      lesson?.order_number ??
      lesson?.position ??
      lesson?.sort_order ??
      lesson?.sortOrder ??
      lesson?.index ??
      null;

    const sortedLessons = computed(() => {
      const lessons = moduleLessons.value.slice();
      const hasOrder = lessons.some(
        (item) =>
          getLessonOrder(item) !== null && getLessonOrder(item) !== undefined
      );
      if (!hasOrder) return lessons;
      return lessons.sort((a, b) => {
        const orderA = getLessonOrder(a) ?? 0;
        const orderB = getLessonOrder(b) ?? 0;
        return orderA - orderB;
      });
    });

    const firstIncompleteIndex = computed(() =>
      sortedLessons.value.findIndex((lesson) => !isLessonCompleted(lesson))
    );

    const selectedLessonKey = ref(null);
    const selectedLesson = computed(() => {
      if (!sortedLessons.value.length) return null;
      const found = sortedLessons.value.find(
        (lesson, index) =>
          getLessonKey(lesson, index) === selectedLessonKey.value
      );
      return found || sortedLessons.value[0];
    });

    // Вычисляемое свойство для следующего урока
    const nextLesson = computed(() => {
      if (!sortedLessons.value.length) return null;
      const currentIndex = sortedLessons.value.findIndex(
        (lesson) => getLessonKey(lesson, 0) === selectedLessonKey.value
      );
      return sortedLessons.value[currentIndex + 1] || null;
    });

    const isLessonSelected = (lesson, index) => {
      if (contentMode.value !== "video" && contentMode.value !== "article") {
        return false;
      }
      return getLessonKey(lesson, index) === selectedLessonKey.value;
    };

    const selectedLessonTitle = computed(() =>
      getItemTitle(selectedLesson.value, props.x012 || props.x013 || "")
    );

    const videoDescription = computed(() => {
      const lesson = selectedLesson.value;
      return (
        lesson?.description ||
        lesson?.short_description ||
        lesson?.summary ||
        lesson?.text ||
        lesson?.video_description ||
        lesson?.videoDescription ||
        ""
      );
    });

    const articleContent = computed(() => {
      const lesson = selectedLesson.value;
      return (
        lesson?.article_content ||
        lesson?.articleContent ||
        lesson?.content ||
        lesson?.body ||
        ""
      );
    });

    // Санитизация HTML с использованием DOMPurify
    const sanitizeHtml = (html) => {
      if (!html || typeof html !== "string") return "";
      if (typeof document === "undefined") return html;

      return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
          "p",
          "br",
          "strong",
          "em",
          "u",
          "s",
          "del",
          "ins",
          "a",
          "ul",
          "ol",
          "li",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "blockquote",
          "code",
          "pre",
          "hr",
          "figure",
          "figcaption",
          "img",
          "video",
          "source",
          "iframe",
          "table",
          "caption",
          "thead",
          "tbody",
          "tfoot",
          "tr",
          "th",
          "td",
          "colgroup",
          "col",
          "div",
          "span",
          "label",
          "input",
          "b",
          "i",
          "small",
          "mark",
          "sub",
          "sup",
          "oembed",
        ],
        ALLOWED_ATTR: [
          "href",
          "target",
          "rel",
          "src",
          "srcset",
          "sizes",
          "alt",
          "title",
          "class",
          "id",
          "style",
          "width",
          "height",
          "poster",
          "preload",
          "playsinline",
          "controls",
          "allow",
          "allowfullscreen",
          "frameborder",
          "loading",
          "colspan",
          "rowspan",
          "type",
          "checked",
          "disabled",
          "value",
          "name",
          "url",
          "start",
          "reversed",
          "dir",
          "lang",
          "aria-label",
        ],
        ALLOW_DATA_ATTR: true,
        FORBID_TAGS: [
          "script",
          "style",
          "object",
          "embed",
          "link",
          "meta",
        ],
        FORBID_ATTR: ["on*"],
      });
    };

    const pickRichTextContent = (...values) => {
      const list = values.filter((value) => typeof value === "string" && value.trim());
      if (!list.length) return "";
      const withHtml = list.find((value) => /<[^>]+>/.test(value));
      return withHtml || list[0] || "";
    };

    const sanitizedArticleContent = computed(() =>
      sanitizeHtml(articleContent.value)
    );

    const hasArticleContent = computed(() => {
      const html = sanitizedArticleContent.value;
      if (!html) return false;

      // Статья может состоять только из картинки/таблицы/списка и т.д. (текста не будет).
      if (/<(img|table|ul|ol|blockquote|pre|hr|input|video|iframe|figure|oembed)\b/i.test(html)) {
        return true;
      }

      if (typeof document === "undefined") {
        const text = html
          .replace(/<[^>]*>/g, " ")
          .replace(/&nbsp;|&#160;/gi, " ")
          .replace(/\s+/g, " ")
          .trim();
        return text.length > 0;
      }

      const tmp = document.createElement("div");
      tmp.innerHTML = html;
      const text = (tmp.textContent || "").replace(/\u00A0/g, " ").trim();
      return text.length > 0;
    });

    const articleCollapsibleHeadings = ["h1", "h2", "h3", "h4"];

    const isArticleTocEnabled = computed(() => {
      const lesson = selectedLesson.value;
      const raw =
        lesson?.enable_toc ??
        lesson?.enableToc ??
        lesson?.settings?.enable_toc ??
        lesson?.settings?.enableToc;
      if (raw === undefined || raw === null || raw === "") return true;
      return normalizeBoolean(raw) === true;
    });

    const articleTocMode = computed(() => {
      const lesson = selectedLesson.value;
      return (
        lesson?.toc_mode ||
        lesson?.tocMode ||
        lesson?.settings?.toc_mode ||
        lesson?.settings?.tocMode ||
        "auto"
      );
    });

    const articleTocItems = computed(() => {
      const html = sanitizedArticleContent.value;
      if (!hasArticleContent.value || !html || typeof document === "undefined") {
        return [];
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const headings = Array.from(doc.querySelectorAll("h1, h2, h3, h4"));
      const allowed =
        articleTocMode.value === "auto"
          ? new Set(["H1", "H2", "H3", "H4"])
          : new Set(["H1", "H2", "H3", "H4"]);
      let index = 0;
      const items = [];
      headings.forEach((heading) => {
        const text = String(heading.textContent || "")
          .replace(/\u00A0/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        const level = Number.parseInt(heading.tagName.slice(1), 10);
        const id = `collapsible-heading-${index}`;
        if (allowed.has(heading.tagName) && text) {
          items.push({ id, text, level });
        }
        index += 1;
      });
      if (items.length) return items;

      const fallbackItems = [];
      Array.from(doc.body.children).forEach((element, blockIndex) => {
        if (!(element instanceof HTMLElement)) return;
        if (!["P", "DIV"].includes(element.tagName)) return;
        const text = String(element.textContent || "")
          .replace(/\u00A0/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        if (!text || text.length < 8 || text.length > 120) return;
        const hasStrongText = Boolean(element.querySelector("strong, b"));
        const hasHeadingClass = /(heading|title|subtitle)/i.test(
          String(element.className || "")
        );
        const endsLikeSentence = /[.!?]$/.test(text);
        const looksLikeShortHeading = text.length <= 70 && !endsLikeSentence;
        if (!(hasStrongText || hasHeadingClass || looksLikeShortHeading)) return;
        fallbackItems.push({
          id: `fallback-block-${blockIndex}`,
          text,
          level: 2,
        });
      });
      return fallbackItems.slice(0, 30);
    });

    const scrollToArticleHeading = (id) => {
      if (typeof document === "undefined") return;
      const container = document.querySelector(".article-content-body");
      if (!container) return;
      const contentRoot =
        container.querySelector(".collapsible-article > div") || container;
      let heading = container.querySelector(`[data-collapsible-id="${id}"]`);
      if (!heading && /^fallback-block-\d+$/.test(String(id))) {
        const blockIndex = Number.parseInt(
          String(id).replace("fallback-block-", ""),
          10
        );
        if (!Number.isNaN(blockIndex)) {
          heading = contentRoot.children?.[blockIndex] || null;
        }
      }
      if (!heading) return;
      heading.scrollIntoView({ behavior: "smooth", block: "start" });
      heading.classList.add("article-heading-highlight");
      setTimeout(
        () => heading.classList.remove("article-heading-highlight"),
        2000
      );
    };

    const isArticleTocOpen = ref(false);
    const articleTocCloseTimer = ref(null);
    const isArticleInlineTocExpanded = ref(false);
    const articleInlineTocCollapsedLimit = 3;
    const isArticleNavIndicatorVisible = ref(true);
    const articleContentBodyShellRef = ref(null);
    const articleContentNavHeadersRef = ref(null);
    let articleNavIndicatorResizeObserver = null;
    let articleNavIndicatorRafId = null;

    const hasArticleInlineTocOverflow = computed(
      () => articleTocItems.value.length > articleInlineTocCollapsedLimit
    );

    const articleInlineTocVisibleItems = computed(() => {
      if (isArticleInlineTocExpanded.value) return articleTocItems.value;
      return articleTocItems.value.slice(0, articleInlineTocCollapsedLimit);
    });

    const toggleArticleInlineToc = () => {
      isArticleInlineTocExpanded.value = !isArticleInlineTocExpanded.value;
    };

    const cancelArticleNavIndicatorBoundsUpdate = () => {
      if (typeof window === "undefined" || articleNavIndicatorRafId === null) return;
      window.cancelAnimationFrame(articleNavIndicatorRafId);
      articleNavIndicatorRafId = null;
    };

    const updateArticleNavIndicatorBounds = () => {
      articleNavIndicatorRafId = null;
      if (typeof window === "undefined") return;
      const shell = articleContentBodyShellRef.value;
      const headers = articleContentNavHeadersRef.value;
      if (!shell || !headers) {
        isArticleNavIndicatorVisible.value = true;
        return;
      }

      const shellRect = shell.getBoundingClientRect();
      const headersRect = headers.getBoundingClientRect();
      isArticleNavIndicatorVisible.value =
        shellRect.bottom - headersRect.bottom > 24;
    };

    const scheduleArticleNavIndicatorBoundsUpdate = () => {
      if (typeof window === "undefined") return;
      cancelArticleNavIndicatorBoundsUpdate();
      articleNavIndicatorRafId = window.requestAnimationFrame(
        updateArticleNavIndicatorBounds
      );
    };

    const reconnectArticleNavIndicatorObserver = () => {
      if (typeof ResizeObserver === "undefined") return;
      if (articleNavIndicatorResizeObserver) {
        articleNavIndicatorResizeObserver.disconnect();
      }
      const shell = articleContentBodyShellRef.value;
      const headers = articleContentNavHeadersRef.value;
      if (!shell || !headers) return;
      articleNavIndicatorResizeObserver = new ResizeObserver(() => {
        scheduleArticleNavIndicatorBoundsUpdate();
      });
      articleNavIndicatorResizeObserver.observe(shell);
    };

    const clearArticleTocCloseTimer = () => {
      if (!articleTocCloseTimer.value) return;
      clearTimeout(articleTocCloseTimer.value);
      articleTocCloseTimer.value = null;
    };

    const openArticleToc = () => {
      clearArticleTocCloseTimer();
      isArticleTocOpen.value = true;
    };

    const closeArticleToc = () => {
      clearArticleTocCloseTimer();
      isArticleTocOpen.value = false;
    };

    const scheduleCloseArticleToc = () => {
      clearArticleTocCloseTimer();
      articleTocCloseTimer.value = setTimeout(() => {
        isArticleTocOpen.value = false;
        articleTocCloseTimer.value = null;
      }, 180);
    };

    const handleArticleTocFocusOut = (event) => {
      const next = event?.relatedTarget;
      const current = event?.currentTarget;
      if (current && next && current.contains(next)) return;
      scheduleCloseArticleToc();
    };

    const onArticleTocItemClick = (id) => {
      scrollToArticleHeading(id);
      closeArticleToc();
    };

    watch(
      () => [
        hasArticleContent.value,
        sanitizedArticleContent.value,
        articleTocItems.value.length,
      ],
      () => {
        nextTick(() => {
          reconnectArticleNavIndicatorObserver();
          scheduleArticleNavIndicatorBoundsUpdate();
        });
      },
      { immediate: true }
    );

    const sanitizedVideoDescription = computed(() =>
      sanitizeHtml(videoDescription.value)
    );

    const lessonMainMaterials = computed(() => {
      const lesson = selectedLesson.value;
      if (!lesson) return [];
      const docMaterials = [];
      const docTitle =
        lesson?.doc_file_name ||
        lesson?.docFileName ||
        lesson?.document_name ||
        lesson?.documentName ||
        lesson?.docFile?.file_name ||
        lesson?.docFile?.name ||
        "";
      const docUrl =
        lesson?.doc_file_url ||
        lesson?.docFileUrl ||
        lesson?.doc_url ||
        lesson?.document_url ||
        lesson?.documentUrl;
      if (docUrl) {
        docMaterials.push({ url: docUrl, title: docTitle });
      }
      const docPath =
        lesson?.doc_file_path ||
        lesson?.docFilePath ||
        lesson?.document_path ||
        lesson?.documentPath;
      if (docPath) {
        docMaterials.push({ file_path: docPath, title: docTitle });
      }
      const items = collectMaterials(
        lesson?.materials,
        lesson?.materials_list,
        lesson?.materialsList,
        lesson?.files,
        lesson?.files_list,
        lesson?.filesList,
        lesson?.attachments,
        lesson?.resources,
        lesson?.documents,
        lesson?.docs,
        lesson?.docFile,
        lesson?.doc_file,
        lesson?.document,
        lesson?.file,
        docMaterials
      );
      return dedupeMaterials(items);
    });

    const lessonAdditionalMaterials = computed(() => {
      const lesson = selectedLesson.value;
      if (!lesson) return [];
      const items = collectMaterials(
        lesson?.additional_materials,
        lesson?.additionalMaterials,
        lesson?.extra_materials,
        lesson?.extraMaterials,
        lesson?.supplementary_files,
        lesson?.supplementaryFiles
      );
      return dedupeMaterials(items);
    });

    const hasLessonMaterials = computed(
      () =>
        lessonMainMaterials.value.length > 0 ||
        lessonAdditionalMaterials.value.length > 0
    );

    const isMainMaterialsDownloadDisabled = computed(() => {
      const lesson = selectedLesson.value;
      if (!lesson) return false;
      const raw =
        lesson?.disable_main_materials_download ??
        lesson?.disableMainMaterialsDownload ??
        lesson?.fullData?.disable_main_materials_download ??
        lesson?.fullData?.disableMainMaterialsDownload ??
        lesson?.settings?.disable_main_materials_download ??
        lesson?.settings?.disableMainMaterialsDownload;
      return normalizeBoolean(raw) === true;
    });

    const isAdditionalMaterialsDownloadDisabled = computed(() => {
      const lesson = selectedLesson.value;
      if (!lesson) return false;
      const raw =
        lesson?.disable_additional_materials_download ??
        lesson?.disableAdditionalMaterialsDownload ??
        lesson?.fullData?.disable_additional_materials_download ??
        lesson?.fullData?.disableAdditionalMaterialsDownload ??
        lesson?.settings?.disable_additional_materials_download ??
        lesson?.settings?.disableAdditionalMaterialsDownload;
      return normalizeBoolean(raw) === true;
    });

    const getLessonImage = (lesson) =>
      lesson?.cover_image ||
      lesson?.cover_image_url ||
      lesson?.preview_image ||
      lesson?.image ||
      props.image2 ||
      props.image1;

    const getLessonState = (lesson, index) => {
      if (isLessonCompleted(lesson)) return "completed";
      if (firstIncompleteIndex.value === -1) return "completed";
      if (index === firstIncompleteIndex.value) return "current";
      if (index > firstIncompleteIndex.value) return "locked";
      return "available";
    };

    const isLessonLocked = (lesson, index) =>
      getLessonState(lesson, index) === "locked";

    const getLessonCardClassName = (lesson, index, baseClasses = []) => {
      const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses];
      classes.push(
        isLessonCompleted(lesson)
          ? "lesson-card-active"
          : "lesson-card-inactive"
      );
      if (isLessonSelected(lesson, index)) {
        classes.push("lesson-card-selected");
      }
      if (isLessonLocked(lesson, index)) {
        classes.push("lesson-card-locked");
      }
      return classes.filter(Boolean).join(" ");
    };

    const getPracticeKey = (item, index) =>
      item?.id ?? item?._id ?? item?.task_id ?? item?.practical_id ?? index;

    const getPracticeId = (item) =>
      item?.id ?? item?._id ?? item?.task_id ?? item?.practical_id ?? null;

    const getPracticeOrder = (item) =>
      item?.order ??
      item?.order_number ??
      item?.position ??
      item?.sort_order ??
      item?.sortOrder ??
      item?.index ??
      null;

    const sortedPractice = computed(() => {
      const items = modulePractice.value.slice();
      const hasOrder = items.some(
        (item) =>
          getPracticeOrder(item) !== null &&
          getPracticeOrder(item) !== undefined
      );
      if (!hasOrder) return items;
      return items.sort((a, b) => {
        const orderA = getPracticeOrder(a) ?? 0;
        const orderB = getPracticeOrder(b) ?? 0;
        return orderA - orderB;
      });
    });

    const isPracticeCompleted = (item) => {
      if (!item) return false;
      if (item?.is_completed !== undefined)
        return normalizeBoolean(item.is_completed) === true;
      if (item?.isCompleted !== undefined)
        return normalizeBoolean(item.isCompleted) === true;
      if (item?.completed !== undefined)
        return normalizeBoolean(item.completed) === true;
      const status =
        item?.submission_status ??
        item?.submissionStatus ??
        item?.status ??
        null;
      if (status) return ["completed", "verified"].includes(status);
      const completionPercent =
        item?.completion_percent ??
        item?.completionPercent ??
        item?.progress_percent ??
        item?.progressPercent ??
        null;
      if (completionPercent !== undefined && completionPercent !== null) {
        return Number(completionPercent) >= 100;
      }
      return false;
    };

    const firstIncompletePracticeIndex = computed(() =>
      sortedPractice.value.findIndex((item) => !isPracticeCompleted(item))
    );

    const getPracticeState = (item, index) => {
      if (isPracticeCompleted(item)) return "completed";
      if (firstIncompletePracticeIndex.value === -1) return "completed";
      if (index === firstIncompletePracticeIndex.value) return "current";
      if (index > firstIncompletePracticeIndex.value) return "locked";
      return "available";
    };

    const isPracticeLocked = (item, index) =>
      getPracticeState(item, index) === "locked";

    const selectedPracticeKey = ref(null);

    const isPracticeSelected = (item, index) => {
      if (contentMode.value !== "practice") {
        return false;
      }
      return getPracticeKey(item, index) === selectedPracticeKey.value;
    };

    const getPracticeCardClassName = (item, index, baseClasses = []) => {
      const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses];
      const state = getPracticeState(item, index);
      if (state === "completed") {
        classes.push("practice-card-completed");
      } else if (state === "current") {
        classes.push("lesson-card-active");
      } else {
        classes.push("lesson-card-inactive");
      }
      if (isPracticeSelected(item, index)) {
        classes.push("lesson-card-selected");
      }
      if (isPracticeLocked(item, index)) {
        classes.push("lesson-card-locked");
      }
      return classes.filter(Boolean).join(" ");
    };

    const practiceFallbackImages = computed(() =>
      [props.image3, props.image4, props.image5].filter(Boolean)
    );

    const getPracticeImage = (item, index) =>
      item?.cover_image ||
      item?.cover_image_url ||
      item?.preview_image ||
      item?.image ||
      practiceFallbackImages.value[index] ||
      practiceFallbackImages.value[0] ||
      props.image3 ||
      props.image4 ||
      props.image5;

    const practiceIcons = computed(() =>
      [props.text395, props.text394, props.text393].filter(Boolean)
    );

    const getPracticeIcon = (index) =>
      practiceIcons.value[index] ||
      props.text395 ||
      props.text394 ||
      props.text393 ||
      "";

    const getPracticeTitle = (item, index) => {
      const fallback = [props.x015, props.x016, props.x017][index] || "";
      return getItemTitle(item, fallback);
    };

    const selectedPractice = computed(() => {
      if (!sortedPractice.value.length) return null;
      const found = sortedPractice.value.find(
        (item, index) =>
          getPracticeKey(item, index) === selectedPracticeKey.value
      );
      return found || sortedPractice.value[0];
    });

    // Вычисляемое свойство для следующей практики
    const nextPractice = computed(() => {
      if (!sortedPractice.value.length) return null;
      const currentIndex = sortedPractice.value.findIndex(
        (item) => getPracticeKey(item, 0) === selectedPracticeKey.value
      );
      return sortedPractice.value[currentIndex + 1] || null;
    });

    const selectedPracticeTitle = computed(() =>
      getItemTitle(
        selectedPractice.value,
        props.x015 || props.x016 || props.x017 || ""
      )
    );

    const practiceDescription = computed(() => {
      const item = selectedPractice.value;
      return pickRichTextContent(
        item?.content,
        item?.description,
        item?.task_description,
        item?.goal,
        ""
      );
    });

    const practiceInstructions = computed(() => {
      const item = selectedPractice.value;
      return item?.instructions || "";
    });

    const sanitizedPracticeDescription = computed(() =>
      sanitizeHtml(practiceDescription.value)
    );

    const sanitizedPracticeInstructions = computed(() =>
      sanitizeHtml(practiceInstructions.value)
    );

    const normalizeList = (value) => {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return [];
        if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
          try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) return parsed;
            if (parsed) return [parsed];
          } catch (error) {
            return [value];
          }
        }
        return [value];
      }
      return [value];
    };

    const extractFileName = (value) => {
      if (!value || typeof value !== "string") return "";
      const withoutQuery = value.split("?")[0].split("#")[0];
      const segments = withoutQuery.split("/");
      return segments[segments.length - 1] || "";
    };

    const looksLikeFileName = (value) => {
      if (!value || typeof value !== "string") return false;
      if (
        value.startsWith("http://") ||
        value.startsWith("https://") ||
        value.startsWith("/")
      ) {
        return true;
      }
      return /\.[a-z0-9]{2,6}($|\?|#)/i.test(value);
    };

    const normalizeFileUrl = (value) => {
      if (!value || typeof value !== "string") return "";
      const trimmed = value.trim();
      if (!trimmed) return "";
      if (
        trimmed.startsWith("http://") ||
        trimmed.startsWith("https://") ||
        trimmed.startsWith("/")
      ) {
        return trimmed;
      }
      if (trimmed.startsWith("uploads/") || trimmed.startsWith("storage/")) {
        return `/${trimmed}`;
      }
      return `/uploads/${trimmed}`;
    };

    const isYouTubeUrl = (url) => {
      if (!url || typeof url !== "string") return false;
      return url.includes("youtube.com") || url.includes("youtu.be");
    };

    const getYouTubeEmbedUrl = (url) => {
      if (!url || typeof url !== "string") return "";
      const match = url.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/
      );
      const videoId = match?.[1];
      return videoId
        ? `https://www.youtube-nocookie.com/embed/${videoId}?fs=1&rel=0`
        : url;
    };

    const getMaterialTitle = (item) => {
      if (!item) return "";
      if (typeof item === "string") return item;
      return (
        item?.title ||
        item?.name ||
        item?.file_name ||
        item?.fileName ||
        item?.original_name ||
        item?.originalName ||
        item?.filename ||
        item?.text ||
        item?.description ||
        item?.url ||
        item?.file_path ||
        item?.filePath ||
        ""
      );
    };

    const getMaterialLink = (item) => {
      if (!item) return "";
      if (typeof item === "string") {
        return looksLikeFileName(item) ? normalizeFileUrl(item) : "";
      }
      const url =
        item?.url ||
        item?.file_url ||
        item?.fileUrl ||
        item?.link ||
        item?.href ||
        item?.download_url ||
        item?.downloadUrl ||
        item?.path ||
        item?.file_path ||
        item?.filePath ||
        item?.storage_path ||
        item?.storagePath ||
        "";
      if (url) return normalizeFileUrl(url);
      const name =
        item?.file_name ||
        item?.fileName ||
        item?.original_name ||
        item?.originalName ||
        item?.filename ||
        item?.name ||
        item?.title ||
        "";
      if (looksLikeFileName(name)) return normalizeFileUrl(name);
      return "";
    };

    const getMaterialDownloadName = (item) => {
      if (!item) return "";
      if (typeof item === "string") {
        return extractFileName(item);
      }
      return (
        item?.file_name ||
        item?.fileName ||
        item?.original_name ||
        item?.originalName ||
        item?.filename ||
        extractFileName(
          item?.url ||
            item?.file_url ||
            item?.fileUrl ||
            item?.path ||
            item?.file_path ||
            item?.filePath ||
            ""
        )
      );
    };

    const getMaterialViewerRoute = (item, downloadDisabled = false) => {
      const url = getMaterialLink(item);
      if (!url) return null;
      return {
        name: "StudentDocumentViewer",
        query: {
          url,
          title: getMaterialTitle(item) || "",
          downloadDisabled: downloadDisabled ? "1" : undefined,
        },
      };
    };

    const collectMaterials = (...values) => {
      const items = [];
      values.forEach((value) => {
        const normalized = normalizeList(value);
        if (normalized.length) {
          items.push(...normalized);
        }
      });
      return items.filter(
        (item) => item !== null && item !== undefined && item !== ""
      );
    };

    const dedupeMaterials = (items) => {
      const seen = new Set();
      const result = [];
      items.forEach((item) => {
        if (!item) return;
        const title = getMaterialTitle(item);
        const link = getMaterialLink(item);
        if (!title && !link) return;
        const key = `${link}::${title}`.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        result.push(item);
      });
      return result;
    };

    const practiceSteps = computed(() => []);

    const practiceQuestions = computed(() =>
      normalizeList(selectedPractice.value?.questions)
    );

    const getPracticeTestId = (practice) =>
      practice?.test_id ??
      practice?.testId ??
      practice?.linked_test_id ??
      practice?.linkedTestId ??
      practice?.miniTest?.id ??
      practice?.mini_test?.id ??
      null;

    const buildPracticeTest = (practice) => {
      if (!practice) return null;
      const inlineTest =
        practice?.mini_test || practice?.miniTest || practice?.test || null;
      const practiceTestId = getPracticeTestId(practice);
      const normalizeId = (value) => {
        if (value === null || value === undefined) return null;
        const num = Number(value);
        return Number.isNaN(num) ? value : num;
      };
      const targetId = normalizeId(practiceTestId);
      let fromModule = null;
      if (targetId !== null) {
        fromModule = moduleTests.value.find((test) => {
          const id =
            test?.id ?? test?._id ?? test?.test_id ?? test?.testId ?? test?.id;
          return normalizeId(id) === targetId;
        });
      }
      if (!fromModule && !inlineTest) return null;
      const fallbackId =
        targetId ??
        inlineTest?.id ??
        `practice-test-${
          getPracticeId(practice) ?? getPracticeKey(practice, 0)
        }`;
      const merged = {
        ...(fromModule || {}),
        ...(inlineTest || {}),
      };
      if (!merged.id) merged.id = fallbackId;
      if (!merged.questions && inlineTest?.questions) {
        merged.questions = inlineTest.questions;
      }
      if (!merged.questions_count && Array.isArray(merged.questions)) {
        merged.questions_count = merged.questions.length;
      }
      return merged;
    };

    const practiceAttachedTest = computed(() =>
      buildPracticeTest(selectedPractice.value)
    );

    const practiceMaterials = computed(() => {
      const item = selectedPractice.value;
      if (!item) return [];
      const items = collectMaterials(
        item?.materials,
        item?.materials_list,
        item?.materialsList,
        item?.files,
        item?.files_list,
        item?.filesList,
        item?.attachments,
        item?.resources,
        item?.documents,
        item?.docs,
        item?.additional_materials,
        item?.additionalMaterials
      );
      return dedupeMaterials(items);
    });

    const getPracticeListText = (item) => {
      if (!item) return "";
      if (typeof item === "string") return item;
      return (
        item?.title ||
        item?.text ||
        item?.question ||
        item?.name ||
        item?.file_name ||
        item?.fileName ||
        item?.url ||
        item?.file_path ||
        ""
      );
    };

    const getPracticeMaterialLink = (item) => {
      return getMaterialLink(item);
    };

    const getTestKey = (test, index) =>
      test?.id ?? test?._id ?? test?.test_id ?? test?.testId ?? index;

    const getTestId = (test) =>
      test?.id ?? test?._id ?? test?.test_id ?? test?.testId ?? null;

    const isFinalTest = (test) => {
      if (!test || !finalTestId.value) return false;
      const id = getTestId(test);
      return id !== null && String(id) === String(finalTestId.value);
    };

    const isSelectedTestFinal = computed(() => {
      const test = selectedTestDetails.value || selectedTest.value;
      return isFinalTest(test);
    });

    const normalizeTestId = (id) =>
      id === null || id === undefined ? null : String(id);

    const getTestOrder = (test) =>
      test?.order ??
      test?.order_number ??
      test?.position ??
      test?.sort_order ??
      test?.sortOrder ??
      test?.index ??
      null;

    const getTestCreatedAtValue = (test) => {
      const raw =
        test?.created_at ??
        test?.createdAt ??
        test?.created ??
        test?.created_date ??
        test?.createdDate ??
        null;
      if (!raw) return null;
      const value = new Date(raw).getTime();
      return Number.isNaN(value) ? null : value;
    };

    const sortedTests = computed(() => {
      const items = moduleTests.value.map((item, index) => ({ item, index }));
      const hasOrder = items.some(
        (entry) =>
          getTestOrder(entry.item) !== null &&
          getTestOrder(entry.item) !== undefined
      );
      const hasCreatedAt = items.some(
        (entry) => getTestCreatedAtValue(entry.item) !== null
      );
      if (!hasOrder && !hasCreatedAt) return items.map((entry) => entry.item);
      return items
        .sort((a, b) => {
          if (hasOrder) {
            const orderA = getTestOrder(a.item);
            const orderB = getTestOrder(b.item);
            const normalizedA =
              orderA !== null && orderA !== undefined
                ? orderA
                : Number.POSITIVE_INFINITY;
            const normalizedB =
              orderB !== null && orderB !== undefined
                ? orderB
                : Number.POSITIVE_INFINITY;
            if (normalizedA !== normalizedB) return normalizedA - normalizedB;
          }
          if (hasCreatedAt) {
            const dateA = getTestCreatedAtValue(a.item);
            const dateB = getTestCreatedAtValue(b.item);
            const normalizedA =
              dateA !== null && dateA !== undefined
                ? dateA
                : Number.POSITIVE_INFINITY;
            const normalizedB =
              dateB !== null && dateB !== undefined
                ? dateB
                : Number.POSITIVE_INFINITY;
            if (normalizedA !== normalizedB) return normalizedA - normalizedB;
          }
          return a.index - b.index;
        })
        .map((entry) => entry.item);
    });

    const isTestCompleted = (test) => {
      if (!test) return false;
      if (test?.is_completed !== undefined)
        return normalizeBoolean(test.is_completed) === true;
      if (test?.isCompleted !== undefined)
        return normalizeBoolean(test.isCompleted) === true;
      if (test?.completed !== undefined)
        return normalizeBoolean(test.completed) === true;
      if (test?.passed !== undefined)
        return normalizeBoolean(test.passed) === true;
      if (test?.status) return test.status === "completed";
      if (test?.completion_percent !== undefined) {
        return Number(test.completion_percent) >= 100;
      }
      return false;
    };

    const selectedTestKey = ref(null);
    const testDetailsById = ref({});
    const testDetailsRequests = new Map();
    const selectedTest = computed(() => {
      if (!sortedTests.value.length) return null;
      const found = sortedTests.value.find(
        (test, index) => getTestKey(test, index) === selectedTestKey.value
      );
      return found || sortedTests.value[0];
    });

    const selectedTestDetails = computed(() => {
      const test = selectedTest.value;
      if (!test) return null;
      const rawId = getTestId(test);
      const id = normalizeTestId(rawId);
      return (id && testDetailsById.value[id]) || test;
    });

    const loadTestDetails = async (test) => {
      const rawId = getTestId(test);
      const id = normalizeTestId(rawId);
      console.log("[loadTestDetails] test id:", rawId, "test:", test);
      if (
        !rawId ||
        (typeof rawId === "string" &&
          String(rawId).startsWith("practice-test-"))
      )
        return;
      if (testDetailsById.value[id]) return;
      if (testDetailsRequests.has(id)) {
        return testDetailsRequests.get(id);
      }
      const request = testsService
        .getWithQuestions(rawId)
        .then((data) => {
          console.log("[loadTestDetails] API response:", data);
          console.log(
            "[loadTestDetails] questions:",
            data?.questions,
            data?.question_list,
            data?.questionList
          );
          if (!isUnmounted.value && data) {
            testDetailsById.value = { ...testDetailsById.value, [id]: data };
          }
          return data;
        })
        .catch((error) => {
          console.warn("Failed to load test details:", error);
          return null;
        })
        .finally(() => {
          testDetailsRequests.delete(id);
        });
      testDetailsRequests.set(id, request);
      try {
        return await request;
      } finally {
        // request cleanup happens in finally above
      }
    };

    const loadTestResults = async (test, options = {}) => {
      const { force = false } = options;
      const rawId = getTestId(test);
      const id = normalizeTestId(rawId);
      if (
        !rawId ||
        (typeof rawId === "string" &&
          String(rawId).startsWith("practice-test-")) ||
        !testsService?.getStudentAttempts
      )
        return;
      if (force) {
        clearTestResultsCache(id);
      }
      if (testResultsRequests.has(id)) {
        return testResultsRequests.get(id);
      }
      const request = testsService
        .getStudentAttempts(rawId)
        .then((data) => {
          const isArray = Array.isArray(data);
          const normalized = isArray ? data[0] : data;
          const attemptsUsed = isArray
            ? data.length
            : getAttemptsUsedFromResults(normalized);
          const cachedResults = loadTestResultsCache(id);
          const hasResults = normalized?.hasResults !== false;
          const preferredResults = hasResults
            ? shouldPreferLocalTestResults(test, cachedResults)
              ? pickPreferredTestResults(cachedResults, normalized)
              : normalized
            : null;
          if (!isUnmounted.value) {
            testResultsById.value = {
              ...testResultsById.value,
              [id]: preferredResults || null,
            };
            const limitFromResults =
              getAttemptLimitFromResults(preferredResults);
            if (limitFromResults !== null && limitFromResults !== undefined) {
              testAttemptsLimitById.value = {
                ...testAttemptsLimitById.value,
                [id]: limitFromResults,
              };
            }
            if (attemptsUsed !== null && attemptsUsed !== undefined) {
              testAttemptsUsedById.value = {
                ...testAttemptsUsedById.value,
                [id]: attemptsUsed,
              };
            }
            if (preferredResults) {
              updateModuleTestProgress(id, preferredResults);
            }
          }
          return preferredResults;
        })
        .catch((error) => {
          console.warn("Failed to load test results:", error);
          return null;
        })
        .finally(() => {
          testResultsRequests.delete(id);
        });
      testResultsRequests.set(id, request);
      try {
        return await request;
      } finally {
        // request cleanup happens in finally above
      }
    };

    function updateModuleTestProgress(testId, results) {
      if (!testId || !moduleData.value?.tests) return;
      const passed = normalizeBoolean(results?.passed);
      if (passed !== true) return;
      const items = moduleData.value.tests;
      const index = items.findIndex((item) => getTestId(item) === testId);
      if (index === -1) return;
      const updated = { ...items[index], is_completed: true };
      if (results?.score !== undefined) {
        updated.best_score = results.score;
      }
      const completedAt =
        results?.endTime ??
        results?.completed_at ??
        results?.completedAt ??
        null;
      if (completedAt) {
        updated.completed_at = completedAt;
      }
      const nextItems = items.slice();
      nextItems[index] = updated;
      moduleData.value = { ...moduleData.value, tests: nextItems };
    }

    const finalTestGradeFetchInFlight = ref(false);
    const preloadFinalTestGrades = async () => {
      if (!finalTestId.value || !testsService?.getStudentAttempts) return;
      if (finalTestGradeFetchInFlight.value) return;
      const tests = moduleTests.value.filter((test) => !isFinalTest(test));
      if (!tests.length) return;
      finalTestGradeFetchInFlight.value = true;
      try {
        await Promise.all(tests.map((test) => loadTestResults(test)));
      } finally {
        finalTestGradeFetchInFlight.value = false;
      }
    };

    watch(
      selectedTest,
      (current) => {
        if (!current) return;
        loadTestDetails(current);
        loadTestResults(current);
      },
      { immediate: true }
    );
    watch(
      () => [
        isSelectedTestFinal.value,
        moduleTests.value.length,
        finalTestId.value,
      ],
      ([isFinal]) => {
        if (isFinal) preloadFinalTestGrades();
      },
      { immediate: true }
    );

    const isTestSelected = (test, index) =>
      contentMode.value === "test" &&
      getTestKey(test, index) === selectedTestKey.value;

    const selectedTestTitle = computed(() =>
      getItemTitle(selectedTest.value, props.x018 || "")
    );

    const testDescription = computed(() => {
      const test = selectedTestDetails.value;
      return (
        test?.description ||
        test?.content ||
        test?.body ||
        test?.instructions ||
        ""
      );
    });

    const sanitizedTestDescription = computed(() =>
      sanitizeHtml(testDescription.value)
    );

    const runnerTest = ref(null);

    const getRunnerTest = () =>
      runnerTest.value || selectedTestDetails.value || selectedTest.value || {};

    const resolveTestForRunner = (testOverride) =>
      testOverride ||
      selectedTestDetails.value ||
      selectedTest.value ||
      runnerTest.value ||
      null;

    const testQuestions = computed(() => {
      const test = getRunnerTest();
      const sources = [
        test?.questions,
        test?.question_list,
        test?.questionList,
        test?.items,
        test?.questionnaire,
        test?.fullData?.questions,
        test?.fullData?.question_list,
        test?.fullData?.questionList,
        test?.fullData?.items,
        test?.fullData?.questionnaire,
      ];
      for (const source of sources) {
        const normalized = normalizeList(source);
        if (normalized.length) return normalized;
      }
      return [];
    });

    const testMaterials = computed(() => {
      const test = selectedTestDetails.value;
      if (!test) return [];
      const items = collectMaterials(
        test?.materials,
        test?.materials_list,
        test?.materialsList,
        test?.files,
        test?.files_list,
        test?.filesList,
        test?.attachments,
        test?.resources,
        test?.documents,
        test?.docs,
        test?.additional_materials,
        test?.additionalMaterials
      );
      return dedupeMaterials(items);
    });

    const getTestQuestionText = (item) => {
      if (!item) return "";
      if (typeof item === "string") return item;
      return (
        item?.text ||
        item?.question ||
        item?.title ||
        item?.body ||
        item?.prompt ||
        ""
      );
    };

    const testMeta = computed(() => {
      const test = selectedTestDetails.value;
      if (!test) return [];
      const meta = [];
      const duration =
        getDurationMinutes(test) ??
        test?.time_limit ??
        test?.timeLimit ??
        test?.duration_minutes ??
        null;
      if (duration) {
        meta.push({ label: "Время", value: `${duration} мин.` });
      }
      const passingScore =
        test?.passing_score ??
        test?.passingScore ??
        test?.pass_score ??
        test?.min_score ??
        null;
      if (
        passingScore !== null &&
        passingScore !== undefined &&
        passingScore !== ""
      ) {
        meta.push({ label: "Проходной балл", value: String(passingScore) });
      }
      const attempts =
        test?.max_attempts ??
        test?.attempts ??
        test?.attempt_limit ??
        test?.attemptLimit ??
        null;
      if (attempts !== null && attempts !== undefined && attempts !== "") {
        meta.push({ label: "Попыток", value: String(attempts) });
      }
      const totalPoints =
        test?.total_points ??
        test?.max_score ??
        test?.max_points ??
        test?.totalPoints ??
        null;
      if (
        totalPoints !== null &&
        totalPoints !== undefined &&
        totalPoints !== ""
      ) {
        meta.push({ label: "Баллы", value: String(totalPoints) });
      }
      return meta;
    });

    const getTestSetting = (...keys) => {
      const test = getRunnerTest();
      const fullData = test?.fullData || {};
      for (const key of keys) {
        if (fullData?.[key] !== undefined && fullData?.[key] !== null) {
          return fullData[key];
        }
      }
      for (const key of keys) {
        if (test?.[key] !== undefined && test?.[key] !== null) {
          return test[key];
        }
      }
      return undefined;
    };

    const toNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    };

    const toBoolean = (value) => {
      if (value === null || value === undefined) return null;
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value !== 0;
      if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (["true", "1", "yes", "y", "да"].includes(normalized)) return true;
        if (["false", "0", "no", "n", "нет"].includes(normalized)) return false;
      }
      return Boolean(value);
    };

    const getTestQuestionsCount = (test) => {
      if (!test) return null;
      const raw =
        test?.questions_count ??
        test?.question_count ??
        test?.total_questions ??
        test?.questionsCount ??
        test?.questionsTotal ??
        test?.fullData?.questions_count ??
        test?.fullData?.question_count ??
        test?.fullData?.total_questions ??
        test?.fullData?.questionsCount ??
        test?.fullData?.questionsTotal ??
        null;
      const count = toNumber(raw);
      return count && count > 0 ? count : null;
    };

    const getTestAttemptLimit = (test) => {
      const raw =
        test?.fullData?.attempts ??
        test?.fullData?.max_attempts ??
        test?.fullData?.attempt_limit ??
        test?.fullData?.attemptLimit ??
        test?.attempts ??
        test?.max_attempts ??
        test?.attempt_limit ??
        test?.attemptLimit ??
        null;
      const limit = toNumber(raw);
      return limit && limit > 0 ? limit : null;
    };

    const getAttemptLimitFromResults = (results) => {
      if (!results) return null;
      const raw =
        results?.attemptsLimit ??
        results?.attempts_limit ??
        results?.maxAttempts ??
        results?.max_attempts ??
        results?.attemptLimit ??
        results?.attempt_limit ??
        null;
      const limit = toNumber(raw);
      return limit && limit > 0 ? limit : null;
    };

    const getAttemptsUsedFromResults = (results) => {
      if (!results) return null;
      const raw =
        results?.attemptsUsed ??
        results?.attempts_used ??
        results?.attemptsCount ??
        results?.attempts_count ??
        results?.attempts ??
        results?.attempt ??
        results?.attemptNumber ??
        results?.attempt_number ??
        null;
      const parsed = toNumber(raw);
      if (parsed === null) return null;
      return parsed >= 0 ? parsed : null;
    };

    const isAttemptsLimitError = (error) => {
      const message =
        error?.response?.data?.message ??
        error?.response?.data?.error ??
        error?.message ??
        "";
      const normalized = String(message).toLowerCase();
      return (
        (normalized.includes("попыт") && normalized.includes("максим")) ||
        normalized.includes("max attempts")
      );
    };

    const getTestSettingFrom = (test, ...keys) => {
      if (!test) return undefined;
      const fullData = test?.fullData || {};
      for (const key of keys) {
        if (fullData?.[key] !== undefined && fullData?.[key] !== null) {
          return fullData[key];
        }
      }
      for (const key of keys) {
        if (test?.[key] !== undefined && test?.[key] !== null) {
          return test[key];
        }
      }
      return undefined;
    };

    const getRandomSubsetSettings = (test) => {
      const selectRandomQuestions =
        toBoolean(
          getTestSettingFrom(
            test,
            "selectRandomQuestions",
            "select_random_questions"
          )
        ) === true;
      const questionsToShow = toNumber(
        getTestSettingFrom(test, "questionsToShow", "questions_to_show")
      );
      return { selectRandomQuestions, questionsToShow };
    };

    const getResultQuestionCounts = (results) => {
      const questionCount = toNumber(
        results?.questionCount ?? results?.question_count
      );
      const questionPoolCount = toNumber(
        results?.questionPoolCount ?? results?.question_pool_count
      );
      return { questionCount, questionPoolCount };
    };

    const isSubsetTestResult = (results) => {
      const { questionCount, questionPoolCount } =
        getResultQuestionCounts(results);
      if (!questionCount || !questionPoolCount) return false;
      return questionCount < questionPoolCount;
    };

    const shouldPreferLocalTestResults = (test, results) => {
      if (isSubsetTestResult(results)) return true;
      const { selectRandomQuestions, questionsToShow } =
        getRandomSubsetSettings(test);
      if (!selectRandomQuestions || !questionsToShow) return false;
      const poolCount = getTestQuestionsCount(test);
      if (!poolCount) return true;
      return questionsToShow < poolCount;
    };

    const getTestResultsCacheKey = (testId) =>
      testId ? `screen8:test-results:${testId}` : null;

    const loadTestResultsCache = (testId) => {
      try {
        const key = getTestResultsCacheKey(testId);
        if (!key) return null;
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed?.results || null;
      } catch (error) {
        console.warn("Failed to read cached test results:", error);
        return null;
      }
    };

    const saveTestResultsCache = (testId, results) => {
      try {
        const key = getTestResultsCacheKey(testId);
        if (!key || !results) return;
        localStorage.setItem(
          key,
          JSON.stringify({
            results,
            savedAt: new Date().toISOString(),
          })
        );
      } catch (error) {
        console.warn("Failed to cache test results:", error);
      }
    };

    const clearTestResultsCache = (testId) => {
      try {
        const key = getTestResultsCacheKey(testId);
        if (!key) return;
        localStorage.removeItem(key);
      } catch (error) {
        console.warn("Failed to clear cached test results:", error);
      }
    };

    const clearTestResultsState = (testId) => {
      if (!testId) return;
      if (Object.prototype.hasOwnProperty.call(testResultsById.value, testId)) {
        const nextResults = { ...testResultsById.value };
        delete nextResults[testId];
        testResultsById.value = nextResults;
      }
      if (
        Object.prototype.hasOwnProperty.call(testAttemptsUsedById.value, testId)
      ) {
        const nextAttempts = { ...testAttemptsUsedById.value };
        delete nextAttempts[testId];
        testAttemptsUsedById.value = nextAttempts;
      }
      if (
        Object.prototype.hasOwnProperty.call(
          testAttemptsLimitById.value,
          testId
        )
      ) {
        const nextLimits = { ...testAttemptsLimitById.value };
        delete nextLimits[testId];
        testAttemptsLimitById.value = nextLimits;
      }
    };

    const isRefreshingTestResults = ref(false);
    const refreshSelectedTestResults = async () => {
      const test = selectedTestDetails.value || selectedTest.value;
      const id = normalizeTestId(getTestId(test));
      if (!id) return;
      isRefreshingTestResults.value = true;
      try {
        clearTestResultsCache(id);
        clearTestResultsState(id);
        await loadTestResults(test, { force: true });
      } finally {
        isRefreshingTestResults.value = false;
      }
    };

    const getTestResultsTimestamp = (results) => {
      if (!results) return null;
      const value =
        results?.graded_at ??
        results?.gradedAt ??
        results?.reviewed_at ??
        results?.reviewedAt ??
        results?.endTime ??
        results?.end_time ??
        results?.completed_at ??
        results?.completedAt ??
        null;
      const parsed = value ? Date.parse(value) : NaN;
      return Number.isFinite(parsed) ? parsed : null;
    };

    const pickPreferredTestResults = (cached, incoming) => {
      if (!cached) return incoming;
      if (!incoming) return cached;
      const cachedReviewedFlag =
        cached?.reviewed ??
        cached?.is_reviewed ??
        cached?.graded_by_teacher ??
        cached?.gradedByTeacher ??
        cached?.teacher_reviewed ??
        cached?.teacherReviewed ??
        null;
      const cachedStatusReviewed = ["graded", "reviewed"].includes(
        String(
          cached?.status ?? cached?.review_status ?? cached?.reviewStatus ?? ""
        ).toLowerCase()
      );
      const cachedTimeReviewed = Boolean(
        cached?.graded_at ??
          cached?.gradedAt ??
          cached?.reviewed_at ??
          cached?.reviewedAt ??
          null
      );
      const cachedReviewed =
        Boolean(cachedReviewedFlag) ||
        cachedStatusReviewed ||
        cachedTimeReviewed;

      const incomingReviewedFlag =
        incoming?.reviewed ??
        incoming?.is_reviewed ??
        incoming?.graded_by_teacher ??
        incoming?.gradedByTeacher ??
        incoming?.teacher_reviewed ??
        incoming?.teacherReviewed ??
        null;
      const incomingStatusReviewed = ["graded", "reviewed"].includes(
        String(
          incoming?.status ??
            incoming?.review_status ??
            incoming?.reviewStatus ??
            ""
        ).toLowerCase()
      );
      const incomingTimeReviewed = Boolean(
        incoming?.graded_at ??
          incoming?.gradedAt ??
          incoming?.reviewed_at ??
          incoming?.reviewedAt ??
          null
      );
      const incomingReviewed =
        Boolean(incomingReviewedFlag) ||
        incomingStatusReviewed ||
        incomingTimeReviewed;
      if (incomingReviewed && !cachedReviewed) return incoming;
      if (cachedReviewed && !incomingReviewed) return cached;
      const cachedSubset = isSubsetTestResult(cached);
      const incomingSubset = isSubsetTestResult(incoming);
      if (cachedSubset && !incomingSubset) return cached;
      if (!cachedSubset && incomingSubset) return incoming;
      const cachedTime = getTestResultsTimestamp(cached);
      const incomingTime = getTestResultsTimestamp(incoming);
      if (cachedTime && incomingTime) {
        return cachedTime >= incomingTime ? cached : incoming;
      }
      if (cachedTime && !incomingTime) return cached;
      if (!cachedTime && incomingTime) return incoming;
      return cached;
    };

    const normalizeQuestionType = (value) => {
      if (!value) return "text";
      const normalized = String(value).trim().toLowerCase();
      if (normalized === "single_choice" || normalized === "single")
        return "single";
      if (normalized === "multiple_choice" || normalized === "multiple")
        return "multiple";
      if (
        normalized === "text" ||
        normalized === "text_answer" ||
        normalized === "open"
      )
        return "text";
      return "text";
    };

    const normalizeQuestionAnswers = (answers, questionId) => {
      if (!Array.isArray(answers)) return [];
      return answers
        .filter((answer) => answer !== null && answer !== undefined)
        .map((answer, index) => {
          if (typeof answer === "string") {
            return {
              id: `${questionId}-a-${index + 1}`,
              text: answer,
              isCorrect: false,
            };
          }
          return {
            id:
              answer?.id ??
              answer?.answer_id ??
              answer?.answerId ??
              `${questionId}-a-${index + 1}`,
            text: answer?.text ?? answer?.answer_text ?? "",
            isCorrect: answer?.isCorrect ?? answer?.is_correct ?? false,
            image:
              answer?.image ?? answer?.image_url ?? answer?.imageUrl ?? null,
          };
        });
    };

    // Состояние и логика мини-теста внутри практики (самопроверка)
    const practiceQuizState = reactive({
      answers: {},
      checked: false,
    });
    const practiceQuizAnswers = practiceQuizState.answers;
    const practiceQuizChecked = computed(() => practiceQuizState.checked);

    const practiceQuizQuestions = computed(() => {
      const test = practiceAttachedTest.value;
      if (!test) return [];
      const sources = [
        test?.questions,
        test?.question_list,
        test?.questionList,
        test?.items,
        test?.questionnaire,
      ];
      for (const source of sources) {
        const normalized = normalizeList(source);
        if (normalized.length) {
          return normalized.map((question, index) => {
            if (question && typeof question === "object") {
              const id =
                question.id ??
                question._id ??
                question.question_id ??
                question.questionId ??
                `pq-${index + 1}`;
              const answersSource =
                question.answers ??
                question.answer_list ??
                question.answerList ??
                question.options ??
                [];
              return {
                ...question,
                id,
                text:
                  question.text ??
                  question.question_text ??
                  question.title ??
                  question.body ??
                  "",
                type: normalizeQuestionType(
                  question.type ??
                    question.question_type ??
                    question.questionType
                ),
                answers: normalizeQuestionAnswers(answersSource, id),
                correctText:
                  question.correctText ??
                  question.correct_text ??
                  question.correct_answer ??
                  "",
              };
            }
            return {
              id: `pq-${index + 1}`,
              text: String(question),
              type: "text",
              answers: [],
              correctText: "",
            };
          });
        }
      }
      return [];
    });

    const resetPracticeQuiz = () => {
      practiceQuizState.checked = false;
      Object.keys(practiceQuizState.answers).forEach((key) => {
        delete practiceQuizState.answers[key];
      });
    };

    const setPracticeSingleAnswer = (question, answerId) => {
      practiceQuizState.answers[question.id] = answerId;
      practiceQuizState.checked = false;
    };

    const togglePracticeMultiAnswer = (question, answerId) => {
      const current = Array.isArray(practiceQuizState.answers[question.id])
        ? practiceQuizState.answers[question.id].slice()
        : [];
      const index = current.indexOf(answerId);
      if (index >= 0) {
        current.splice(index, 1);
      } else {
        current.push(answerId);
      }
      practiceQuizState.answers[question.id] = current;
      practiceQuizState.checked = false;
    };

    const setPracticeTextAnswer = (question, value) => {
      practiceQuizState.answers[question.id] = value;
      practiceQuizState.checked = false;
    };

    const getCorrectAnswerIds = (question) => {
      const answers = Array.isArray(question.answers) ? question.answers : [];
      return answers
        .filter((answer) =>
          normalizeBoolean(answer?.isCorrect ?? answer?.is_correct)
        )
        .map((answer) => answer.id);
    };

    const normalizeAnswerText = (value) =>
      typeof value === "string" ? value.trim().toLowerCase() : "";

    const isPracticeQuestionCorrect = (question) => {
      const userAnswer = practiceQuizState.answers[question.id];
      if (question.type === "single") {
        const correctIds = getCorrectAnswerIds(question);
        if (!correctIds.length) return false;
        return correctIds.includes(userAnswer);
      }
      if (question.type === "multiple") {
        const correctIds = getCorrectAnswerIds(question);
        if (!correctIds.length) return false;
        const selected = Array.isArray(userAnswer) ? userAnswer : [];
        if (selected.length !== correctIds.length) return false;
        return correctIds.every((id) => selected.includes(id));
      }
      // text answer
      if (!question.correctText) return false;
      return (
        normalizeAnswerText(userAnswer) ===
        normalizeAnswerText(question.correctText)
      );
    };

    const checkPracticeQuiz = () => {
      if (!practiceQuizQuestions.value.length) return;
      practiceQuizState.checked = true;
    };

    const practiceQuizTotal = computed(
      () => practiceQuizQuestions.value.length || 0
    );
    const practiceQuizCorrectCount = computed(() => {
      if (!practiceQuizState.checked) return 0;
      return practiceQuizQuestions.value.reduce(
        (total, question) =>
          total + (isPracticeQuestionCorrect(question) ? 1 : 0),
        0
      );
    });

    watch(
      () => practiceAttachedTest.value,
      () => resetPracticeQuiz(),
      { immediate: true }
    );

    const testRunnerQuestions = computed(() =>
      testQuestions.value
        .filter((item) => item !== null && item !== undefined && item !== "")
        .map((question, index) => {
          if (question && typeof question === "object") {
            const id =
              question.id ??
              question._id ??
              question.question_id ??
              question.questionId ??
              `q-${index + 1}`;
            const answersSource =
              question.answers ??
              question.answer_list ??
              question.answerList ??
              question.options ??
              [];
            return {
              ...question,
              id,
              text:
                question.text ??
                question.question_text ??
                question.title ??
                question.body ??
                "",
              image:
                question.image ??
                question.image_url ??
                question.imageUrl ??
                question.image_file_url ??
                question.imageFileUrl ??
                question.image_path ??
                question.imagePath ??
                null,
              type: normalizeQuestionType(
                question.type ?? question.question_type ?? question.questionType
              ),
              answers: normalizeQuestionAnswers(answersSource, id),
              correctText:
                question.correctText ??
                question.correct_text ??
                question.correct_answer ??
                "",
              caseSensitive:
                question.caseSensitive ?? question.case_sensitive ?? false,
              customPoints:
                question.customPoints ??
                question.points ??
                question.score ??
                null,
            };
          }
          return {
            id: `q-${index + 1}`,
            text: String(question),
            type: "text",
            answers: [],
            correctText: "",
          };
        })
    );

    const testRunnerData = computed(() => {
      const test = getRunnerTest();
      const runnerTitle =
        getItemTitle(test, props.x018 || "") ||
        selectedTestTitle.value ||
        "Тест";
      const runnerDescription =
        test?.description ||
        test?.content ||
        test?.body ||
        test?.instructions ||
        testDescription.value ||
        "";
      const duration =
        toNumber(
          getTestSetting(
            "duration",
            "duration_minutes",
            "time_limit",
            "timeLimit",
            "time_limit_minutes"
          )
        ) ?? getDurationMinutes(test);
      const passingScore =
        toNumber(
          getTestSetting(
            "passingScore",
            "passing_score",
            "pass_score",
            "min_score"
          )
        ) ?? 70;
      const attempts =
        toNumber(
          getTestSetting(
            "attempts",
            "max_attempts",
            "attempt_limit",
            "attemptLimit"
          )
        ) ?? 1;
      const pointsPerQuestion =
        toNumber(getTestSetting("pointsPerQuestion", "points_per_question")) ??
        1;
      const explicitTotalPoints = toNumber(
        getTestSetting("totalPoints", "total_points", "max_points", "max_score")
      );
      const totalPoints =
        explicitTotalPoints ??
        testRunnerQuestions.value.reduce((sum, question) => {
          const customPoints = toNumber(question?.customPoints);
          return sum + (customPoints ?? pointsPerQuestion);
        }, 0);
      const randomOrder =
        toBoolean(getTestSetting("randomOrder", "random_order")) === true;
      const showCorrectAnswers =
        toBoolean(
          getTestSetting("showCorrectAnswers", "show_correct_answers")
        ) !== false;
      const allowReview =
        toBoolean(getTestSetting("allowReview", "allow_review")) !== false;
      const showProgressBar =
        toBoolean(getTestSetting("showProgressBar", "show_progress_bar")) !==
        false;
      const penalizeWrong =
        toBoolean(getTestSetting("penalizeWrong", "penalize_wrong")) === true;
      const penaltyPercentage =
        toNumber(getTestSetting("penaltyPercentage", "penalty_percentage")) ??
        50;
      const disableCopying =
        toBoolean(getTestSetting("disableCopying", "disable_copying")) === true;
      const limitTimePerQuestion =
        toBoolean(
          getTestSetting("limitTimePerQuestion", "limit_time_per_question")
        ) === true;
      const timePerQuestion =
        toNumber(getTestSetting("timePerQuestion", "time_per_question")) ?? 60;
      const selectRandomQuestions =
        toBoolean(
          getTestSetting("selectRandomQuestions", "select_random_questions")
        ) === true;
      const questionsToShow = toNumber(
        getTestSetting("questionsToShow", "questions_to_show")
      );
      const questionDistributionMode =
        getTestSetting(
          "questionDistributionMode",
          "question_distribution_mode"
        ) || "random";
      const questionTypeDistribution =
        getTestSetting(
          "questionTypeDistribution",
          "question_type_distribution"
        ) || {};

      return {
        title: runnerTitle,
        description: runnerDescription,
        duration,
        passingScore,
        attempts,
        pointsPerQuestion,
        totalPoints,
        randomOrder,
        showCorrectAnswers,
        allowReview,
        showProgressBar,
        penalizeWrong,
        penaltyPercentage,
        disableCopying,
        limitTimePerQuestion,
        timePerQuestion,
        selectRandomQuestions,
        questionsToShow,
        questionDistributionMode,
        questionTypeDistribution,
      };
    });

    const showTestRunner = ref(false);
    const testResultsById = ref({});
    const testAttemptById = ref({});
    const testAttemptsUsedById = ref({});
    const testAttemptsLimitById = ref({});
    const testResultsRequests = new Map();
    const selectedTestResults = computed(() => {
      const test = selectedTestDetails.value || selectedTest.value;
      const id = normalizeTestId(getTestId(test));
      return id ? testResultsById.value[id] : null;
    });
    const formatTestScoreValue = (value) => {
      if (value === null || value === undefined || value === "") return "";
      const numeric = Number(value);
      if (Number.isNaN(numeric)) return String(value);
      return numeric.toLocaleString("ru-RU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };
    const testScoreValue = computed(() => {
      const results = selectedTestResults.value;
      if (!results) return null;
      const raw =
        results?.score ??
        results?.pointsEarned ??
        results?.points_earned ??
        results?.result ??
        null;
      return raw === "" ? null : raw;
    });
    const testMaxScoreValue = computed(() => {
      const results = selectedTestResults.value;
      const test = selectedTestDetails.value || selectedTest.value;
      const raw =
        results?.maxPoints ??
        results?.totalPoints ??
        results?.total_points ??
        test?.total_points ??
        test?.max_score ??
        test?.max_points ??
        test?.totalPoints ??
        null;
      return raw === "" ? null : raw;
    });
    const testGradeLabel = computed(() => {
      const grade = formatTestScoreValue(testScoreValue.value);
      const maxScore = formatTestScoreValue(testMaxScoreValue.value);
      if (grade && maxScore) return `${grade} / ${maxScore}`;
      return grade || maxScore || "Нет оценки";
    });
    const testReviewPercentValue = computed(() => {
      const results = selectedTestResults.value;
      if (!results) return null;
      const directPercent = toNumber(
        results?.percentage ??
          results?.percent ??
          results?.percent_value ??
          results?.percentValue ??
          null
      );
      if (directPercent !== null && directPercent !== undefined) {
        return directPercent;
      }
      const scoreValue = toNumber(results?.score ?? null);
      const maxValue = toNumber(
        results?.total_points ??
          results?.totalPoints ??
          testMaxScoreValue.value ??
          null
      );
      if (scoreValue !== null) {
        if (maxValue && scoreValue <= maxValue) {
          return (scoreValue / maxValue) * 100;
        }
        if (scoreValue <= 100) return scoreValue;
      }
      const earnedValue = toNumber(
        results?.points_earned ?? results?.pointsEarned ?? null
      );
      if (earnedValue !== null && maxValue) {
        return (earnedValue / maxValue) * 100;
      }
      return null;
    });
    const testReviewGradeLabel = computed(() => {
      const percent = testReviewPercentValue.value;
      if (percent === null || percent === undefined) return "Нет оценки";
      return `${formatTestScoreValue(percent)} / ${formatTestScoreValue(100)}`;
    });
    const testReviewGradedAt = computed(() => {
      const results = selectedTestResults.value;
      return (
        results?.graded_at ??
        results?.gradedAt ??
        results?.reviewed_at ??
        results?.reviewedAt ??
        null
      );
    });
    const testReviewGradedAtLabel = computed(
      () => formatTestReviewDateTime(testReviewGradedAt.value) || "—"
    );
    const testReviewIsFailing = computed(() => {
      const percent = testReviewPercentValue.value;
      return percent !== null && percent !== undefined && percent < 50;
    });
    function getTestReviewedFlag(results) {
      if (!results) return false;
      const status = String(
        results?.status ?? results?.review_status ?? results?.reviewStatus ?? ""
      ).toLowerCase();
      if (["graded", "reviewed"].includes(status)) return true;
      if (
        results?.reviewed ??
        results?.is_reviewed ??
        results?.graded_by_teacher ??
        results?.gradedByTeacher ??
        results?.teacher_reviewed ??
        results?.teacherReviewed
      ) {
        return true;
      }
      if (
        results?.graded_at ??
        results?.gradedAt ??
        results?.reviewed_at ??
        results?.reviewedAt
      ) {
        return true;
      }
      return false;
    }
    const hasTestGrade = (results) => {
      if (!results) return false;
      if (getTestReviewedFlag(results)) return true;
      const candidates = [
        results?.score,
        results?.percentage,
        results?.percent,
        results?.percent_value,
        results?.percentValue,
        results?.points_earned,
        results?.pointsEarned,
        results?.result,
      ];
      return candidates.some(
        (value) => value !== null && value !== undefined && value !== ""
      );
    };
    const testIsReviewedByTeacher = computed(() => {
      return getTestReviewedFlag(selectedTestResults.value);
    });
    const testReviewIsAvailable = computed(() => testIsReviewedByTeacher.value);
    const _isTestGradeLocked = computed(() => {
      const results = selectedTestResults.value;
      if (!results) return false;
      if (
        results?.reviewed ??
        results?.is_reviewed ??
        results?.graded_by_teacher ??
        results?.gradedByTeacher ??
        results?.teacher_reviewed ??
        results?.teacherReviewed
      ) {
        return true;
      }
      if (results?.graded_at ?? results?.gradedAt) return true;
      if (results?.score !== null && results?.score !== undefined) return true;
      if (results?.percentage !== null && results?.percentage !== undefined) {
        return true;
      }
      if (
        results?.points_earned !== null &&
        results?.points_earned !== undefined
      ) {
        return true;
      }
      return false;
    });
    const finalTestMissingGrades = computed(() => {
      if (!finalTestId.value) return [];
      const tests = moduleTests.value.filter((test) => !isFinalTest(test));
      if (!tests.length) return [];
      return tests
        .map((test) => {
          const id = normalizeTestId(getTestId(test));
          const results = id ? testResultsById.value[id] : null;
          if (hasTestGrade(results)) return null;
          return { id, title: getItemTitle(test, "Тест") };
        })
        .filter(Boolean);
    });
    const finalTestHasRequiredGrades = computed(
      () => finalTestMissingGrades.value.length === 0
    );
    const finalTestAccessAllowed = computed(
      () =>
        finalTestAccessAllowedByRules.value && finalTestHasRequiredGrades.value
    );
    const finalTestAccessMessage = computed(() => {
      if (!finalTestId.value || finalTestAccessAllowed.value) return "";
      const parts = [];
      if (finalTestMissingItems.value.length) {
        parts.push(
          `Нужно завершить: ${finalTestMissingItems.value
            .map((item) => `${item.label} (${item.completed}/${item.total})`)
            .join(", ")}`
        );
      }
      if (finalTestMissingGrades.value.length) {
        parts.push(
          `Нужна оценка за тесты: ${finalTestMissingGrades.value
            .map((item) => item.title)
            .join(", ")}`
        );
      }
      if (
        finalTestWindowStatus.value === "upcoming" &&
        finalTestWindowStart.value
      ) {
        parts.push(
          `Тест станет доступен ${formatDateTime(finalTestWindowStart.value)}`
        );
      }
      if (
        finalTestWindowStatus.value === "expired" &&
        finalTestWindowEnd.value
      ) {
        parts.push(
          `Окно доступа завершилось ${formatDateTime(finalTestWindowEnd.value)}`
        );
      }
      return parts.join(". ");
    });
    const testAttemptsLimit = computed(() => {
      const test = selectedTestDetails.value || selectedTest.value;
      const id = normalizeTestId(getTestId(test));
      const override =
        id !== null && id !== undefined
          ? testAttemptsLimitById.value[id]
          : null;
      if (override !== null && override !== undefined) return override;
      return (
        getTestAttemptLimit(test) ||
        getAttemptLimitFromResults(selectedTestResults.value)
      );
    });
    const testAttemptsUsed = computed(() => {
      const test = selectedTestDetails.value || selectedTest.value;
      const id = normalizeTestId(getTestId(test));
      const stored =
        id !== null && id !== undefined ? testAttemptsUsedById.value[id] : null;
      if (stored !== null && stored !== undefined) return stored;
      const results = selectedTestResults.value;
      const fromResults = getAttemptsUsedFromResults(results);
      if (fromResults !== null && fromResults !== undefined) return fromResults;
      return 0;
    });
    const isTestAttemptsExhausted = computed(() => {
      const limit = testAttemptsLimit.value;
      if (!limit) return false;
      return (testAttemptsUsed.value ?? 0) >= limit;
    });
    const testStartLabel = computed(() => {
      if (isSelectedTestFinal.value && !finalTestAccessAllowed.value)
        return "Недоступно";
      if (isTestAttemptsExhausted.value) return "Попытки закончились";
      return "Начать тест";
    });
    const canStartTest = computed(() => {
      const test = selectedTestDetails.value || selectedTest.value;
      const hasQuestions =
        testRunnerQuestions.value.length > 0 || Boolean(getTestId(test));
      const hasAccess =
        !isFinalTest(test) || finalTestAccessAllowed.value === true;
      return hasQuestions && !isTestAttemptsExhausted.value && hasAccess;
    });

    const openTestRunner = async (testOverride) => {
      const test = resolveTestForRunner(testOverride);
      console.log("[openTestRunner] test:", test);
      if (!test) return;
      if (isFinalTest(test)) {
        await preloadFinalTestGrades();
        if (!finalTestAccessAllowed.value) {
          completionError.value =
            finalTestAccessMessage.value || "Доступ к финальному тесту закрыт.";
          setTimeout(() => {
            if (completionError.value) completionError.value = null;
          }, 5000);
          return;
        }
      }
      if (testsService?.getStudentAttempts) {
        await loadTestResults(test);
      }
      if (isTestAttemptsExhausted.value) {
        completionError.value = "Лимит попыток исчерпан.";
        setTimeout(() => {
          if (completionError.value) completionError.value = null;
        }, 5000);
        return;
      }
      runnerTest.value = test;
      console.log(
        "[openTestRunner] testRunnerQuestions before load:",
        testRunnerQuestions.value.length
      );
      const rawId = getTestId(test);
      const id = normalizeTestId(rawId);
      const expectedCount = getTestQuestionsCount(test);
      const needsFullLoad =
        !testRunnerQuestions.value.length ||
        (expectedCount && testRunnerQuestions.value.length < expectedCount) ||
        (id && !testDetailsById.value[id]);
      if (needsFullLoad) {
        await loadTestDetails(test);
        // Обновить runnerTest данными из testDetailsById после загрузки
        if (id && testDetailsById.value[id]) {
          console.log(
            "[openTestRunner] updating runnerTest from testDetailsById:",
            testDetailsById.value[id]
          );
          runnerTest.value = testDetailsById.value[id];
        }
      }
      console.log("[openTestRunner] testRunnerQuestions count after load:", {
        count: testRunnerQuestions.value.length,
        expectedCount: getTestQuestionsCount(runnerTest.value),
        testId: rawId,
      });
      console.log(
        "[openTestRunner] testRunnerQuestions after load:",
        testRunnerQuestions.value.length
      );
      console.log("[openTestRunner] testQuestions:", testQuestions.value);
      console.log("[openTestRunner] runnerTest.value:", runnerTest.value);
      if (!testRunnerQuestions.value.length) {
        completionError.value = "В этом тесте нет вопросов.";
        setTimeout(() => {
          if (completionError.value) completionError.value = null;
        }, 5000);
        return;
      }
      showTestRunner.value = true;
    };

    const closeTestRunner = async (payload) => {
      showTestRunner.value = false;
      const test = getRunnerTest();
      const rawId = getTestId(test);
      const id = normalizeTestId(rawId);
      const results = payload?.results ?? payload;
      const answers = payload?.answers;
      if (id && results) {
        testResultsById.value = { ...testResultsById.value, [id]: results };
        const limitFromResults = getAttemptLimitFromResults(results);
        if (limitFromResults !== null && limitFromResults !== undefined) {
          testAttemptsLimitById.value = {
            ...testAttemptsLimitById.value,
            [id]: limitFromResults,
          };
        }
        const payloadAttempts = getAttemptsUsedFromResults(results);
        const storedAttempts = testAttemptsUsedById.value[id];
        const nextAttempts =
          payloadAttempts !== null && payloadAttempts !== undefined
            ? storedAttempts !== null && storedAttempts !== undefined
              ? storedAttempts + payloadAttempts
              : payloadAttempts
            : storedAttempts !== null && storedAttempts !== undefined
            ? storedAttempts + 1
            : 1;
        testAttemptsUsedById.value = {
          ...testAttemptsUsedById.value,
          [id]: nextAttempts,
        };
        if (shouldPreferLocalTestResults(test, results)) {
          saveTestResultsCache(id, results);
        }
      }
      if (rawId && answers && testsService?.submitAttempt) {
        try {
          let attemptId = testAttemptById.value[id];
          if (!attemptId && testsService?.startAttempt) {
            try {
              const attempt = await testsService.startAttempt(rawId);
              attemptId =
                attempt?.attemptId ??
                attempt?.id ??
                attempt?.attempt_id ??
                null;
              if (attemptId) {
                testAttemptById.value = {
                  ...testAttemptById.value,
                  [id]: attemptId,
                };
              }
            } catch (error) {
              console.warn("Failed to start test attempt:", error);
              if (isAttemptsLimitError(error)) {
                const limit =
                  testAttemptsLimit.value ||
                  getAttemptLimitFromResults(results);
                if (limit !== null && limit !== undefined && id) {
                  testAttemptsUsedById.value = {
                    ...testAttemptsUsedById.value,
                    [id]: limit,
                  };
                  testAttemptsLimitById.value = {
                    ...testAttemptsLimitById.value,
                    [id]: limit,
                  };
                }
                completionError.value = "Лимит попыток исчерпан.";
                setTimeout(() => {
                  if (completionError.value) completionError.value = null;
                }, 5000);
                return;
              }
              throw error;
            }
          }
          if (attemptId) {
            console.log("[submitAttempt] payload", {
              testId: rawId,
              attemptId,
              answers,
              timeSpentSeconds: results?.totalTime ?? null,
            });
            await testsService.submitAttempt(
              rawId,
              attemptId,
              answers,
              results?.totalTime ?? null
            );
            console.log("[submitAttempt] success", {
              testId: rawId,
              attemptId,
            });
            testAttemptById.value = {
              ...testAttemptById.value,
              [id]: null,
            };
            if (results) {
              updateModuleTestProgress(id, results);
            }
            loadTestResults(test);
          } else {
            throw new Error("Attempt not started");
          }
        } catch (error) {
          const readableErrorMessage = decodeMojibakeMessage(
            error?.response?.data?.message ??
              error?.response?.data?.error ??
              error?.message ??
              ""
          );
          if (readableErrorMessage) {
            console.warn(
              "Failed to submit test attempt:",
              readableErrorMessage,
              error
            );
          } else {
            console.warn("Failed to submit test attempt:", error);
          }
          if (isAttemptsLimitError(error)) {
            const limitFromResults = getAttemptLimitFromResults(results);
            const limit = testAttemptsLimit.value || limitFromResults;
            if (limit !== null && limit !== undefined && id) {
              testAttemptsUsedById.value = {
                ...testAttemptsUsedById.value,
                [id]: limit,
              };
              testAttemptsLimitById.value = {
                ...testAttemptsLimitById.value,
                [id]: limit,
              };
            } else if (id) {
              const stored = testAttemptsUsedById.value[id];
              const next = stored !== null && stored !== undefined ? stored : 1;
              testAttemptsUsedById.value = {
                ...testAttemptsUsedById.value,
                [id]: next,
              };
              testAttemptsLimitById.value = {
                ...testAttemptsLimitById.value,
                [id]: next,
              };
            }
            completionError.value = "Лимит попыток исчерпан.";
          } else {
            // Ошибка сохранения попытки: не показываем пользователю,
            // чтобы не блокировать прохождение теста при серверных сбоях.
            completionError.value = null;
          }
          setTimeout(() => {
            if (completionError.value) completionError.value = null;
          }, 5000);
        }
      }
    };

    const decodeMojibakeMessage = (value) => {
      if (!value || typeof value !== "string") return "";
      const original = value.trim();
      if (!original) return "";
      if (!/Р|С/.test(original)) return original;
      try {
        const bytes = Uint8Array.from(original, (char) => char.charCodeAt(0));
        const decoded = new TextDecoder("windows-1251").decode(bytes);
        const originalCyrillicCount = (original.match(/[А-Яа-яЁё]/g) || [])
          .length;
        const decodedCyrillicCount = (decoded.match(/[А-Яа-яЁё]/g) || [])
          .length;
        if (decodedCyrillicCount >= originalCyrillicCount) {
          return decoded;
        }
      } catch (error) {
        // ignore decoding errors
      }
      return original;
    };

    const formatTestDateTime = (value) => {
      if (!value) return "";
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return formatDateTime(value) || "";
      const pad2 = (num) => String(num).padStart(2, "0");
      return (
        pad2(date.getDate()) +
        "." +
        pad2(date.getMonth() + 1) +
        "." +
        date.getFullYear() +
        ", " +
        pad2(date.getHours()) +
        ":" +
        pad2(date.getMinutes())
      );
    };

    const formatTestDuration = (seconds) => {
      if (seconds === null || seconds === undefined) return "";
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${String(secs).padStart(2, "0")}`;
    };

    const getTestStartTimeValue = (results) =>
      results?.startTime ??
      results?.start_time ??
      results?.started_at ??
      results?.startedAt ??
      results?.created_at ??
      results?.createdAt ??
      null;

    const getTestEndTimeValue = (results) =>
      results?.endTime ??
      results?.end_time ??
      results?.completed_at ??
      results?.completedAt ??
      results?.ended_at ??
      results?.endedAt ??
      null;

    const getTestTotalSecondsValue = (results) =>
      toNumber(
        results?.totalTime ??
          results?.total_time ??
          results?.time_spent_seconds ??
          results?.timeSpentSeconds ??
          null
      );

    const deriveEndTimeFromDuration = (startValue, totalSeconds) => {
      if (!startValue || totalSeconds === null || totalSeconds === undefined)
        return null;
      const startDate =
        startValue instanceof Date ? startValue : new Date(startValue);
      if (Number.isNaN(startDate.getTime())) return null;
      return new Date(startDate.getTime() + totalSeconds * 1000);
    };

    const testStartTimeValue = computed(() =>
      getTestStartTimeValue(selectedTestResults.value)
    );

    const testEndTimeValue = computed(() => {
      const results = selectedTestResults.value;
      if (!results) return null;
      const startValue = getTestStartTimeValue(results);
      const endValue = getTestEndTimeValue(results);
      const totalSeconds = getTestTotalSecondsValue(results);
      const derivedEnd = deriveEndTimeFromDuration(startValue, totalSeconds);
      if (endValue) {
        if (derivedEnd && startValue && totalSeconds) {
          const startDate =
            startValue instanceof Date ? startValue : new Date(startValue);
          const endDate =
            endValue instanceof Date ? endValue : new Date(endValue);
          if (
            !Number.isNaN(startDate.getTime()) &&
            !Number.isNaN(endDate.getTime()) &&
            endDate.getTime() <= startDate.getTime()
          ) {
            return derivedEnd;
          }
        }
        return endValue;
      }
      return derivedEnd;
    });

    const testFallbackImages = computed(() => [props.image6].filter(Boolean));

    const getTestImage = (test) =>
      test?.cover_image ||
      test?.cover_image_url ||
      test?.preview_image ||
      test?.image ||
      testFallbackImages.value[0] ||
      props.image6;

    const getTestCardClassName = (test, index, baseClasses = []) => {
      const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses];
      if (isTestSelected(test, index)) {
        classes.push("lesson-card-active");
      } else {
        classes.push("lesson-card-inactive");
      }
      return classes.filter(Boolean).join(" ");
    };

    const selectTest = (test, index) => {
      selectedTestKey.value = getTestKey(test, index);
      contentMode.value = "test";
      scheduleScrollPageToTop();
    };
    const selectTestMobile = (test, index) => {
      selectTest(test, index);
      if (isMobileViewport()) {
        closeSidebar();
      }
    };

    const getHomeworkKey = (item, index) =>
      item?.id ??
      item?._id ??
      item?.homework_id ??
      item?.homeworkId ??
      item?.task_id ??
      index;

    const getHomeworkId = (item) =>
      item?.id ??
      item?._id ??
      item?.homework_id ??
      item?.homeworkId ??
      item?.task_id ??
      null;

    const getHomeworkOrder = (item) =>
      item?.order ??
      item?.order_number ??
      item?.position ??
      item?.sort_order ??
      item?.sortOrder ??
      item?.index ??
      null;

    const sortedHomework = computed(() => {
      const items = moduleHomework.value.slice();
      const hasOrder = items.some(
        (item) =>
          getHomeworkOrder(item) !== null &&
          getHomeworkOrder(item) !== undefined
      );
      if (!hasOrder) return items;
      return items.sort((a, b) => {
        const orderA = getHomeworkOrder(a) ?? 0;
        const orderB = getHomeworkOrder(b) ?? 0;
        return orderA - orderB;
      });
    });

    const getHomeworkSubmissionStatus = (item) =>
      item?.submission_status ?? item?.submissionStatus ?? item?.status ?? null;

    const isHomeworkCompleted = (item) => {
      if (!item) return false;
      if (item?.is_completed !== undefined)
        return normalizeBoolean(item.is_completed) === true;
      if (item?.isCompleted !== undefined)
        return normalizeBoolean(item.isCompleted) === true;
      if (item?.completed !== undefined)
        return normalizeBoolean(item.completed) === true;
      const status = getHomeworkSubmissionStatus(item);
      if (status) return ["completed", "graded", "reviewed"].includes(status);
      if (item?.completion_percent !== undefined) {
        return Number(item.completion_percent) >= 100;
      }
      return false;
    };

    function updateModuleHomeworkProgress(homeworkId, submission) {
      if (!homeworkId || !moduleData.value?.homework) return;
      const items = moduleData.value.homework;
      const index = items.findIndex(
        (item) => getHomeworkId(item) === homeworkId
      );
      if (index === -1) return;
      const updated = { ...items[index] };
      if (!submission) {
        updated.is_submitted = false;
        updated.is_completed = false;
        updated.submission_status = null;
        updated.submission_score = null;
        updated.submitted_at = null;
        updated.graded_at = null;
        const nextItems = items.slice();
        nextItems[index] = updated;
        moduleData.value = { ...moduleData.value, homework: nextItems };
        return;
      }
      if (submission?.is_submitted !== undefined) {
        updated.is_submitted =
          normalizeBoolean(submission.is_submitted) === true;
      }
      if (submission?.is_completed !== undefined) {
        updated.is_completed =
          normalizeBoolean(submission.is_completed) === true;
      }
      const status = getHomeworkSubmissionStatus(submission);
      if (status) {
        updated.submission_status = status;
        if (
          [
            "submitted",
            "completed",
            "graded",
            "reviewed",
            "needs_revision",
          ].includes(status)
        ) {
          updated.is_submitted = true;
        }
        if (["completed", "graded", "reviewed"].includes(status)) {
          updated.is_completed = true;
        }
      }
      if (submission?.score !== undefined) {
        updated.submission_score = submission.score;
      }
      const submittedAt =
        submission?.submitted_at ?? submission?.submittedAt ?? null;
      if (submittedAt) {
        updated.submitted_at = submittedAt;
      }
      const gradedAt = submission?.graded_at ?? submission?.gradedAt ?? null;
      if (gradedAt) {
        updated.graded_at = gradedAt;
      }
      const nextItems = items.slice();
      nextItems[index] = updated;
      moduleData.value = { ...moduleData.value, homework: nextItems };
    }

    const selectedHomeworkKey = ref(null);
    const selectedHomework = computed(() => {
      if (!sortedHomework.value.length) return null;
      const found = sortedHomework.value.find(
        (item, index) =>
          getHomeworkKey(item, index) === selectedHomeworkKey.value
      );
      return found || sortedHomework.value[0];
    });

    const isHomeworkSelected = (item, index) =>
      contentMode.value === "homework" &&
      getHomeworkKey(item, index) === selectedHomeworkKey.value;

    const selectedHomeworkTitle = computed(() =>
      getItemTitle(
        selectedHomework.value,
        props.x019 || props.x0110 || props.x0111 || ""
      )
    );

    const homeworkDescription = computed(() => {
      const item = selectedHomework.value;
      return pickRichTextContent(
        item?.description,
        item?.task_description,
        item?.content,
        item?.body,
        item?.instructions,
        ""
      );
    });

    const sanitizedHomeworkDescription = computed(() =>
      sanitizeHtml(homeworkDescription.value)
    );

    const homeworkRequirements = computed(() =>
      normalizeList(
        selectedHomework.value?.requirements ??
          selectedHomework.value?.requirements_list ??
          selectedHomework.value?.requirementsList ??
          selectedHomework.value?.checklist ??
          selectedHomework.value?.tasks ??
          selectedHomework.value?.steps ??
          []
      )
    );

    const homeworkMaterials = computed(() => {
      const item = selectedHomework.value;
      if (!item) return [];
      const items = collectMaterials(
        item?.materials,
        item?.materials_list,
        item?.materialsList,
        item?.files,
        item?.files_list,
        item?.filesList,
        item?.attachments,
        item?.resources,
        item?.documents,
        item?.docs,
        item?.additional_materials,
        item?.additionalMaterials
      );
      return dedupeMaterials(items);
    });

    const parseDateInput = (value) => {
      if (!value) return null;
      if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
      if (typeof value === "number") {
        const asDate = new Date(value);
        return Number.isNaN(asDate.getTime()) ? null : asDate;
      }
      const raw = String(value).trim();
      if (!raw) return null;
      const dotMatch = raw.match(/^(\d{2})\.(\d{2})\.(\d{2,4})/);
      if (dotMatch) {
        let year = Number(dotMatch[3]);
        if (dotMatch[3].length === 2) {
          year += 2000;
        }
        return new Date(year, Number(dotMatch[2]) - 1, Number(dotMatch[1]));
      }
      const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        return new Date(
          Number(isoMatch[1]),
          Number(isoMatch[2]) - 1,
          Number(isoMatch[3])
        );
      }
      const asDate = new Date(raw);
      return Number.isNaN(asDate.getTime()) ? null : asDate;
    };

    const parseTimeInput = (value) => {
      if (value instanceof Date && !Number.isNaN(value.getTime())) {
        return {
          hours: value.getHours(),
          minutes: value.getMinutes(),
          seconds: value.getSeconds(),
        };
      }
      if (value === null || value === undefined) return null;
      const raw = String(value).trim();
      if (!raw) return null;
      const match = raw.match(/(\d{1,2}):(\d{2})(?::(\d{2}))?/);
      if (!match) return null;
      return {
        hours: Number(match[1]),
        minutes: Number(match[2]),
        seconds: match[3] ? Number(match[3]) : 0,
      };
    };

    const mergeDateTime = (dateValue, timeValue) => {
      const date = parseDateInput(dateValue);
      if (!date) return null;
      let time = parseTimeInput(timeValue);
      if (!time && typeof dateValue === "string") {
        time = parseTimeInput(dateValue);
      }
      if (time) {
        date.setHours(time.hours, time.minutes, time.seconds || 0, 0);
      }
      return date;
    };

    const formatLateDuration = (milliseconds) => {
      if (!milliseconds || milliseconds <= 0) return "";
      const totalMinutes = Math.ceil(milliseconds / 60000);
      const days = Math.floor(totalMinutes / 1440);
      const hours = Math.floor((totalMinutes % 1440) / 60);
      const minutes = totalMinutes % 60;
      const parts = [];
      if (days) {
        parts.push(`${days} дн`);
      }
      if (hours || days) {
        parts.push(`${hours} ч`);
      }
      parts.push(`${minutes} мин`);
      return parts.join(" ");
    };

    const toValidDate = (value) => {
      if (!value) return null;
      if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const formatHomeworkDateTimeLong = (value) => {
      const date = toValidDate(value);
      if (!date) return "";
      const formatter = new Intl.DateTimeFormat("ru-RU", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      return formatter.format(date).replace(" г.,", ",");
    };
    const formatTestReviewDateTime = (value) => {
      const date = toValidDate(value);
      if (!date) return "";
      const formatter = new Intl.DateTimeFormat("ru-RU", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      return formatter.format(date).replace(" г.,", " г. в");
    };

    const formatScoreValue = (value) => {
      if (value === null || value === undefined || value === "") return "";
      const numeric = Number(value);
      if (Number.isNaN(numeric)) return String(value);
      return numeric.toLocaleString("ru-RU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const homeworkDueParts = computed(() => {
      const item = selectedHomework.value;
      if (!item) return { dateValue: null, timeValue: null };
      return {
        dateValue:
          item?.due_date ??
          item?.dueDate ??
          item?.deadline ??
          item?.due_at ??
          item?.dueAt ??
          null,
        timeValue: item?.due_time ?? item?.dueTime ?? null,
      };
    });

    const homeworkDueAt = computed(() =>
      mergeDateTime(
        homeworkDueParts.value.dateValue,
        homeworkDueParts.value.timeValue
      )
    );

    const homeworkDueLabel = computed(() => {
      const { dateValue, timeValue } = homeworkDueParts.value;
      if (!dateValue) return "";
      return formatDateTime(dateValue, timeValue);
    });

    const homeworkAllowLate = computed(() => {
      const item = selectedHomework.value;
      if (!item) return null;
      const raw =
        item?.allow_late_submission ??
        item?.allowLate ??
        item?.allowLateSubmission ??
        item?.allow_late ??
        item?.late_allowed ??
        item?.lateAllowed ??
        null;
      if (raw === null || raw === undefined) return null;
      return normalizeBoolean(raw);
    });

    const homeworkIsLate = computed(() => {
      if (!homeworkDueAt.value) return false;
      return now.value.getTime() > homeworkDueAt.value.getTime();
    });

    const homeworkSubmissionBlocked = computed(() => {
      if (!homeworkDueAt.value) return false;
      const allowLate = homeworkAllowLate.value;
      if (allowLate === null) return false;
      return !allowLate && homeworkIsLate.value;
    });

    const homeworkLateLabel = computed(() => {
      if (!homeworkDueAt.value || !lastHomeworkSubmissionAt.value) return "";
      const delta =
        lastHomeworkSubmissionAt.value.getTime() -
        homeworkDueAt.value.getTime();
      if (delta <= 0) return "";
      return formatLateDuration(delta);
    });

    const homeworkMeta = computed(() => {
      const item = selectedHomework.value;
      if (!item) return [];
      const meta = [];
      if (homeworkDueLabel.value) {
        meta.push({
          label: "Срок",
          value: homeworkDueLabel.value,
        });
      }
      const explicitMaxScore =
        item?.maxScore ??
        item?.fullData?.maxScore ??
        item?.max_points ??
        item?.total_points ??
        null;
      const maxScore =
        explicitMaxScore !== null &&
        explicitMaxScore !== undefined &&
        explicitMaxScore !== ""
          ? explicitMaxScore
          : item?.max_score ?? null;
      if (
        maxScore !== null &&
        maxScore !== undefined &&
        maxScore !== ""
      ) {
        meta.push({ label: "Баллы", value: String(maxScore) });
      }
      const attempts =
        item?.attempts ??
        item?.attempts_count ??
        item?.attemptsCount ??
        item?.tries ??
        item?.try_limit ??
        item?.tryLimit ??
        null;
      if (attempts !== null && attempts !== undefined && attempts !== "") {
        meta.push({ label: "Попытки", value: String(attempts) });
      }
      if (homeworkDueAt.value && homeworkAllowLate.value !== null) {
        meta.push({
          label: "Опоздание",
          value: homeworkAllowLate.value ? "Разрешено" : "Запрещено",
        });
      }
      return meta;
    });

    const getHomeworkSubmissionDate = (submission) => {
      if (!submission) return null;
      const raw =
        submission?.submitted_at ??
        submission?.submittedAt ??
        submission?.created_at ??
        submission?.createdAt ??
        null;
      if (!raw) return null;
      const date = new Date(raw);
      return Number.isNaN(date.getTime()) ? null : date;
    };

    const normalizeSubmissionFiles = (value) => {
      const list = normalizeList(value);
      return list.filter(
        (item) => item !== null && item !== undefined && item !== ""
      );
    };

    const getHomeworkSubmissionFileName = (file) => {
      if (!file) return "";
      const title = getMaterialTitle(file);
      if (title) return title;
      if (typeof file === "string") return extractFileName(file);
      const raw =
        file?.file_path ||
        file?.filePath ||
        file?.url ||
        file?.path ||
        file?.file_url ||
        file?.fileUrl ||
        "";
      return extractFileName(raw);
    };

    const getHomeworkSubmissionFileUrl = (file) => getMaterialLink(file);

    const homeworkExistingFiles = ref([]);
    const homeworkFiles = ref([]);
    const isHomeworkUploadExpanded = ref(false);
    const homeworkFileInput = ref(null);
    const homeworkSubmissionCache = ref({});
    const homeworkStatusCache = ref({});
    const homeworkSubmissionData = ref(null);
    const homeworkCommentCache = ref({});
    const homeworkCommentSaved = ref("");
    const homeworkCommentDraft = ref("");
    const homeworkCommentModalOpen = ref(false);
    const isHomeworkDragging = ref(false);
    const isRevisionDragging = ref(false);
    const isSubmittingHomework = ref(false);
    const homeworkSubmissionError = ref("");
    const homeworkSubmissionSuccess = ref(false);
    const lastHomeworkSubmissionAt = ref(null);
    const revisionFiles = ref([]);
    const revisionExistingFiles = ref([]);
    const revisionText = ref("");
    const revisionFileInput = ref(null);
    const isSubmittingRevision = ref(false);
    const revisionSubmissionError = ref("");
    const _homeworkSubmissionDateLabel = computed(() => {
      if (!lastHomeworkSubmissionAt.value) return "";
      return formatDateTime(lastHomeworkSubmissionAt.value) || "";
    });
    const homeworkHasSubmission = computed(() => {
      const submission = homeworkSubmissionData.value;
      const status = String(
        submission?.status ??
          submission?.submission_status ??
          ""
      ).toLowerCase();
      const submissionText = String(
        submission?.submission_text ??
          submission?.submissionText ??
          submission?.answer ??
          ""
      ).trim();
      const submissionFiles = normalizeSubmissionFiles(
        submission?.files ??
          submission?.attachments ??
          submission?.files_list ??
          submission?.filesList ??
          submission?.uploads ??
          []
      ).length;
      const revisionText = String(
        submission?.revision_submission_text ??
          submission?.revisionSubmissionText ??
          ""
      ).trim();
      const revisionFiles = normalizeSubmissionFiles(
        submission?.revision_submission_files ??
          submission?.revisionSubmissionFiles ??
          []
      ).length;
      const hasPayload =
        Boolean(submissionText) ||
        submissionFiles > 0 ||
        Boolean(revisionText) ||
        revisionFiles > 0;
      const hasGrade =
        submission?.grade !== null &&
        submission?.grade !== undefined &&
        submission?.grade !== "";
      const hasSystemState =
        ["graded", "reviewed", "needs_revision"].includes(status) || hasGrade;
      return (
        hasPayload ||
        hasSystemState ||
        homeworkExistingFiles.value.length > 0 ||
        homeworkFiles.value.length > 0
      );
    });
    const homeworkSubmissionStatus = computed(() =>
      getHomeworkSubmissionStatus(
        homeworkSubmissionData.value || selectedHomework.value
      )
    );
    const homeworkRevisionRequested = computed(() => {
      const status = homeworkSubmissionStatus.value;
      if (status === "needs_revision") return true;
      const submission = homeworkSubmissionData.value;
      return Boolean(
        submission?.revision_request_text ||
          submission?.revisionRequestText ||
          (submission?.revision_request_files &&
            normalizeSubmissionFiles(submission.revision_request_files).length)
      );
    });
    const homeworkMaxScoreValue = computed(() => {
      const item = selectedHomework.value;
      if (!item) return null;
      return (
        item?.maxScore ??
        item?.fullData?.maxScore ??
        item?.max_score ??
        item?.max_points ??
        item?.total_points ??
        null
      );
    });
    const homeworkGradeValue = computed(() => {
      const submission = homeworkSubmissionData.value;
      const raw =
        submission?.grade ??
        submission?.score ??
        submission?.points ??
        submission?.result ??
        selectedHomework.value?.submission_score ??
        selectedHomework.value?.score ??
        selectedHomework.value?.grade ??
        null;
      return raw === "" ? null : raw;
    });
    const homeworkGradedAt = computed(() => {
      const submission = homeworkSubmissionData.value;
      return (
        submission?.graded_at ??
        submission?.gradedAt ??
        selectedHomework.value?.graded_at ??
        selectedHomework.value?.gradedAt ??
        null
      );
    });
    const homeworkIsGraded = computed(() => {
      if (
        homeworkGradeValue.value !== null &&
        homeworkGradeValue.value !== undefined
      )
        return true;
      if (toValidDate(homeworkGradedAt.value)) return true;
      const status = homeworkSubmissionStatus.value;
      return status ? ["graded", "reviewed"].includes(status) : false;
    });
    const homeworkEditingBlocked = computed(
      () =>
        homeworkIsGraded.value ||
        homeworkSubmissionBlocked.value ||
        homeworkSubmissionStatus.value === "needs_revision"
    );
    const homeworkEditingBlockedLabel = computed(() => {
      if (homeworkIsGraded.value) {
        return "Работа проверена. Изменения недоступны.";
      }
      if (homeworkSubmissionStatus.value === "needs_revision") {
        return 'Ответ отправлен на доработку. Используйте блок "Исправленное задание".';
      }
      if (homeworkSubmissionBlocked.value) {
        return "Прием работ закрыт. Опоздание не допускается.";
      }
      return "";
    });
    const homeworkRevisionEditingBlocked = computed(
      () => homeworkIsGraded.value
    );
    const homeworkAnswerStateLabel = computed(() => {
      if (homeworkSubmissionStatus.value === "needs_revision") {
        return "Требуется доработка";
      }
      if (homeworkHasSubmission.value) {
        return "Отправлено для оценивания";
      }
      if (homeworkSubmissionBlocked.value || homeworkIsLate.value) {
        return "Срок истек";
      }
      return "Не отправлено";
    });
    const homeworkGradingStateLabel = computed(() => {
      if (homeworkSubmissionStatus.value === "needs_revision") {
        return "На доработке";
      }
      return homeworkIsGraded.value ? "Оценено" : "Нет оценки";
    });
    const homeworkTimingLabel = computed(() => {
      if (!homeworkDueAt.value) return "Срок не задан";
      if (homeworkHasSubmission.value) {
        if (homeworkLateLabel.value) {
          return `Ответ представлен с опозданием — ${homeworkLateLabel.value}`;
        }
        return "Ответ представлен вовремя";
      }
      const diff = homeworkDueAt.value.getTime() - now.value.getTime();
      if (diff > 0) return `Осталось: ${formatLateDuration(diff)}`;
      return "Срок сдачи истек";
    });
    const homeworkTimingRowClass = computed(() => {
      if (homeworkHasSubmission.value && homeworkLateLabel.value) {
        return "homework-status-row--late";
      }
      if (homeworkHasSubmission.value && homeworkDueAt.value) {
        return "homework-status-row--on-time";
      }
      return "";
    });
    const homeworkLastChangeAt = computed(() => {
      const submission = homeworkSubmissionData.value;
      return (
        submission?.revision_submitted_at ??
        submission?.revisionSubmittedAt ??
        submission?.updated_at ??
        submission?.updatedAt ??
        submission?.submitted_at ??
        submission?.submittedAt ??
        submission?.created_at ??
        submission?.createdAt ??
        lastHomeworkSubmissionAt.value ??
        null
      );
    });
    const homeworkLastChangeLabel = computed(() => {
      const label = formatHomeworkDateTimeLong(homeworkLastChangeAt.value);
      return label || "—";
    });
    const homeworkSubmittedFiles = computed(() => {
      const submission = homeworkSubmissionData.value;
      if (!submission) return [];
      return normalizeSubmissionFiles(
        submission?.files ??
          submission?.attachments ??
          submission?.files_list ??
          submission?.filesList ??
          submission?.uploads ??
          []
      );
    });
    const homeworkRevisionRequestText = computed(() => {
      const submission = homeworkSubmissionData.value;
      const raw =
        submission?.revision_request_text ??
        submission?.revisionRequestText ??
        submission?.revision_request_comment ??
        "";
      return String(raw ?? "").trim();
    });
    const homeworkRevisionRequestFiles = computed(() => {
      const submission = homeworkSubmissionData.value;
      if (!submission) return [];
      return normalizeSubmissionFiles(
        submission?.revision_request_files ??
          submission?.revisionRequestFiles ??
          []
      );
    });
    const homeworkRevisionRequestedAt = computed(() => {
      const submission = homeworkSubmissionData.value;
      return (
        submission?.revision_requested_at ??
        submission?.revisionRequestedAt ??
        null
      );
    });
    const homeworkRevisionSubmissionText = computed(() => {
      const submission = homeworkSubmissionData.value;
      const raw =
        submission?.revision_submission_text ??
        submission?.revisionSubmissionText ??
        "";
      return String(raw ?? "").trim();
    });
    const homeworkRevisionSubmissionFiles = computed(() => {
      const submission = homeworkSubmissionData.value;
      if (!submission) return [];
      return normalizeSubmissionFiles(
        submission?.revision_submission_files ??
          submission?.revisionSubmissionFiles ??
          []
      );
    });
    const homeworkRevisionSubmittedAt = computed(() => {
      const submission = homeworkSubmissionData.value;
      return (
        submission?.revision_submitted_at ??
        submission?.revisionSubmittedAt ??
        null
      );
    });
    const homeworkRevisionHasSubmission = computed(
      () =>
        Boolean(homeworkRevisionSubmissionText.value) ||
        homeworkRevisionSubmissionFiles.value.length > 0
    );
    const homeworkAnswerFiles = computed(() => {
      const source = homeworkSubmittedFiles.value.length
        ? homeworkSubmittedFiles.value
        : homeworkExistingFiles.value;
      return source
        .map((file, index) => ({
          key: `${getHomeworkSubmissionFileName(file) || "file"}-${index}`,
          name: getHomeworkSubmissionFileName(file),
          url: getHomeworkSubmissionFileUrl(file),
        }))
        .filter((file) => file.name);
    });
    const homeworkSubmittedComment = computed(() => {
      const submission = homeworkSubmissionData.value;
      const raw =
        submission?.submission_text ??
        submission?.submissionText ??
        submission?.answer ??
        selectedHomework.value?.submission_text ??
        selectedHomework.value?.submissionText ??
        "";
      return String(raw ?? "").trim();
    });
    const homeworkCommentText = computed(() =>
      (homeworkCommentSaved.value || homeworkSubmittedComment.value).trim()
    );
    const homeworkCommentsCount = computed(() => {
      const submission = homeworkSubmissionData.value;
      const raw =
        submission?.comments_count ??
        submission?.commentsCount ??
        submission?.comments?.length ??
        0;
      const count = Number(raw) || 0;
      const commentCount = homeworkCommentText.value ? 1 : 0;
      return Math.max(count, commentCount);
    });
    const homeworkGradeLabel = computed(() => {
      if (!homeworkIsGraded.value) return "Нет оценки";
      const grade = formatScoreValue(homeworkGradeValue.value);
      const maxScore = formatScoreValue(homeworkMaxScoreValue.value);
      if (grade && maxScore) return `${grade} / ${maxScore}`;
      return grade || maxScore || "Нет оценки";
    });
    const homeworkFeedbackValue = computed(() => {
      const submission = homeworkSubmissionData.value;
      const raw =
        submission?.feedback ??
        submission?.review ??
        submission?.comment ??
        selectedHomework.value?.feedback ??
        selectedHomework.value?.review ??
        "";
      return String(raw ?? "").trim();
    });
    const homeworkFeedbackLabel = computed(() => {
      if (!homeworkIsGraded.value) return "Нет отзыва";
      return homeworkFeedbackValue.value || "Нет отзыва";
    });
    const homeworkGradedAtLabel = computed(() => {
      const label = formatHomeworkDateTimeLong(homeworkGradedAt.value);
      return label || "—";
    });
    const canSubmitHomework = computed(
      () =>
        homeworkFiles.value.length > 0 ||
        homeworkExistingFiles.value.length > 0 ||
        (homeworkHasSubmission.value && isHomeworkUploadExpanded.value)
    );
    const homeworkSubmitButtonLabel = computed(() => {
      if (isSubmittingHomework.value) return "Отправка...";
      if (homeworkHasSubmission.value && !homeworkFiles.value.length) {
        return "Сохранить изменения";
      }
      return "Отправить задание";
    });

    const resetHomeworkUploadState = () => {
      homeworkSubmissionError.value = "";
      homeworkSubmissionSuccess.value = false;
    };

    const openHomeworkCommentModal = () => {
      homeworkCommentDraft.value = homeworkCommentText.value;
      homeworkCommentModalOpen.value = true;
    };

    const closeHomeworkCommentModal = () => {
      homeworkCommentModalOpen.value = false;
    };

    const saveHomeworkComment = () => {
      const homeworkId = getHomeworkId(selectedHomework.value);
      const nextComment = homeworkCommentDraft.value.trim();
      homeworkCommentSaved.value = nextComment;
      if (homeworkId) {
        homeworkCommentCache.value = {
          ...homeworkCommentCache.value,
          [homeworkId]: nextComment,
        };
      }
      homeworkCommentModalOpen.value = false;
    };

    const setBodyScrollLocked = (locked) => {
      if (typeof document === "undefined") return;
      const overflowValue = locked ? "hidden" : "";
      document.body.style.overflow = overflowValue;
      document.documentElement.style.overflow = overflowValue;
    };

    watch(homeworkCommentModalOpen, (value) => {
      setBodyScrollLocked(value);
    });

    const expandHomeworkUpload = () => {
      if (homeworkEditingBlocked.value) return;
      homeworkSubmissionError.value = "";
      isHomeworkUploadExpanded.value = true;
    };

    const cancelHomeworkUpload = () => {
      homeworkSubmissionError.value = "";
      homeworkFiles.value = [];
      if (homeworkFileInput.value) {
        homeworkFileInput.value.value = "";
      }
      const homeworkId = getHomeworkId(selectedHomework.value);
      const cached = homeworkId
        ? homeworkSubmissionCache.value[homeworkId]
        : null;
      if (cached) {
        applyHomeworkSubmission(homeworkId, cached.submission);
        return;
      }
      isHomeworkUploadExpanded.value = false;
      homeworkExistingFiles.value = [];
      homeworkSubmissionSuccess.value = false;
      lastHomeworkSubmissionAt.value = null;
      homeworkSubmissionData.value = null;
    };

    const openHomeworkFileDialog = () => {
      if (homeworkEditingBlocked.value) return;
      homeworkFileInput.value?.click();
    };

    const addHomeworkFiles = (files) => {
      if (homeworkEditingBlocked.value) return;
      const list = Array.from(files || []);
      if (!list.length) return;
      resetHomeworkUploadState();
      isHomeworkUploadExpanded.value = true;
      const existing = new Set(
        homeworkFiles.value.map(
          (file) => `${file.name}_${file.size}_${file.lastModified}`
        )
      );
      list.forEach((file) => {
        const key = `${file.name}_${file.size}_${file.lastModified}`;
        if (!existing.has(key)) {
          existing.add(key);
          homeworkFiles.value.push(file);
        }
      });
    };

    const onHomeworkFileChange = (event) => {
      addHomeworkFiles(event.target?.files);
      if (event.target) {
        event.target.value = "";
      }
    };

    const onHomeworkDragOver = () => {
      if (homeworkEditingBlocked.value) return;
      isHomeworkDragging.value = true;
    };

    const onHomeworkDragLeave = () => {
      isHomeworkDragging.value = false;
    };

    const onHomeworkDrop = (event) => {
      if (homeworkEditingBlocked.value) return;
      isHomeworkDragging.value = false;
      addHomeworkFiles(event.dataTransfer?.files);
    };

    const removeHomeworkFile = (index) => {
      if (homeworkEditingBlocked.value) return;
      homeworkFiles.value.splice(index, 1);
    };

    const removeHomeworkExistingFile = (index) => {
      if (homeworkEditingBlocked.value) return;
      homeworkExistingFiles.value.splice(index, 1);
      resetHomeworkUploadState();
    };

    const applyHomeworkSubmission = (homeworkId, submission) => {
      const nextStatus = getHomeworkSubmissionStatus(submission);
      const nextGraded =
        Boolean(
          submission?.grade ??
            submission?.score ??
            submission?.points ??
            submission?.result ??
            null
        ) || (nextStatus ? ["graded", "reviewed"].includes(nextStatus) : false);

      const files = submission
        ? normalizeSubmissionFiles(
            submission?.files ??
              submission?.attachments ??
              submission?.files_list ??
              submission?.filesList ??
              submission?.uploads ??
              []
          )
        : [];
      const submittedAt = submission
        ? getHomeworkSubmissionDate(submission)
        : null;
      homeworkSubmissionSuccess.value = Boolean(submission);
      lastHomeworkSubmissionAt.value = submittedAt;
      homeworkExistingFiles.value = files;
      homeworkSubmissionData.value = submission || null;
      revisionExistingFiles.value = submission
        ? normalizeSubmissionFiles(
            submission?.revision_submission_files ??
              submission?.revisionSubmissionFiles ??
              []
          )
        : [];
      revisionText.value = submission
        ? String(
            submission?.revision_submission_text ??
              submission?.revisionSubmissionText ??
              ""
          ).trim()
        : "";
      revisionSubmissionError.value = "";
      const submissionComment = submission
        ? String(
            submission?.submission_text ??
              submission?.submissionText ??
              submission?.answer ??
              ""
          ).trim()
        : "";
      const cachedComment = homeworkId
        ? homeworkCommentCache.value[homeworkId]
        : "";
      const nextComment = submission ? submissionComment || cachedComment || "" : "";
      homeworkCommentSaved.value = nextComment;
      homeworkCommentDraft.value = nextComment;
      if (homeworkId) {
        if (submission) {
          homeworkCommentCache.value = {
            ...homeworkCommentCache.value,
            [homeworkId]: nextComment,
          };
        } else {
          const nextCommentCache = { ...homeworkCommentCache.value };
          delete nextCommentCache[homeworkId];
          homeworkCommentCache.value = nextCommentCache;
        }
      }
      isHomeworkUploadExpanded.value = false;
      if (submission) {
        homeworkSubmissionCache.value = {
          ...homeworkSubmissionCache.value,
          [homeworkId]: { submission, files, submittedAt },
        };
      } else if (homeworkId) {
        const nextSubmissionCache = { ...homeworkSubmissionCache.value };
        delete nextSubmissionCache[homeworkId];
        homeworkSubmissionCache.value = nextSubmissionCache;
      }
      updateModuleHomeworkProgress(homeworkId, submission);

      if (homeworkId) {
        homeworkStatusCache.value = {
          ...homeworkStatusCache.value,
          [homeworkId]: { status: nextStatus, graded: nextGraded },
        };
      }
    };

    const loadHomeworkSubmission = async () => {
      const requestId = ++homeworkSubmissionRequestId;
      const homeworkId = getHomeworkId(selectedHomework.value);
      if (!homeworkId || !homeworkService?.getMySubmissions) {
        if (requestId === homeworkSubmissionRequestId && !isUnmounted.value) {
          homeworkSubmissionSuccess.value = false;
          lastHomeworkSubmissionAt.value = null;
          homeworkExistingFiles.value = [];
          homeworkSubmissionData.value = null;
        }
        return;
      }

      const cached = homeworkSubmissionCache.value[homeworkId];
      if (cached) {
        applyHomeworkSubmission(homeworkId, cached.submission);
      }

      try {
        const submission = await homeworkService.getMySubmissions(homeworkId);
        if (requestId !== homeworkSubmissionRequestId || isUnmounted.value)
          return;
        applyHomeworkSubmission(homeworkId, submission);
      } catch (error) {
        if (requestId !== homeworkSubmissionRequestId || isUnmounted.value)
          return;
        console.warn("Failed to load homework submission:", error);
        if (cached) {
          applyHomeworkSubmission(homeworkId, cached.submission);
        } else {
          homeworkSubmissionSuccess.value = false;
          homeworkSubmissionData.value = null;
        }
      }
    };

    const submitHomework = async () => {
      resetHomeworkUploadState();
      if (homeworkEditingBlocked.value) {
        homeworkSubmissionError.value = homeworkEditingBlockedLabel.value;
        return;
      }
      const homeworkId = getHomeworkId(selectedHomework.value);
      if (!homeworkId) {
        homeworkSubmissionError.value = "Не удалось определить задание.";
        return;
      }
      if (!canSubmitHomework.value) {
        homeworkSubmissionError.value =
          "Добавьте файлы или оставьте уже отправленные.";
        return;
      }
      isSubmittingHomework.value = true;
      try {
        const submission = await homeworkService.submit(homeworkId, {
          submissionText: homeworkCommentSaved.value.trim(),
          files: homeworkFiles.value,
          existingFiles: homeworkExistingFiles.value,
        });
        homeworkSubmissionSuccess.value = Boolean(submission);
        lastHomeworkSubmissionAt.value = submission
          ? getHomeworkSubmissionDate(submission) || new Date()
          : null;
        if (submission) {
          updateModuleHomeworkProgress(homeworkId, submission);
        }
        homeworkFiles.value = [];
        if (homeworkFileInput.value) {
          homeworkFileInput.value.value = "";
        }
        await loadHomeworkSubmission();
      } catch (error) {
        console.warn("Ошибка отправки домашнего задания:", error);
        const serverMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          "";
        homeworkSubmissionError.value =
          serverMessage ||
          "Не удалось отправить задание. Проверьте формат файла: .py не поддерживается.";
      } finally {
        isSubmittingHomework.value = false;
      }
    };

    const canSubmitRevision = computed(() => {
      return (
        Boolean(revisionText.value.trim()) ||
        revisionFiles.value.length > 0 ||
        revisionExistingFiles.value.length > 0
      );
    });

    const openRevisionFileDialog = () => {
      if (homeworkRevisionEditingBlocked.value) return;
      revisionFileInput.value?.click();
    };

    const addRevisionFiles = (files) => {
      if (homeworkRevisionEditingBlocked.value) return;
      const list = Array.from(files || []);
      if (!list.length) return;
      const existing = new Set(
        revisionFiles.value.map(
          (file) => `${file.name}_${file.size}_${file.lastModified}`
        )
      );
      list.forEach((file) => {
        const key = `${file.name}_${file.size}_${file.lastModified}`;
        if (!existing.has(key)) {
          existing.add(key);
          revisionFiles.value.push(file);
        }
      });
    };

    const onRevisionFileChange = (event) => {
      addRevisionFiles(event.target?.files);
      if (event.target) {
        event.target.value = "";
      }
    };

    const onRevisionDragOver = () => {
      if (homeworkRevisionEditingBlocked.value) return;
      isRevisionDragging.value = true;
    };

    const onRevisionDragLeave = () => {
      isRevisionDragging.value = false;
    };

    const onRevisionDrop = (event) => {
      if (homeworkRevisionEditingBlocked.value) return;
      isRevisionDragging.value = false;
      addRevisionFiles(event.dataTransfer?.files);
    };

    const removeRevisionFile = (index) => {
      if (homeworkRevisionEditingBlocked.value) return;
      revisionFiles.value.splice(index, 1);
    };

    const removeRevisionExistingFile = (index) => {
      if (homeworkRevisionEditingBlocked.value) return;
      revisionExistingFiles.value.splice(index, 1);
    };

    const submitRevision = async () => {
      revisionSubmissionError.value = "";
      if (homeworkRevisionEditingBlocked.value) {
        revisionSubmissionError.value =
          "Работа уже оценена. Доработка недоступна.";
        return;
      }
      if (!homeworkRevisionRequested.value) {
        revisionSubmissionError.value = "Доработка не запрошена.";
        return;
      }
      const homeworkId = getHomeworkId(selectedHomework.value);
      if (!homeworkId) {
        revisionSubmissionError.value = "Не удалось определить задание.";
        return;
      }
      if (!canSubmitRevision.value) {
        revisionSubmissionError.value = "Добавьте текст или файлы исправления.";
        return;
      }
      isSubmittingRevision.value = true;
      try {
        const submission = await homeworkService.submitRevision(homeworkId, {
          text: revisionText.value.trim(),
          files: revisionFiles.value,
          existingFiles: revisionExistingFiles.value,
        });
        revisionFiles.value = [];
        revisionSubmissionError.value = "";
        await loadHomeworkSubmission();
        if (submission) {
          updateModuleHomeworkProgress(homeworkId, submission);
        }
        appStore.addNotification({
          type: "success",
          title: "Домашнее задание",
          message: "Исправленное задание отправлено преподавателю.",
          duration: 6000,
        });
      } catch (error) {
        console.warn("Ошибка отправки исправленного задания:", error);
        revisionSubmissionError.value =
          "Не удалось отправить исправленное задание.";
      } finally {
        isSubmittingRevision.value = false;
      }
    };

    watch(
      selectedHomework,
      (curr, prev) => {
        const currId = getHomeworkId(curr);
        const prevId = getHomeworkId(prev);
        // Избегаем рекурсии: если ID не поменялся, не дергаем загрузку повторно
        if (prev !== undefined && currId === prevId) return;
        homeworkFiles.value = [];
        isHomeworkUploadExpanded.value = false;
        resetHomeworkUploadState();
        revisionFiles.value = [];
        revisionExistingFiles.value = [];
        revisionText.value = "";
        revisionSubmissionError.value = "";
        isRevisionDragging.value = false;
        if (homeworkFileInput.value) {
          homeworkFileInput.value.value = "";
        }
        if (revisionFileInput.value) {
          revisionFileInput.value.value = "";
        }
        const cachedComment = currId
          ? homeworkCommentCache.value[currId] || ""
          : "";
        homeworkCommentSaved.value = cachedComment;
        homeworkCommentDraft.value = cachedComment;
        homeworkCommentModalOpen.value = false;
        const homeworkId = currId;
        const cached = homeworkId
          ? homeworkSubmissionCache.value[homeworkId]
          : null;
        if (cached) {
          applyHomeworkSubmission(homeworkId, cached.submission);
        } else {
          homeworkSubmissionSuccess.value = false;
          lastHomeworkSubmissionAt.value = null;
          homeworkExistingFiles.value = [];
          homeworkSubmissionData.value = null;
        }
        loadHomeworkSubmission();
      },
      { immediate: true }
    );

    const getHomeworkListText = (item) => {
      if (!item) return "";
      if (typeof item === "string") return item;
      return (
        item?.title ||
        item?.text ||
        item?.description ||
        item?.name ||
        item?.file_name ||
        item?.fileName ||
        item?.url ||
        item?.file_path ||
        ""
      );
    };

    const getHomeworkMaterialLink = (item) => {
      return getMaterialLink(item);
    };

    const homeworkIcons = computed(() =>
      [props.text385, props.text384, props.text383].filter(Boolean)
    );

    const getHomeworkIcon = (index) =>
      homeworkIcons.value[index] ||
      props.text385 ||
      props.text384 ||
      props.text383 ||
      "";

    const homeworkFallbackImages = computed(() =>
      [props.image7, props.image8, props.image9].filter(Boolean)
    );

    const getHomeworkImage = (item, index) =>
      item?.cover_image ||
      item?.cover_image_url ||
      item?.preview_image ||
      item?.image ||
      homeworkFallbackImages.value[index] ||
      homeworkFallbackImages.value[0] ||
      props.image7 ||
      props.image8 ||
      props.image9;

    const getHomeworkCardClassName = (item, index, baseClasses = []) => {
      const classes = Array.isArray(baseClasses) ? baseClasses : [baseClasses];
      if (isHomeworkSelected(item, index)) {
        classes.push("lesson-card-active");
      } else {
        classes.push("lesson-card-inactive");
      }
      return classes.filter(Boolean).join(" ");
    };

    const selectHomework = (item, index) => {
      selectedHomeworkKey.value = getHomeworkKey(item, index);
      contentMode.value = "homework";
      scheduleScrollPageToTop();
    };
    const selectHomeworkMobile = (item, index) => {
      selectHomework(item, index);
      if (isMobileViewport()) {
        closeSidebar();
      }
    };

    // Автоматический выбор ДЗ при переходе с главной страницы
    watch(
      [() => moduleData.value, homeworkIdFromQuery, sectionFromQuery],
      ([data, hwId, section]) => {
        if (!data) return;
        // Если указан section=homework и homeworkId
        if (section === "homework" && hwId) {
          const homework = moduleHomework.value;
          const index = homework.findIndex(
            (hw) => (hw.id ?? hw._id ?? hw.homework_id) == hwId
          );
          if (index !== -1) {
            selectHomework(homework[index], index);
          }
        }
      },
      { immediate: true }
    );

    const lessonTitles = computed(() =>
      moduleLessons.value.map((lesson) => getItemTitle(lesson, ""))
    );
    const testTitles = computed(() =>
      moduleTests.value.map((test) => getItemTitle(test, ""))
    );
    const practiceTitles = computed(() =>
      modulePractice.value.map((item) => getItemTitle(item, ""))
    );
    const homeworkTitles = computed(() =>
      moduleHomework.value.map((item) => getItemTitle(item, ""))
    );

    const currentLesson = computed(() => selectedLesson.value);

    const normalizeVideoSource = (source) => {
      if (!source) return "";
      if (typeof source === "string") {
        return normalizeFileUrl(source);
      }
      return getMaterialLink(source);
    };

    const getVideoCandidate = (lesson) => {
      if (!lesson) return null;
      return (
        lesson?.video_url ||
        lesson?.videoUrl ||
        lesson?.video_link ||
        lesson?.videoLink ||
        lesson?.video_file_url ||
        lesson?.videoFileUrl ||
        lesson?.video_file_path ||
        lesson?.videoFilePath ||
        lesson?.video_path ||
        lesson?.videoPath ||
        lesson?.video_file ||
        lesson?.videoFile ||
        lesson?.video ||
        lesson?.file ||
        lesson?.file_path ||
        lesson?.filePath ||
        null
      );
    };

    const getVideoCandidateUrl = (candidate) => {
      if (!candidate) return "";
      if (typeof candidate === "string") return candidate;
      return (
        candidate?.url ||
        candidate?.file_url ||
        candidate?.fileUrl ||
        candidate?.link ||
        candidate?.href ||
        candidate?.path ||
        candidate?.file_path ||
        candidate?.filePath ||
        ""
      );
    };

    const videoCandidate = computed(() =>
      getVideoCandidate(currentLesson.value)
    );
    const videoCandidateUrl = computed(() =>
      getVideoCandidateUrl(videoCandidate.value)
    );
    const isYouTubeVideo = computed(() =>
      isYouTubeUrl(videoCandidateUrl.value)
    );
    const youtubeEmbedUrl = computed(() =>
      isYouTubeVideo.value ? getYouTubeEmbedUrl(videoCandidateUrl.value) : ""
    );

    const videoSource = computed(() => {
      return normalizeVideoSource(videoCandidate.value);
    });

    const view2 = computed(() => {
      const lesson = currentLesson.value;
      return (
        lesson?.cover_image ||
        lesson?.cover_image_url ||
        lesson?.preview_image ||
        moduleData.value?.cover_image ||
        moduleData.value?.cover_image_url ||
        props.view2
      );
    });

    const x011 = computed(() => {
      const lesson = currentLesson.value;
      const docName =
        lesson?.doc_file_name ||
        lesson?.docFile?.file_name ||
        lesson?.docFile?.name;
      const material = lesson?.materials?.[0];
      const materialName =
        material?.name || material?.title || material?.file_name;
      return docName || materialName || props.x011;
    });

    const x013 = computed(() => getItemTitle(currentLesson.value, props.x013));

    const lessonCard1Title = computed(() => lessonTitles.value[0] || "");
    const x014 = computed(() => lessonTitles.value[2] || props.x014);
    const x272Props = computed(() => ({
      ...(props.x272Props || {}),
      x01: lessonTitles.value[1] || props.x272Props?.x01,
    }));

    const view702Props = computed(() => ({
      ...(props.view702Props || {}),
      x01: lessonTitles.value[3] || props.view702Props?.x01,
    }));

    const x5331Props = computed(() => ({
      ...(props.x5331Props || {}),
      x01: lessonTitles.value[4] || props.x5331Props?.x01,
    }));
    const x61Props = computed(() => ({
      ...(props.x61Props || {}),
      view70Props: {
        ...(props.x61Props?.view70Props || {}),
        x01: lessonTitles.value[5] || props.x61Props?.view70Props?.x01,
      },
    }));
    const x5332Props = computed(() => ({
      ...(props.x5332Props || {}),
      x01: lessonTitles.value[6] || props.x5332Props?.x01,
    }));
    const x62Props = computed(() => ({
      ...(props.x62Props || {}),
      view70Props: {
        ...(props.x62Props?.view70Props || {}),
        x01: lessonTitles.value[7] || props.x62Props?.view70Props?.x01,
      },
    }));
    const x63Props = computed(() => ({
      ...(props.x63Props || {}),
      view70Props: {
        ...(props.x63Props?.view70Props || {}),
        x01: lessonTitles.value[8] || props.x63Props?.view70Props?.x01,
      },
    }));
    const x5333Props = computed(() => ({
      ...(props.x5333Props || {}),
      x01: lessonTitles.value[9] || props.x5333Props?.x01,
    }));

    const x015 = computed(() => practiceTitles.value[0] || props.x015);
    const x016 = computed(() => practiceTitles.value[1] || props.x016);
    const x017 = computed(() => practiceTitles.value[2] || props.x017);

    const x018 = computed(() => testTitles.value[0] || props.x018);
    const x2821Props = computed(() => ({
      ...(props.x2821Props || {}),
      x01: testTitles.value[1] || props.x2821Props?.x01,
    }));
    const x2822Props = computed(() => ({
      ...(props.x2822Props || {}),
      x01: testTitles.value[2] || props.x2822Props?.x01,
    }));

    const x019 = computed(() => homeworkTitles.value[0] || props.x019);
    const x0110 = computed(() => homeworkTitles.value[1] || props.x0110);
    const x0111 = computed(() => homeworkTitles.value[2] || props.x0111);

    // Инициализация состояния чата с восстановлением из localStorage
    const getChatStateFromStorage = () => {
      if (typeof window === "undefined" || !window.localStorage) {
        return true;
      }
      try {
        const saved = localStorage.getItem("chatCollapsed");
        return saved ? JSON.parse(saved) : true;
      } catch (error) {
        console.warn(
          "Ошибка при чтении состояния чата из localStorage:",
          error
        );
        return true;
      }
    };

    const chatBlock = useCollapsible(getChatStateFromStorage());

    // Состояние переключения контента
    const contentMode = ref("video");

    // Функция для сохранения состояния чата в localStorage с debounce
    const saveChatStateToStorage = debounce((isExpanded) => {
      if (typeof window === "undefined" || !window.localStorage) {
        return;
      }
      try {
        localStorage.setItem("chatCollapsed", JSON.stringify(isExpanded));
      } catch (error) {
        console.warn(
          "Ошибка при сохранении состояния чата в localStorage:",
          error
        );
      }
    }, 300);

    watch(
      sortedLessons,
      (lessons) => {
        if (!lessons.length) {
          selectedLessonKey.value = null;
          return;
        }
        const existing = lessons.find(
          (lesson, index) =>
            getLessonKey(lesson, index) === selectedLessonKey.value
        );
        if (existing) {
          if (
            contentMode.value === "video" ||
            contentMode.value === "article"
          ) {
            contentMode.value = isLessonArticle(existing) ? "article" : "video";
          }
          return;
        }
        const defaultLesson =
          lessons.find((lesson) => !isLessonCompleted(lesson)) || lessons[0];
        selectedLessonKey.value = getLessonKey(
          defaultLesson,
          lessons.indexOf(defaultLesson)
        );
        if (contentMode.value === "video" || contentMode.value === "article") {
          contentMode.value = isLessonArticle(defaultLesson)
            ? "article"
            : "video";
        }
      },
      { immediate: true }
    );
    watch(
      sortedPractice,
      (items) => {
        if (!items.length) {
          selectedPracticeKey.value = null;
          return;
        }
        const existing = items.find(
          (item, index) =>
            getPracticeKey(item, index) === selectedPracticeKey.value
        );
        if (existing) return;
        const defaultItem =
          items.find((item) => !isPracticeCompleted(item)) ||
          items[items.length - 1];
        selectedPracticeKey.value = getPracticeKey(
          defaultItem,
          items.indexOf(defaultItem)
        );
      },
      { immediate: true }
    );
    watch(
      sortedTests,
      (items) => {
        if (!items.length) {
          selectedTestKey.value = null;
          return;
        }
        const existing = items.find(
          (item, index) => getTestKey(item, index) === selectedTestKey.value
        );
        if (existing) return;
        const defaultItem =
          items.find((item) => !isTestCompleted(item)) ||
          items[items.length - 1];
        selectedTestKey.value = getTestKey(
          defaultItem,
          items.indexOf(defaultItem)
        );
      },
      { immediate: true }
    );
    watch(
      sortedHomework,
      (items) => {
        if (!items.length) {
          selectedHomeworkKey.value = null;
          return;
        }
        const existing = items.find(
          (item, index) =>
            getHomeworkKey(item, index) === selectedHomeworkKey.value
        );
        if (existing) return;
        const defaultItem =
          items.find((item) => !isHomeworkCompleted(item)) ||
          items[items.length - 1];
        selectedHomeworkKey.value = getHomeworkKey(
          defaultItem,
          items.indexOf(defaultItem)
        );
      },
      { immediate: true }
    );
    watch(
      [sortedLessons, sortedPractice, sortedTests, sortedHomework],
      ([lessons, practice, tests, homework]) => {
        if (lessons.length) return;
        if (contentMode.value !== "video" && contentMode.value !== "article")
          return;
        const nextMode = practice.length
          ? "practice"
          : tests.length
          ? "test"
          : homework.length
          ? "homework"
          : null;
        if (nextMode) {
          contentMode.value = nextMode;
        }
      },
      { immediate: true }
    );

    const onSidebarLessonSelect = (value) => {
      const lessonIndex = sortedLessons.value.findIndex(
        (lesson, index) => getLessonKey(lesson, index) === value
      );
      if (lessonIndex !== -1) {
        selectLessonMobile(sortedLessons.value[lessonIndex], lessonIndex);
        return;
      }
      selectedLessonKey.value = value;
      if (isMobileViewport()) {
        closeSidebar();
      }
    };

    const onSidebarPracticeSelect = (value) => {
      const practiceIndex = sortedPractice.value.findIndex(
        (item, index) => getPracticeKey(item, index) === value
      );
      if (practiceIndex !== -1) {
        selectPracticeMobile(
          sortedPractice.value[practiceIndex],
          practiceIndex
        );
        return;
      }
      selectedPracticeKey.value = value;
      if (isMobileViewport()) {
        closeSidebar();
      }
    };

    const onSidebarTestSelect = (value) => {
      const testIndex = sortedTests.value.findIndex(
        (test, index) => getTestKey(test, index) === value
      );
      if (testIndex !== -1) {
        selectTestMobile(sortedTests.value[testIndex], testIndex);
        return;
      }
      selectedTestKey.value = value;
      if (isMobileViewport()) {
        closeSidebar();
      }
    };

    const onSidebarHomeworkSelect = (value) => {
      const homeworkIndex = sortedHomework.value.findIndex(
        (item, index) => getHomeworkKey(item, index) === value
      );
      if (homeworkIndex !== -1) {
        selectHomeworkMobile(
          sortedHomework.value[homeworkIndex],
          homeworkIndex
        );
        return;
      }
      selectedHomeworkKey.value = value;
      if (isMobileViewport()) {
        closeSidebar();
      }
    };

    // Переопределяем toggle для чата с сохранением в localStorage
    const toggleChat = () => {
      chatBlock.toggle();
      saveChatStateToStorage(chatBlock.isExpanded.value);
    };

    // Вычисляемые свойства для позиций блоков с использованием констант
    const lessonsExpandedHeight = computed(() => {
      const count = sortedLessons.value.length || 1;
      return (
        BLOCK_DIMENSIONS.LESSONS_BLOCK.HEADER_HEIGHT +
        BLOCK_DIMENSIONS.LESSONS_BLOCK.EXTRA_PADDING +
        count * BLOCK_DIMENSIONS.LESSON_CARD.HEIGHT +
        Math.max(0, count - 1) * BLOCK_DIMENSIONS.LESSON_CARD.GAP
      );
    });

    const practiceExpandedHeight = computed(() => {
      const count = sortedPractice.value.length || 3;
      return (
        BLOCK_DIMENSIONS.PRACTICE_BLOCK.HEADER_HEIGHT +
        BLOCK_DIMENSIONS.PRACTICE_BLOCK.EXTRA_PADDING +
        count * BLOCK_DIMENSIONS.PRACTICE_CARD.HEIGHT +
        Math.max(0, count - 1) * BLOCK_DIMENSIONS.PRACTICE_CARD.GAP
      );
    });

    const testsExpandedHeight = computed(() => {
      const count = sortedTests.value.length || 1;
      return (
        BLOCK_DIMENSIONS.TESTS_BLOCK.HEADER_HEIGHT +
        BLOCK_DIMENSIONS.TESTS_BLOCK.EXTRA_PADDING +
        count * BLOCK_DIMENSIONS.TESTS_CARD.HEIGHT +
        Math.max(0, count - 1) * BLOCK_DIMENSIONS.TESTS_CARD.GAP
      );
    });

    // Блок "Уроки" - всегда на фиксированной позиции
    const lessonsBlockTop = computed(() => {
      return BLOCK_DIMENSIONS.MARGINS.LESSONS_TOP;
    });

    // Блок "Практика" - зависит от состояния блока "Уроки"
    const practiceBlockTop = computed(() => {
      const lessonsHeight = lessonsBlock.isExpanded.value
        ? lessonsExpandedHeight.value
        : BLOCK_DIMENSIONS.LESSONS_BLOCK.COLLAPSED_HEIGHT;
      return (
        BLOCK_DIMENSIONS.MARGINS.LESSONS_TOP +
        lessonsHeight +
        BLOCK_DIMENSIONS.MARGINS.PRACTICE
      );
    });

    // Блок "Тесты" - зависит от состояния блоков "Уроки" и "Практика"
    const testsBlockTop = computed(() => {
      const practiceHeight = practiceBlock.isExpanded.value
        ? practiceExpandedHeight.value
        : BLOCK_DIMENSIONS.PRACTICE_BLOCK.COLLAPSED_HEIGHT;
      return (
        practiceBlockTop.value + practiceHeight + BLOCK_DIMENSIONS.MARGINS.TESTS
      );
    });

    // Блок "Домашнее задание" - зависит от состояния всех трех блоков выше
    const homeworkBlockTop = computed(() => {
      const testsHeight = testsBlock.isExpanded.value
        ? testsExpandedHeight.value
        : BLOCK_DIMENSIONS.TESTS_BLOCK.COLLAPSED_HEIGHT;
      return (
        testsBlockTop.value + testsHeight + BLOCK_DIMENSIONS.MARGINS.HOMEWORK
      );
    });

    // Transition hooks для плавной анимации контента
    const enter = (element) => {
      element.style.height = "0";
      element.style.opacity = "0";
      element.offsetHeight;
      const contentHeight = element.scrollHeight;
      element.style.height = `${contentHeight}px`;
      element.style.opacity = "1";
    };

    const afterEnter = (element) => {
      element.style.height = "auto";
    };

    const leave = (element) => {
      element.style.height = `${element.scrollHeight}px`;
      element.offsetHeight;
      element.style.height = "0";
      element.style.opacity = "0";
    };

    // Логика радио-кнопок для карточек уроков
    const selectedLessonCard = ref("card3");

    const isCompleting = ref(false);
    const isCompletingPractice = ref(false);

    const selectLesson = (lesson, index) => {
      if (isLessonLocked(lesson, index)) return;
      selectedLessonKey.value = getLessonKey(lesson, index);
      contentMode.value = isLessonArticle(lesson) ? "article" : "video";
      scheduleScrollPageToTop();
    };
    const selectLessonMobile = (lesson, index) => {
      selectLesson(lesson, index);
      if (isMobileViewport()) {
        closeSidebar();
      }
    };
    const selectPractice = (item, index) => {
      if (isPracticeLocked(item, index)) return;
      selectedPracticeKey.value = getPracticeKey(item, index);
      contentMode.value = "practice";
      scheduleScrollPageToTop();
    };
    const selectPracticeMobile = (item, index) => {
      selectPractice(item, index);
      if (isMobileViewport()) {
        closeSidebar();
      }
    };

    const canCompletePractice = computed(() => {
      const practice = selectedPractice.value;
      return Boolean(practice && !isPracticeCompleted(practice));
    });

    const canCompleteLesson = computed(() => {
      const lesson = selectedLesson.value;
      return Boolean(lesson && !isLessonCompleted(lesson));
    });

    const updateLessonCompletion = (lesson) => {
      if (!moduleData.value?.lessons || !lesson) return;
      const lessonId = getLessonId(lesson);
      const lessons = moduleData.value.lessons.map((item) => {
        const isMatch = lessonId
          ? getLessonId(item) === lessonId
          : item === lesson;
        if (!isMatch) return item;
        return {
          ...item,
          is_completed: true,
          isCompleted: true,
          completed: true,
          status: "completed",
        };
      });
      moduleData.value = { ...moduleData.value, lessons };
    };

    const updatePracticeCompletion = (practice) => {
      if (!moduleData.value?.practice || !practice) return;
      const taskId = getPracticeId(practice);
      const practiceItems = moduleData.value.practice.map((item) => {
        const isMatch = taskId
          ? getPracticeId(item) === taskId
          : item === practice;
        if (!isMatch) return item;
        return {
          ...item,
          is_completed: true,
          isCompleted: true,
          completed: true,
          status: "completed",
          completion_percent: 100,
        };
      });
      moduleData.value = { ...moduleData.value, practice: practiceItems };
    };

    const markLessonCompleted = async () => {
      const lesson = selectedLesson.value;
      if (!lesson || isLessonCompleted(lesson) || isCompleting.value) return;
      isCompleting.value = true;
      const lessonId = getLessonId(lesson);
      let completedRemotely = false;
      let lastError = null;
      try {
        if (lessonId) {
          const attempts = [
            progressService?.markLessonComplete?.bind(progressService),
            lessonsService?.markAsCompleted?.bind(lessonsService),
            lessonsService?.markCompleted?.bind(lessonsService),
          ].filter(Boolean);
          for (const attempt of attempts) {
            try {
              await attempt(lessonId);
              completedRemotely = true;
              break;
            } catch (error) {
              lastError = error;
            }
          }
        }
      } catch (error) {
        lastError = error;
      } finally {
        isCompleting.value = false;
      }

      if (!completedRemotely) {
        if (lessonId) {
          console.warn("Failed to mark lesson as completed:", lastError);
          completionError.value =
            "Не удалось сохранить прогресс. Попробуйте ещё раз.";
          setTimeout(() => {
            completionError.value = null;
          }, 5000);
        }
        return;
      }

      updateLessonCompletion(lesson);
      loadModuleProgress();

      const nextLessonItem = sortedLessons.value.find(
        (item) => !isLessonCompleted(item)
      );
      if (nextLessonItem) {
        selectedLessonKey.value = getLessonKey(
          nextLessonItem,
          sortedLessons.value.indexOf(nextLessonItem)
        );
        if (contentMode.value === "video" || contentMode.value === "article") {
          contentMode.value = isLessonArticle(nextLessonItem)
            ? "article"
            : "video";
        }
        scheduleScrollPageToTop();
      }
    };

    const markPracticeCompleted = async () => {
      const practice = selectedPractice.value;
      if (
        !practice ||
        isPracticeCompleted(practice) ||
        isCompletingPractice.value
      )
        return;
      isCompletingPractice.value = true;
      const taskId = getPracticeId(practice);
      let completedRemotely = false;
      let lastError = null;
      try {
        if (taskId && practicalService?.markComplete) {
          await practicalService.markComplete(taskId);
          completedRemotely = true;
        }
      } catch (error) {
        lastError = error;
      } finally {
        isCompletingPractice.value = false;
      }

      if (!completedRemotely) {
        if (taskId) {
          console.warn("Failed to mark practice as completed:", lastError);
          completionError.value =
            "Не удалось сохранить прогресс. Попробуйте ещё раз.";
          setTimeout(() => {
            completionError.value = null;
          }, 5000);
        }
        return;
      }

      if (taskId) {
        savePracticeCompletionToStorage(taskId);
      }

      updatePracticeCompletion(practice);
      loadModuleProgress();

      const nextItem = sortedPractice.value.find(
        (item) => !isPracticeCompleted(item)
      );
      if (nextItem) {
        selectedPracticeKey.value = getPracticeKey(
          nextItem,
          sortedPractice.value.indexOf(nextItem)
        );
        scheduleScrollPageToTop();
      }
    };

    // Методы для работы с видео
    const startWatchTimer = () => {
      if (watchTimerId.value || typeof window === "undefined") return;
      const lesson = selectedLesson.value;
      if (!lesson || !isLessonVideo(lesson)) return;
      const lessonId = getLessonId(lesson);
      if (!lessonId || !progressService?.updateLessonProgress) return;
      trackedLessonId.value = lessonId;
      trackedLessonIsVideo.value = true;
      lastWatchAt.value = Date.now();
      watchTimerId.value = setInterval(() => {
        flushWatchTime(false);
      }, 15000);
    };

    const stopWatchTimer = ({ flush = true } = {}) => {
      if (watchTimerId.value) {
        clearInterval(watchTimerId.value);
        watchTimerId.value = null;
      }
      if (flush) {
        flushWatchTime(true);
      }
      lastWatchAt.value = null;
      trackedLessonId.value = null;
      trackedLessonIsVideo.value = false;
    };

    const flushWatchTime = async (force) => {
      if (isUnmounted.value) return;
      if (!trackedLessonId.value || !trackedLessonIsVideo.value) return;

      const now = Date.now();
      const last = lastWatchAt.value ?? now;
      const deltaSeconds = Math.floor((now - last) / 1000);
      lastWatchAt.value = now;

      const lastPositionSeconds = Math.floor(videoCurrentTime.value || 0);
      if (!force && !isVideoPlaying.value) return;
      if (deltaSeconds <= 0 && lastPositionSeconds <= 0) return;

      try {
        await progressService.updateLessonProgress(trackedLessonId.value, {
          secondsSpent: Math.max(0, deltaSeconds),
          lastPositionSeconds,
        });
      } catch (error) {
        console.warn("Failed to update lesson progress:", error);
      }
    };

    const resetVideoTracking = (flush = true) => {
      stopWatchTimer({ flush });
      isVideoPlaying.value = false;
      videoCurrentTime.value = 0;
      videoDuration.value = 0;
    };

    const onVideoLoadedMetadata = (duration) => {
      const numericDuration = Number(duration);
      if (Number.isFinite(numericDuration) && numericDuration > 0) {
        videoDuration.value = numericDuration;
      }
    };

    const onVideoTimeUpdate = (time, duration) => {
      const numericTime = Number(time);
      videoCurrentTime.value = Number.isFinite(numericTime) ? numericTime : 0;

      const numericDuration = Number(duration);
      if (Number.isFinite(numericDuration) && numericDuration > 0) {
        videoDuration.value = numericDuration;
      }
    };

    const onVideoPlay = () => {
      isVideoPlaying.value = true;
      startWatchTimer();
    };

    const onVideoPause = () => {
      isVideoPlaying.value = false;
      stopWatchTimer({ flush: true });
      stopTabTimer({ flush: true });
    };

    const onVideoEnded = () => {
      stopWatchTimer({ flush: true });
      stopTabTimer({ flush: true });
      if (canCompleteLesson.value) {
        markLessonCompleted();
      }
    };
    // Tab time tracking
    const getTabTrackingTarget = () => {
      const mode = contentMode.value;
      if (mode === "article") {
        const lesson = selectedLesson.value;
        const lessonId = getLessonId(lesson);
        if (!lessonId) return null;
        return { type: "lesson", id: lessonId, mode };
      }
      if (mode === "practice" || mode === "test" || mode === "homework") {
        const id = moduleId.value;
        if (!id) return null;
        return { type: "module", id, mode };
      }
      return null;
    };

    const startTabTimer = (target) => {
      if (!target || tabTimerId.value || typeof window === "undefined") return;
      tabTrackingType.value = target.type;
      tabTrackingId.value = target.id;
      tabTrackingMode.value = target.mode;
      tabLastActiveAt.value = Date.now();
      tabTimerId.value = setInterval(() => {
        flushTabTime();
      }, 15000);
    };

    const stopTabTimer = ({ flush = true } = {}) => {
      if (tabTimerId.value) {
        clearInterval(tabTimerId.value);
        tabTimerId.value = null;
      }
      if (flush) {
        flushTabTime();
      }
      tabLastActiveAt.value = null;
      tabTrackingType.value = null;
      tabTrackingId.value = null;
      tabTrackingMode.value = null;
    };

    const flushTabTime = async () => {
      if (!tabTrackingType.value || !tabTrackingId.value) return;

      const now = Date.now();
      const last = tabLastActiveAt.value ?? now;
      const deltaSeconds = Math.floor((now - last) / 1000);
      tabLastActiveAt.value = now;

      if (deltaSeconds <= 0) return;

      try {
        if (tabTrackingType.value === "lesson") {
          if (!progressService?.updateLessonProgress) return;
          await progressService.updateLessonProgress(tabTrackingId.value, {
            secondsSpent: Math.max(0, deltaSeconds),
            lastPositionSeconds: 0,
          });
          return;
        }
        if (tabTrackingType.value === "module") {
          if (!progressService?.updateModuleTime) return;
          await progressService.updateModuleTime(tabTrackingId.value, {
            secondsSpent: Math.max(0, deltaSeconds),
          });
        }
      } catch (error) {
        console.warn("Failed to update tab time:", error);
      }
    };

    const syncTabTracking = () => {
      const target = getTabTrackingTarget();
      if (!target) {
        stopTabTimer({ flush: true });
        return;
      }
      const isSame =
        tabTrackingType.value === target.type &&
        tabTrackingId.value === target.id &&
        tabTrackingMode.value === target.mode;
      if (!isSame) {
        stopTabTimer({ flush: true });
        startTabTimer(target);
        return;
      }
      if (!tabTimerId.value) {
        startTabTimer(target);
      }
    };

    // Методы навигации к следующему элементу
    const goToNextLesson = () => {
      if (nextLesson.value) {
        selectLesson(
          nextLesson.value,
          sortedLessons.value.indexOf(nextLesson.value)
        );
      }
    };

    const goToNextPractice = () => {
      if (nextPractice.value) {
        selectPractice(
          nextPractice.value,
          sortedPractice.value.indexOf(nextPractice.value)
        );
      }
    };

    const selectCard = (cardId) => {
      selectedLessonCard.value = cardId;
      if (cardId === "card3") {
        contentMode.value = "video";
      }
    };

    const switchToTestContent = () => {
      contentMode.value = "test";
    };

    const switchToHomeworkContent = () => {
      contentMode.value = "homework";
    };

    const switchToVideoContent = () => {
      const lesson = selectedLesson.value;
      contentMode.value =
        lesson && isLessonArticle(lesson) ? "article" : "video";
    };
    watch(selectedLessonKey, () => {
      isArticleInlineTocExpanded.value = false;
      isArticleTocOpen.value = false;
      closeBitrixYoutubeFullscreen();
      resetVideoTracking();
      syncTabTracking();
      scheduleScrollPageToTop();
    });

    watch(selectedPracticeKey, () => {
      scheduleScrollPageToTop();
    });

    watch(selectedTestKey, () => {
      scheduleScrollPageToTop();
    });

    watch(selectedHomeworkKey, () => {
      scheduleScrollPageToTop();
    });

    watch(
      contentMode,
      (mode) => {
        if (mode !== "video") {
          closeBitrixYoutubeFullscreen();
          resetVideoTracking();
        }
        syncTabTracking();
      },
      { immediate: true }
    );

    watch(videoSource, () => {
      resetVideoTracking();
    });

    watch(youtubeEmbedUrl, () => {
      closeBitrixYoutubeFullscreen();
    });

    watch(moduleId, () => {
      syncTabTracking();
    });

    return {
      backRoute,
      isLoading,
      isRefreshing,
      loadError,
      loadModule,
      refreshModuleData,
      hasNoModuleData,
      isSidebarOpen,
      toggleSidebar,
      closeSidebar,
      // Новые свойства
      isUnmounted,
      videoCurrentTime,
      videoDuration,
      videoProgress,
      moduleProgress,
      finalTestId,
      finalTestCapPercent,
      finalTestAccessAllowed,
      finalTestMissingItems,
      finalTestMissingGrades,
      finalTestWindowStatus,
      finalTestWindowStart,
      finalTestWindowEnd,
      showFinalTestCapHint,
      moduleLessons,
      modulePractice,
      moduleTests,
      moduleHomework,
      completionError,
      nextLesson,
      nextPractice,
      onVideoTimeUpdate,
      onVideoPlay,
      onVideoPause,
      onVideoEnded,
      onVideoLoadedMetadata,
      goToNextLesson,
      goToNextPractice,
      // Данные модуля для подстановки
      videoSource,
      isBitrixMode,
      isYouTubeVideo,
      youtubeEmbedUrl,
      isBitrixYoutubeFullscreen,
      toggleBitrixYoutubeFullscreen,
      openBitrixMediaInSlider,
      openCurrentVideoInBitrixSlider,
      handleRichMediaLinkClick,
      view2,
      x011,
      x013,
      selectedLessonKey,
      selectedLessonTitle,
      sanitizedVideoDescription,
      sanitizedArticleContent,
      hasArticleContent,
      isArticleTocEnabled,
      articleTocItems,
      isArticleInlineTocExpanded,
      hasArticleInlineTocOverflow,
      articleInlineTocVisibleItems,
      toggleArticleInlineToc,
      isArticleTocOpen,
      openArticleToc,
      closeArticleToc,
      scheduleCloseArticleToc,
      handleArticleTocFocusOut,
      onArticleTocItemClick,
      articleCollapsibleHeadings,
      isArticleNavIndicatorVisible,
      articleContentBodyShellRef,
      articleContentNavHeadersRef,
      scrollToArticleHeading,
      lessonMainMaterials,
      lessonAdditionalMaterials,
      hasLessonMaterials,
      isMainMaterialsDownloadDisabled,
      isAdditionalMaterialsDownloadDisabled,
      sortedLessons,
      getLessonKey,
      getLessonState,
      getLessonImage,
      getLessonCardClassName,
      sortedPractice,
      selectedPracticeKey,
      getPracticeKey,
      getPracticeCardClassName,
      getPracticeImage,
      getPracticeIcon,
      getPracticeTitle,
      selectedPracticeTitle,
      sanitizedPracticeDescription,
      sanitizedPracticeInstructions,
      practiceSteps,
      practiceQuestions,
      practiceMaterials,
      getMaterialTitle,
      getMaterialLink,
      getMaterialDownloadName,
      getMaterialViewerRoute,
      getPracticeListText,
      getPracticeMaterialLink,
      practiceAttachedTest,
      practiceQuizQuestions,
      practiceQuizAnswers,
      practiceQuizChecked,
      practiceQuizTotal,
      practiceQuizCorrectCount,
      isPracticeQuestionCorrect,
      setPracticeSingleAnswer,
      togglePracticeMultiAnswer,
      setPracticeTextAnswer,
      checkPracticeQuiz,
      resetPracticeQuiz,
      selectPractice,
      onSidebarPracticeSelect,
      sortedTests,
      selectedTestKey,
      getTestKey,
      getTestId,
      getTestCardClassName,
      getTestImage,
      selectedTestTitle,
      isSelectedTestFinal,
      sanitizedTestDescription,
      testMeta,
      testQuestions,
      testMaterials,
      testRunnerQuestions,
      testRunnerData,
      showTestRunner,
      selectedTestResults,
      isRefreshingTestResults,
      testStartTimeValue,
      testEndTimeValue,
      testGradeLabel,
      testIsReviewedByTeacher,
      testReviewIsAvailable,
      testReviewGradeLabel,
      testReviewGradedAtLabel,
      testReviewIsFailing,
      canStartTest,
      testAttemptsUsed,
      testAttemptsLimit,
      testStartLabel,
      openTestRunner,
      closeTestRunner,
      formatDateTime,
      formatTestDateTime,
      formatTestDuration,
      formatHomeworkDateTimeLong,
      getTestQuestionText,
      selectTest,
      onSidebarTestSelect,
      refreshSelectedTestResults,
      sortedHomework,
      selectedHomeworkKey,
      getHomeworkKey,
      getHomeworkCardClassName,
      getHomeworkImage,
      getHomeworkIcon,
      selectedHomeworkTitle,
      sanitizedHomeworkDescription,
      homeworkMeta,
      homeworkRequirements,
      homeworkMaterials,
      homeworkDueLabel,
      homeworkLateLabel,
      homeworkSubmissionBlocked,
      homeworkEditingBlocked,
      homeworkEditingBlockedLabel,
      homeworkExistingFiles,
      homeworkHasSubmission,
      homeworkIsGraded,
      homeworkAnswerStateLabel,
      homeworkGradingStateLabel,
      homeworkTimingLabel,
      homeworkTimingRowClass,
      homeworkLastChangeLabel,
      homeworkAnswerFiles,
      homeworkCommentsCount,
      homeworkCommentModalOpen,
      homeworkCommentDraft,
      openHomeworkCommentModal,
      closeHomeworkCommentModal,
      saveHomeworkComment,
      homeworkGradeLabel,
      homeworkFeedbackLabel,
      homeworkGradedAtLabel,
      homeworkFiles,
      isHomeworkUploadExpanded,
      homeworkFileInput,
      isHomeworkDragging,
      isSubmittingHomework,
      homeworkSubmissionError,
      homeworkRevisionRequested,
      homeworkRevisionRequestText,
      homeworkRevisionRequestFiles,
      homeworkRevisionRequestedAt,
      homeworkRevisionSubmissionText,
      homeworkRevisionSubmissionFiles,
      homeworkRevisionSubmittedAt,
      homeworkRevisionHasSubmission,
      homeworkRevisionEditingBlocked,
      revisionText,
      revisionFiles,
      revisionExistingFiles,
      revisionFileInput,
      isRevisionDragging,
      isSubmittingRevision,
      revisionSubmissionError,
      canSubmitRevision,
      openRevisionFileDialog,
      onRevisionFileChange,
      onRevisionDragOver,
      onRevisionDragLeave,
      onRevisionDrop,
      removeRevisionFile,
      removeRevisionExistingFile,
      submitRevision,
      homeworkSubmissionSuccess,
      canSubmitHomework,
      homeworkSubmitButtonLabel,
      expandHomeworkUpload,
      cancelHomeworkUpload,
      openHomeworkFileDialog,
      onHomeworkFileChange,
      onHomeworkDragOver,
      onHomeworkDragLeave,
      onHomeworkDrop,
      removeHomeworkFile,
      removeHomeworkExistingFile,
      submitHomework,
      getHomeworkSubmissionFileName,
      getHomeworkSubmissionFileUrl,
      getHomeworkListText,
      getHomeworkMaterialLink,
      selectHomework,
      onSidebarHomeworkSelect,
      getItemTitle,
      isLessonVideo,
      isLessonArticle,
      isLessonSelected,
      moduleTitle,
      moduleSubtitle,
      selectLesson,
      onSidebarLessonSelect,
      canCompleteLesson,
      isCompleting,
      markLessonCompleted,
      canCompletePractice,
      isCompletingPractice,
      markPracticeCompleted,
      x014,
      x015,
      x016,
      x017,
      x018,
      x019,
      x0110,
      x0111,
      x272Props,
      view702Props,
      x5331Props,
      x61Props,
      x5332Props,
      x62Props,
      x63Props,
      x5333Props,
      x2821Props,
      x2822Props,
      lessonCard1Title,
      // Состояния сворачиваемых блоков
      lessonsBlock,
      practiceBlock,
      testsBlock,
      homeworkBlock,
      // Состояние и управление чатом
      chatBlock,
      toggleChat,
      // Вычисляемые позиции блоков
      lessonsBlockTop,
      practiceBlockTop,
      testsBlockTop,
      homeworkBlockTop,
      sidebarHeight,
      // Transition hooks для анимации
      enter,
      afterEnter,
      leave,
      // Логика радио-кнопок для карточек уроков
      selectedLessonCard,
      selectCard,
      // Переключение контента
      contentMode,
      switchToTestContent,
      switchToHomeworkContent,
      switchToVideoContent,
    };
  },
};
</script>

<style>
:root {
  --sidebar-left-width: clamp(240px, 20vw, 350px);
  --chat-width-expanded: clamp(320px, 35vw, 671px);
  --chat-width-collapsed: clamp(80px, 10vw, 134px);
  --chat-panel-height: 775px;
  --content-min-width: 800px;
  --content-max-width: 1480px;
  --header-height: 60px;
  --sidebar-left-offset: 0px;
  --content-left-gap: 0px;
  --content-panel-height: calc(100vh - var(--header-height));
  --content-padding-vertical: 40px;
  --content-padding-horizontal: 48px;
  --content-gap: 20px;
  --transition-duration: 0.4s;
  --transition-easing: cubic-bezier(0.4, 0, 0.2, 1);
  --z-header: 100;
  --z-sidebar: 50;
  --z-content: 10;
  --z-chat: 60;
  --z-modal: 1000;
}

@media (max-width: 1400px) {
  :root {
    --sidebar-left-width: 300px;
    --chat-width-expanded: 550px;
    --chat-width-collapsed: 100px;
    --content-min-width: 600px;
    --content-max-width: 1200px;
    --content-padding-horizontal: 32px;
  }
}

.u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 {
  align-items: flex-start;
  background-color: var(--white);
  display: flex;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: visible;
  width: 100%;
  max-width: 1920px;
  scrollbar-width: thin;
  scrollbar-color: #94a3b8 rgba(15, 23, 42, 0.08);
}

.u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074::-webkit-scrollbar {
  width: 10px;
}

.u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.08);
  border-radius: 999px;
  margin: 6px 0;
}

.u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
  border-radius: 999px;
  border: 2px solid rgba(15, 23, 42, 0.08);
}

.u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #64748b 0%, #475569 100%);
}

.x-39 {
  --chat-width: var(--chat-width-expanded);
  --sidebar-height: var(--content-panel-height);
  height: auto;
  min-height: calc(
    var(--header-height) +
      max(
        var(--sidebar-height),
        var(--content-panel-height),
        var(--chat-panel-height)
      )
  );
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding-left: calc(
    var(--sidebar-left-width) + var(--sidebar-left-offset) + var(--content-left-gap)
  );
  padding-right: var(--chat-width);
  box-sizing: border-box;
}

.x-39.chat-collapsed {
  --chat-width: var(--chat-width-collapsed);
}

.x-39.chat-disabled {
  --chat-width: 0px;
}

/* ========================================
     ПАНЕЛЬ ЧАТА
     ======================================== */

.view-404 {
  background-color: var(--white-8);
  height: var(--chat-panel-height);
  right: 0;
  left: auto;
  position: absolute;
  top: var(--header-height);
  width: var(--chat-width);
  transition: width var(--transition-duration) var(--transition-easing);
  z-index: var(--z-chat);
}

.view-404.chat-collapsed {
  background-color: transparent;
}

.chat-expanded-content {
  width: 100%;
  height: 100%;
  position: relative;
}

.chat-collapsed-content {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.view-405 {
  height: calc(100% - 49px);
  left: 0;
  position: absolute;
  top: 49px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px 20px;
  box-sizing: border-box;
}

.view-405 .chat-container {
  width: 100%;
  max-width: 530px;
  height: 100%;
  max-height: 650px;
}

.image-40 {
  height: 650px;
  left: 30px;
  position: absolute;
  top: 0;
  width: 545px;
}

.view-406 {
  background-color: #418b98cc;
  display: flex;
  height: 40px;
  left: 30px;
  position: absolute;
  top: 0;
  width: 546px;
}

.view-407 {
  display: flex;
  flex-direction: column;
  height: 32px;
  margin-left: 188px;
  margin-top: 4px;
  width: 174px;
}

.text_label-39 {
  color: var(--white-3);
  font-family: var(--font-family-poppins);
  font-size: 12px;
  font-weight: 600;
  height: 18px;
  letter-spacing: 0;
  line-height: normal;
  width: 170px;
}

.text_label-40 {
  color: var(--white-3);
  font-family: var(--font-family-poppins);
  font-size: 9px;
  font-weight: 600;
  height: 14px;
  letter-spacing: 0;
  line-height: normal;
  margin-left: 48px;
  width: 74.14px;
}

.view-408 {
  height: 191px;
  left: 109px;
  position: absolute;
  top: -20px;
  transform: rotate(-90deg);
  width: 48px;
}

.view-409 {
  background-color: var(--white);
  border-radius: 60px;
  height: 191px;
  left: 5px;
  position: absolute;
  top: 0;
  width: 40px;
}

.x4-5 {
  background-color: var(--alto);
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 60px;
  height: 40px;
  left: 5px;
  position: absolute;
  top: 151px;
  transform: rotate(90deg);
  width: 40px;
}

.x2-13 {
  height: 43px;
  left: 6px;
  position: absolute;
  top: 50px;
  transform: rotate(90deg);
  width: 40px;
}

.rectangle-82-36 {
  aspect-ratio: 1;
  background-color: var(--alto);
  border-radius: 60px;
  height: 40px;
  left: 0;
  position: absolute;
  top: 3px;
  width: 40px;
}

.image-12-16 {
  aspect-ratio: 1;
  height: 40px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 3px;
  width: 40px;
}

.x3-20 {
  background-color: rgba(65, 139, 152, 0.8);
  border-radius: 60px 60px 0px 0px;
  height: 45px;
  left: 2px;
  position: absolute;
  top: -2px;
  transform: rotate(90deg);
  width: 41px;
}

.x1-50 {
  background-size: 100% 100%;
  display: flex;
  height: 40px;
  left: 5px;
  position: absolute;
  top: 1px;
  transform: rotate(90deg);
  width: 40px;
}

.rectangle-82-37 {
  aspect-ratio: 1;
  background-color: #17eb1e;
  border-radius: 60px;
  height: 7px;
  margin-left: 30px;
  margin-top: 32px;
  width: 7px;
}

.view-410 {
  height: 50px;
  left: 0;
  position: absolute;
  top: 0;
  width: 665px;
}

.view-411 {
  background-color: var(--cornflower-2);
  height: 50px;
  left: 0;
  position: absolute;
  top: 0;
  width: 663px;
}

.view-412 {
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-593.svg);
  background-size: 100% 100%;
  height: 41.67%;
  left: 51.44%;
  position: absolute;
  top: 26%;
  width: 3.13%;
}

.vector-285 {
  height: 10%;
  left: 64.99%;
  position: absolute;
  top: 45%;
  width: 9.99%;
}

.vector-287 {
  height: 10%;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 9.99%;
}

.vector-291 {
  height: 10%;
  left: 24.99%;
  position: absolute;
  top: 45%;
  width: 9.99%;
}

.text-376 {
  color: var(--black-4);
  font-family: var(--font-family-poppins);
  font-size: var(--font-size-m);
  font-weight: 600;
  left: 294px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 10px;
}

.view-413 {
  display: flex;
  gap: 7px;
  height: 13px;
  left: 28px;
  position: absolute;
  top: calc(50% - 370px);
  width: 63px;
  z-index: 10;
}

.chat-toggle-trigger {
  cursor: pointer;
  transition: opacity 0.3s ease, transform 0.2s ease;
  user-select: none;
}

.chat-toggle-trigger:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.chat-toggle-trigger:active {
  transform: scale(0.95);
}

/* ========================================
     СТИЛИ СВЕРНУТОГО ЧАТА
     ======================================== */

.view-112-collapsed {
  align-items: flex-start;
  background-color: var(--cornflower-2);
  display: flex;
  height: 100%;
  justify-content: flex-end;
  min-width: 134px;
  padding: 31px 46px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px 0px 0px 12px;
}

.view-112-collapsed:hover {
  opacity: 0.9;
  transform: scale(1.02);
}

.view-113-collapsed {
  height: 38px;
  position: relative;
  width: 41px;
}

.view-114-collapsed {
  aspect-ratio: 1;
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-572.svg);
  background-size: 100% 100%;
  height: 92.11%;
  left: 0;
  position: absolute;
  top: 7.89%;
  width: 85.37%;
}

.vector-114-collapsed {
  height: 10%;
  left: 65%;
  position: absolute;
  top: 45%;
  width: 10%;
}

.vector-115-collapsed {
  height: 10%;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 10%;
}

.vector-116-collapsed {
  height: 10%;
  left: 24.99%;
  position: absolute;
  top: 45%;
  width: 10%;
}

.view-115-collapsed {
  height: 16px;
  left: 25px;
  position: absolute;
  top: 0;
  width: 18px;
}

.rectangle-82-collapsed {
  aspect-ratio: 1;
  background-color: red;
  border: 2px solid;
  border-color: var(--white);
  border-radius: 60px;
  height: 16px;
  left: 0;
  position: absolute;
  top: 0;
  width: 16px;
}

.x1-6-collapsed {
  color: var(--white);
  font-family: var(--font-family-poppins);
  font-size: 8px;
  font-weight: 600;
  left: 6px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 2px;
  white-space: nowrap;
  width: 5px;
}

.text-378 {
  color: var(--black-7);
  font-family: var(--font-family-font_awesome_5_free-regular);
  font-size: 12px;
  font-weight: 700;
  height: 12px;
  letter-spacing: 0;
  line-height: normal;
  white-space: nowrap;
  width: 47px;
}

.text-377 {
  align-self: center;
  font-size: 12px;
  padding-left: 6px;
  padding-top: 3px;
}

/* ========================================
     ОСНОВНАЯ ОБЛАСТЬ КОНТЕНТА
     ======================================== */

.view-414 {
  height: auto;
  min-height: 0;
  left: auto;
  position: relative;
  top: auto;
  margin-top: var(--header-height);
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: width var(--transition-duration) var(--transition-easing),
    left var(--transition-duration) var(--transition-easing);
  z-index: var(--z-content);
}

/* ========================================
     ЛОАДЕР
     ======================================== */

.screen8-loading-active {
  overflow: hidden;
}

.screen8-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(
      circle at 15% 20%,
      rgba(0, 149, 236, 0.12),
      transparent 45%
    ),
    radial-gradient(
      circle at 85% 10%,
      rgba(90, 200, 250, 0.18),
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 90%,
      rgba(14, 116, 144, 0.12),
      transparent 45%
    ),
    linear-gradient(180deg, #f6f9fe 0%, #eef3f8 50%, #f9fbff 100%);
}

.screen8-loading-overlay::before,
.screen8-loading-overlay::after {
  content: "";
  position: absolute;
  border-radius: 999px;
  filter: blur(0px);
  opacity: 0.6;
}

.screen8-loading-overlay::before {
  width: 220px;
  height: 220px;
  left: 6%;
  top: 70%;
  background: rgba(0, 149, 236, 0.12);
}

.screen8-loading-overlay::after {
  width: 280px;
  height: 280px;
  right: 8%;
  top: 8%;
  background: rgba(90, 200, 250, 0.16);
}

.screen8-loading-card {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 24px;
  padding: 32px 36px;
  width: min(360px, 88vw);
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.2);
  text-align: center;
  backdrop-filter: blur(6px);
}

.screen8-loading-ring {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  border-radius: 50%;
  border: 6px solid rgba(0, 149, 236, 0.18);
  border-top-color: #0095ec;
  border-right-color: rgba(0, 149, 236, 0.6);
  box-sizing: border-box;
  animation: screen8-spin 1.1s linear infinite;
  box-shadow: 0 10px 24px rgba(0, 149, 236, 0.2);
}

.screen8-loading-title {
  font-family: "Poppins", Helvetica;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 6px;
}

.screen8-loading-subtitle {
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  color: #4b5563;
}

.screen8-loading-dots {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  gap: 6px;
}

.screen8-loading-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0095ec;
  animation: screen8-bounce 0.9s infinite ease-in-out;
}

.screen8-loading-dot:nth-child(2) {
  animation-delay: 0.15s;
}

.screen8-loading-dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes screen8-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes screen8-bounce {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-4px);
    opacity: 1;
  }
}

/* ========================================
     ВИДЕО ЭЛЕМЕНТЫ
     ======================================== */

.rectangle-57 {
  background-color: var(--cornflower);
  opacity: 0.2;
  position: relative;
  width: 100%;
  min-height: 320px;
  border-radius: 12px;
  margin: 20px 0;
}

.x01-35 {
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  padding: 0 var(--content-padding-horizontal);
  margin-top: 12px;
}

.x01-36 {
  letter-spacing: 0;
  line-height: normal;
  position: relative;
  padding: 0 var(--content-padding-horizontal);
  margin-top: 20px;
}

.view-415 {
  background-position: 50% 50%;
  background-size: cover;
  display: flex;
  position: relative;
  width: 100%;
  max-width: 900px;
  aspect-ratio: 16 / 9;
  margin: 24px auto;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.view-416 {
  background-color: var(--black-11);
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 82px;
  margin-left: 1px;
  margin-top: 455px;
  width: 803px;
}

.view-417 {
  height: 16px;
  margin-left: 30px;
  margin-top: 20px;
  position: relative;
  width: 742px;
}

.group-273-8 {
  background-color: var(--white);
  border-radius: 2px;
  display: flex;
  height: 8px;
  left: 0;
  position: absolute;
  top: 4px;
  width: 742px;
}

.rectangle-95-20 {
  background-color: var(--azure-radiance);
  border-radius: 2px;
  height: 8px;
  width: 270.4px;
}

.rectangle-142 {
  background-color: var(--azure-radiance);
  border-radius: 15px;
  height: 16px;
  left: 256px;
  position: absolute;
  top: 0;
  width: 16px;
}

.view-418 {
  display: flex;
  margin-left: 30px;
  width: 746px;
}

.text-379 {
  color: var(--white);
  font-family: var(--font-family-font_awesome_5_free-solid);
  font-size: var(--font-size-s);
  font-weight: 400;
  height: 21px;
  letter-spacing: 0.36px;
  line-height: normal;
  margin-top: 3px;
  white-space: nowrap;
  width: 16px;
}

.text-380 {
  height: 24px;
  letter-spacing: 0;
  line-height: normal;
  margin-left: 50px;
  width: 95px;
}

.group-311 {
  height: 11.79px;
  margin-left: 569.6px;
  margin-top: 8px;
  position: relative;
  width: 11.38px;
}

.line-36 {
  height: 1px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: -1px;
  width: 5px;
}

.line-40 {
  height: 1px;
  left: 7px;
  object-fit: cover;
  position: absolute;
  top: -1px;
  width: 5px;
}

.line-38 {
  height: 1px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 11px;
  width: 5px;
}

.line-43 {
  height: 1px;
  left: 7px;
  object-fit: cover;
  position: absolute;
  top: 11px;
  width: 5px;
}

.line-37 {
  height: 4px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 1px;
}

.line-41 {
  height: 4px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 7px;
  width: 1px;
}

.line-42 {
  height: 4px;
  left: 11px;
  object-fit: cover;
  position: absolute;
  top: 7px;
  width: 1px;
}

.line-39 {
  height: 4px;
  left: 11px;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 1px;
}

.video-embed-frame,
.video-embed-frame iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.video-embed-frame {
  position: relative;
  background: #000;
}

.video-embed-frame--bitrix-fullscreen {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5000;
}

.bitrix-video-fullscreen-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  border: none;
  border-radius: 999px;
  padding: 10px 16px;
  background: rgba(15, 23, 42, 0.78);
  color: #ffffff;
  cursor: pointer;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  backdrop-filter: blur(10px);
}

.bitrix-video-fullscreen-btn:hover {
  background: rgba(15, 23, 42, 0.92);
}

.video-missing {
  color: #4b4b4b;
  font-family: "Poppins", Helvetica;
  font-size: 16px;
  text-align: center;
  width: 100%;
}

/* ========================================
     ЗАГОЛОВОК МОДУЛЯ (VIEW-419)
     ======================================== */

.view-419 {
  background-color: var(--azure-radiance-2);
  display: flex;
  align-items: center;
  height: 101px;
  left: auto;
  right: auto;
  position: relative;
  top: auto;
  order: -1;
  max-width: calc(100% - 40px);
  overflow: hidden;
  padding: 0 var(--content-padding-horizontal);
  box-sizing: border-box;
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    height 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-419 > * {
  position: relative;
  z-index: 2;
}

.view-419 .view-129:not(.view-129-collapsed) {
  position: relative;
  left: auto;
  top: auto;
  width: 100%;
  max-width: 100%;
}

.view-419 .view-129:not(.view-129-collapsed) .text-192,
.view-419 .view-129:not(.view-129-collapsed) .text-191 {
  width: 100%;
  white-space: normal;
  word-break: break-word;
  text-align: center;
}

.view-419::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 35px,
      rgba(255, 255, 255, 0.08) 35px,
      rgba(255, 255, 255, 0.08) 37px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 35px,
      rgba(255, 255, 255, 0.06) 35px,
      rgba(255, 255, 255, 0.06) 37px
    ),
    url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='10' y='15' width='25' height='25' fill='rgba(255,255,255,0.1)' transform='rotate(15 22.5 27.5)'/%3E%3Crect x='140' y='50' width='30' height='30' fill='rgba(255,255,255,0.08)'/%3E%3Crect x='70' y='120' width='20' height='20' fill='rgba(255,255,255,0.12)' transform='rotate(45 80 130)'/%3E%3Crect x='160' y='160' width='28' height='28' fill='rgba(255,255,255,0.09)' transform='rotate(30 174 174)'/%3E%3Cpolygon points='80,10 95,35 65,35' fill='rgba(255,255,255,0.1)' transform='rotate(20 80 26)'/%3E%3Cpolygon points='180,90 200,120 160,120' fill='rgba(255,255,255,0.11)'/%3E%3Cpolygon points='25,140 45,170 5,170' fill='rgba(255,255,255,0.09)' transform='rotate(-15 25 155)'/%3E%3Cpolygon points='120,180 135,200 105,200' fill='rgba(255,255,255,0.1)'/%3E%3Cpolygon points='150,25 160,20 170,25 170,35 160,40 150,35' fill='rgba(255,255,255,0.1)'/%3E%3Cpolygon points='40,80 52,75 64,80 64,92 52,97 40,92' fill='rgba(255,255,255,0.12)' transform='rotate(25 52 86)'/%3E%3Cpolygon points='110,100 120,96 130,100 130,110 120,114 110,110' fill='rgba(255,255,255,0.09)'/%3E%3Ccircle cx='50' cy='50' r='12' fill='rgba(255,255,255,0.1)'/%3E%3Ccircle cx='130' cy='140' r='15' fill='rgba(255,255,255,0.08)'/%3E%3Ccircle cx='190' cy='30' r='10' fill='rgba(255,255,255,0.11)'/%3E%3Crect x='100' y='50' width='40' height='30' fill='none' stroke='rgba(255,255,255,0.1)' stroke-width='2' transform='rotate(10 120 65)'/%3E%3Crect x='20' y='100' width='35' height='45' fill='none' stroke='rgba(255,255,255,0.09)' stroke-width='1.5'/%3E%3Crect x='150' y='120' width='30' height='25' fill='none' stroke='rgba(255,255,255,0.1)' stroke-width='2' transform='rotate(-20 165 132.5)'/%3E%3C/svg%3E"),
    radial-gradient(
      circle 2px at center,
      rgba(255, 255, 255, 0.15) 100%,
      transparent 100%
    ),
    radial-gradient(
      circle at 20% 30%,
      rgba(255, 255, 255, 0.05) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(255, 255, 255, 0.05) 0%,
      transparent 40%
    );
  background-size: 100% 100%, 100% 100%, 200px 200px, 30px 30px, 100% 100%,
    100% 100%;
  background-position: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  background-repeat: repeat;
  opacity: 1;
  transition: opacity 0.15s ease-in-out, width 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
}

.view-419::after {
  content: "";
  position: absolute;
  inset: 0;
  height: 100%;
  background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 35px,
      rgba(255, 255, 255, 0.08) 35px,
      rgba(255, 255, 255, 0.08) 37px
    ),
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 35px,
      rgba(255, 255, 255, 0.06) 35px,
      rgba(255, 255, 255, 0.06) 37px
    ),
    url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='10' y='15' width='25' height='25' fill='rgba(255,255,255,0.1)' transform='rotate(15 22.5 27.5)'/%3E%3Crect x='140' y='50' width='30' height='30' fill='rgba(255,255,255,0.08)'/%3E%3Crect x='70' y='120' width='20' height='20' fill='rgba(255,255,255,0.12)' transform='rotate(45 80 130)'/%3E%3Crect x='160' y='160' width='28' height='28' fill='rgba(255,255,255,0.09)' transform='rotate(30 174 174)'/%3E%3Cpolygon points='80,10 95,35 65,35' fill='rgba(255,255,255,0.1)' transform='rotate(20 80 26)'/%3E%3Cpolygon points='180,90 200,120 160,120' fill='rgba(255,255,255,0.11)'/%3E%3Cpolygon points='25,140 45,170 5,170' fill='rgba(255,255,255,0.09)' transform='rotate(-15 25 155)'/%3E%3Cpolygon points='120,180 135,200 105,200' fill='rgba(255,255,255,0.1)'/%3E%3Cpolygon points='150,25 160,20 170,25 170,35 160,40 150,35' fill='rgba(255,255,255,0.1)'/%3E%3Cpolygon points='40,80 52,75 64,80 64,92 52,97 40,92' fill='rgba(255,255,255,0.12)' transform='rotate(25 52 86)'/%3E%3Cpolygon points='110,100 120,96 130,100 130,110 120,114 110,110' fill='rgba(255,255,255,0.09)'/%3E%3Ccircle cx='50' cy='50' r='12' fill='rgba(255,255,255,0.1)'/%3E%3Ccircle cx='130' cy='140' r='15' fill='rgba(255,255,255,0.08)'/%3E%3Ccircle cx='190' cy='30' r='10' fill='rgba(255,255,255,0.11)'/%3E%3Crect x='100' y='50' width='40' height='30' fill='none' stroke='rgba(255,255,255,0.1)' stroke-width='2' transform='rotate(10 120 65)'/%3E%3Crect x='20' y='100' width='35' height='45' fill='none' stroke='rgba(255,255,255,0.09)' stroke-width='1.5'/%3E%3Crect x='150' y='120' width='30' height='25' fill='none' stroke='rgba(255,255,255,0.1)' stroke-width='2' transform='rotate(-20 165 132.5)'/%3E%3C/svg%3E"),
    radial-gradient(
      circle 2px at center,
      rgba(255, 255, 255, 0.15) 100%,
      transparent 100%
    ),
    radial-gradient(
      circle at 20% 30%,
      rgba(255, 255, 255, 0.05) 0%,
      transparent 40%
    ),
    radial-gradient(
      circle at 80% 70%,
      rgba(255, 255, 255, 0.05) 0%,
      transparent 40%
    );
  background-size: 100% 100%, 100% 100%, 200px 200px, 30px 30px, 100% 100%,
    100% 100%;
  background-position: 0 0, 0 0, 0 0, 0 0, 0 0, 0 0;
  background-repeat: repeat;
}

.view-419.view-419-collapsed {
  width: 100%;
  max-width: calc(100% - 40px);
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    height 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-419.view-419-collapsed::before {
  opacity: 0;
  width: 100%;
  transition: opacity 0.15s ease-in-out, width 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.view-419.view-419-collapsed::after {
  opacity: 1;
  width: 100%;
  max-width: 100%;
  transition: opacity 0.15s ease-in-out, width 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ========================================
     ХЕДЕР
     ======================================== */

.header-2-4 {
  height: 60px;
  left: calc(50% - 960px);
  position: absolute;
  top: 0;
  width: 1924px;
  z-index: 1200;
}

.rectangle-207-5 {
  background-color: var(--white);
  height: 62px;
  left: calc(50% - 963px);
  position: absolute;
  top: -1px;
  width: 1922px;
  z-index: 1;
}

.text-415 {
  left: 53px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 11px);
  transform: rotate(180deg);
  white-space: nowrap;
  z-index: 2;
}

.text-416 {
  position: relative;
  display: inline-block;
  top: 15px;
  left: 89px;
  font-family: "FontAwesome5Free-Solid", Arial, sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: black;
  opacity: 0.4;
  letter-spacing: 0;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.3s ease, opacity 0.3s ease;
  z-index: 2;
}

.text-416:hover,
.text-416:focus {
  outline: none;
}

.text-416::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  height: 2px;
  width: 0%;
  background: linear-gradient(90deg, #a8e6ff 0%, #5ac8fa 100%);
  transition: width 0.3s ease;
}

.header-progress {
  position: absolute;
  right: var(--content-padding-horizontal);
  top: 8px;
  width: min(520px, 45%);
  z-index: 2;
}

.text-416:hover::after,
.text-416:focus::after {
  width: 100%;
}

@media (prefers-reduced-motion: reduce) {
  .text-416 {
    transition: none;
  }
  .text-416::after {
    transition: none;
  }
}

.text-415 svg path {
  fill: black;
  opacity: 0.4;
  transition: opacity 0.3s ease;
}

.header-2-4:hover .text-415 svg path,
.header-2-4:hover .text-416 {
  fill: black;
  color: black;
  opacity: 0.6;
}

/* ========================================
     АНИМАЦИИ ЧАТА
     ======================================== */

.chat-expand-enter-active,
.chat-expand-leave-active {
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-expand-enter-from {
  opacity: 0;
}

.chat-expand-leave-to {
  opacity: 0;
}

.chat-expand-enter-to,
.chat-expand-leave-from {
  opacity: 1;
}

.chat-collapse-enter-active,
.chat-collapse-leave-active {
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-collapse-enter-from {
  opacity: 0;
}

.chat-collapse-leave-to {
  opacity: 0;
}

.chat-collapse-enter-to,
.chat-collapse-leave-from {
  opacity: 1;
}

/* ========================================
     АНИМАЦИИ ПЕРЕКЛЮЧЕНИЯ КОНТЕНТА
     ======================================== */

.content-switch-enter-active,
.content-switch-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.content-switch-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.content-switch-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.content-switch-enter-to,
.content-switch-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Для статьи отключаем transform-анимацию:
   fixed-элементы внутри transform-контейнера могут "прыгать" по left */
.article-content-wrapper.content-switch-enter-from,
.article-content-wrapper.content-switch-leave-to,
.article-content-wrapper.content-switch-enter-to,
.article-content-wrapper.content-switch-leave-from {
  transform: none !important;
}

/* ========================================
     БУРГЕР МЕНЮ
     ======================================== */

.burger-menu-toggle {
  display: none;
  position: fixed;
  top: 8px;
  left: 12px;
  z-index: 2100;
  width: var(--burger-size, 44px);
  height: var(--burger-size, 44px);
  padding: 0;
  background: #ffffff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.burger-menu-toggle:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.burger-menu-toggle:active {
  transform: scale(0.95);
}

.burger-icon {
  position: relative;
  width: 22px;
  height: 16px;
  margin: auto;
}

.burger-icon span {
  display: block;
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background: #2b2b2b;
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease, top 0.3s ease;
}

.burger-icon span:nth-child(1) {
  top: 0;
}

.burger-icon span:nth-child(2) {
  top: 7px;
}

.burger-icon span:nth-child(3) {
  top: 14px;
}

.burger-menu-toggle.is-active .burger-icon span:nth-child(1) {
  top: 7px;
  transform: rotate(45deg);
}

.burger-menu-toggle.is-active .burger-icon span:nth-child(2) {
  opacity: 0;
  transform: translateX(-10px);
}

.burger-menu-toggle.is-active .burger-icon span:nth-child(3) {
  top: 7px;
  transform: rotate(-45deg);
}

/* ========================================
     ОВЕРЛЕЙ САЙДБАРА
     ======================================== */

.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 1250;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}

.sidebar-overlay.is-visible {
  opacity: 1;
  visibility: visible;
}

/* ========================================
     ПРОИЗВОДИТЕЛЬНОСТЬ
     ======================================== */

.view-404 {
  will-change: width;
}

.chat-expanded-content,
.chat-collapsed-content {
  will-change: transform, opacity;
}

.chat-toggle-trigger:focus,
.view-112-collapsed:focus {
  outline: 2px solid var(--azure-radiance);
  outline-offset: 2px;
}

/* ========================================
     АДАПТИВНОСТЬ - ПЛАНШЕТЫ
     ======================================== */

@media (max-width: 1024px) {
  :root {
    --sidebar-left-width: 280px;
    --content-padding-horizontal: 20px;
    --header-height: 56px;
  }

  .u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 {
    max-width: 100%;
  }

  .x-39 {
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .view-414 {
    left: auto;
    width: 100%;
    padding-left: 0;
    box-sizing: border-box;
  }

  .view-419 {
    max-width: 100%;
    padding: 0 20px;
  }
}

/* ========================================
     АДАПТИВНОСТЬ - МОБИЛЬНЫЕ
     ======================================== */

@media (max-width: 768px) {
  :root {
    --sidebar-left-width: 85vw;
    --content-padding-horizontal: 16px;
    --header-height: 56px;
    --burger-size: 44px;
  }

  .burger-menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .x-39 {
    padding-left: 0;
    padding-right: 0;
  }

  .x-39 .view-420 {
    z-index: 2000 !important;
  }

  .x-39 .sidebar-overlay {
    z-index: 1900 !important;
  }

  .x-39 .header-2-4 {
    z-index: 1950 !important;
  }

  .sidebar-overlay {
    display: block;
  }

  .u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 {
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
  }

  .x-39 {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-height: 100dvh;
  }

  .view-420 {
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    width: var(--sidebar-left-width) !important;
    max-width: 320px;
    height: auto !important;
    min-height: 100dvh;
    z-index: 1300;
    background: #ffffff;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-top: 60px;
    padding-bottom: 24px;
  }

  .view-420.is-open {
    transform: translateX(0);
  }

  .view-420 .view-421,
  .view-420 .view-425,
  .view-420 .view-431,
  .view-420 .view-434 {
    position: relative !important;
    top: 0 !important;
    left: 0;
    width: calc(100% - 24px);
    margin: 0 12px 16px;
    height: auto;
  }

  .view-420 .view-container-3 {
    width: 100%;
    margin: 0;
    min-height: auto;
    padding: 0;
  }

  .view-420 .view-422,
  .view-420 .view-426,
  .view-420 .view-402,
  .view-420 .view-402-1 {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    gap: 10px;
  }

  .view-420 .view-430,
  .view-420 .view-433,
  .view-420 .view-436 {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    margin-bottom: 10px;
    background: #f5f7fb;
    border-radius: 10px;
  }

  .view-420 .view-199 {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    margin-bottom: 10px;
    background: #f5f7fb;
    border-radius: 10px;
  }

  .view-420 .view-199 .text-256 {
    position: static;
    transform: rotate(90deg);
    order: 3;
    margin-left: auto;
    width: 18px;
    height: 18px;
  }

  .view-420 .view-199 .text-257 {
    position: static;
    order: 2;
    font-size: 15px;
    line-height: 1.2;
  }

  .view-420 .view-199 .teacher {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    order: 1;
    width: 18px;
    height: 18px;
    flex: 0 0 18px;
  }

  .view-420 .view-199.collapsed .text-256 {
    transform: rotate(-90deg);
  }

  .view-420 .text-396,
  .view-420 .text-391,
  .view-420 .text-386 {
    position: static;
    transform: rotate(90deg);
    order: 3;
    margin-left: auto;
    margin-top: 0;
    font-size: 14px;
    width: 18px;
    height: 18px;
  }

  .view-420 .text-3-4 {
    position: static;
    order: 2;
    flex: 1;
    font-size: 15px;
  }

  .view-420 .writing,
  .view-420 .task-2,
  .view-420 .drawing {
    order: 1;
    width: 18px;
    height: 18px;
    flex: 0 0 18px;
  }

  .view-420 .x1-11,
  .view-420 .x2-6,
  .view-420 .x3-21,
  .view-420 .link,
  .view-420 .x2-14,
  .view-420 .x3-22,
  .view-420 .view-402-item {
    width: 100%;
    min-height: 64px;
    height: auto !important;
    margin: 0;
    border-radius: 10px;
  }

  .view-420 .card-border-x1,
  .view-420 .card-border-x2,
  .view-420 .card-border-x3,
  .view-420 .card-bor-x4,
  .view-420 .card-bor-x5,
  .view-420 .card-bor-x6 {
    width: calc(100% + 6px);
    height: calc(100% + 6px);
    left: -3px;
    top: -3px;
    border-radius: 12px;
  }

  .view-420 .writing,
  .view-420 .task-2,
  .view-420 .drawing {
    position: relative !important;
    left: auto !important;
    top: auto !important;
    width: 18px !important;
    height: 18px !important;
    flex: 0 0 18px;
  }

  .view-420 .view-189,
  .view-420 .view-193,
  .view-420 .view-423 {
    position: relative !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: auto !important;
    display: grid !important;
    grid-template-columns: 20px minmax(0, 1fr);
    grid-auto-rows: auto;
    gap: 2px 8px;
    padding: 6px 10px;
    box-sizing: border-box;
  }

  .view-420 .view-427,
  .view-420 .view-428,
  .view-420 .view-429,
  .view-420 .view-403,
  .view-420 .view-435 {
    position: relative !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: auto !important;
    display: flex !important;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    box-sizing: border-box;
  }

  .view-420 .view-189,
  .view-420 .view-193 {
    padding-right: 32px;
  }

  .view-420 .text-255,
  .view-420 .vector-190,
  .view-420 .vector-295,
  .view-420 .lesson-icon-article {
    position: static !important;
    width: 18px !important;
    height: 18px !important;
    grid-column: 1;
    grid-row: 1 / span 2;
  }

  .view-420 .text-395,
  .view-420 .text-394,
  .view-420 .text-393,
  .view-420 .text-38-1 {
    position: static !important;
    width: 18px !important;
    height: 18px !important;
    margin: 0 !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 18px;
  }

  .view-420 .text-255 svg,
  .view-420 .lesson-icon-article svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  .view-420 .x01-17,
  .view-420 .x01-19,
  .view-420 .x01-38 {
    position: static !important;
    left: auto !important;
    top: auto !important;
    width: 100% !important;
    margin: 0 !important;
    grid-column: 2;
    grid-row: 1;
    font-size: 13px;
    line-height: 1.3;
  }

  .view-420 .x01-39,
  .view-420 .x01-40,
  .view-420 .x01-41,
  .view-420 .x01-43,
  .view-420 .x01-44,
  .view-420 .x01-45 {
    position: static !important;
    left: auto !important;
    top: auto !important;
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    white-space: normal;
    line-height: 1.3;
    font-size: 13px;
  }

  .view-420 .view-402-1 .view-427 {
    align-items: flex-start !important;
    height: auto !important;
  }

  .view-420 .view-402-1 .x01-39 {
    display: -webkit-box;
    flex: 1 1 auto;
    min-width: 0;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal !important;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    word-break: normal;
    line-height: 1.25;
  }

  .view-420 .view-402-1 .homework-card-content {
    align-items: flex-start !important;
  }

  .view-420 .view-402-1 .text-395 {
    align-self: flex-start;
    margin-top: 2px !important;
  }

  .view-420 .view-402-1 .homework-card-title {
    display: -webkit-box;
    flex: 1 1 auto;
    min-width: 0;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal !important;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow-wrap: break-word;
    word-break: normal;
    line-height: 1.25;
  }

  .view-420 .view-402-1 .homework-card {
    min-height: 64px !important;
    height: auto !important;
  }

  .view-420 .text-409,
  .view-420 .text-390 {
    position: static !important;
    left: auto !important;
    top: auto !important;
    width: 100% !important;
    margin: 0 !important;
    grid-column: 2;
    grid-row: 2;
    font-size: 11px;
    opacity: 0.75;
  }

  .view-420 .view-189 .view-191,
  .view-420 .view-193 .view-191 {
    position: absolute !important;
    right: 8px !important;
    top: 8px !important;
    left: auto !important;
    width: 18px !important;
    height: 18px !important;
  }

  .view-420 .view-189 .vector-4-1,
  .view-420 .view-193 .vector-4-1 {
    width: 10px !important;
    height: 10px !important;
    margin: 0 !important;
  }

  .view-420 .view-122 {
    display: none;
  }

  .header-2-4 {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: var(--header-height);
    z-index: 1200;
    display: flex;
    align-items: center;
    padding: 0 16px 0 60px;
    background: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .header-2-4 .rectangle-207-5 {
    display: none;
  }

  .header-2-4 .text-415 {
    display: none !important;
  }

  .header-2-4 .text-416 {
    position: static;
    top: 0;
    left: 0;
    font-size: 16px;
    margin: 0;
  }

  .header-2-4 .header-progress {
    position: absolute;
    right: 12px;
    top: 8px;
    width: 200px;
  }

  .header-2-4 .progress-indicators--header .progress-text {
    display: none;
  }

  .view-414 {
    position: relative;
    left: 0 !important;
    top: 0;
    width: 100% !important;
    min-height: calc(100vh - var(--header-height));
    min-height: calc(100dvh - var(--header-height));
    padding-top: var(--header-height);
    padding-left: 0;
    padding-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: #f5f7fb;
    transition: none;
  }

  .view-419 {
    position: relative;
    height: auto;
    min-height: 80px;
    padding: 16px;
    margin: 12px 12px 0;
    max-width: 100%;
    border-radius: 16px;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
    order: -2;
  }

  .view-419::before,
  .view-419::after {
    height: 100%;
  }

  .view-419 .view-129 {
    width: 100%;
  }

  .view-419 .text-192 {
    font-size: 18px;
    text-align: center;
  }

  .view-419 .text-191 {
    font-size: 12px;
    text-align: center;
  }

  .view-404 {
    display: none !important;
  }
}

/* ========================================
     АДАПТИВНОСТЬ - МАЛЕНЬКИЕ ЭКРАНЫ
     ======================================== */

@media (max-width: 480px) {
  :root {
    --sidebar-left-width: 100vw;
    --content-padding-horizontal: 12px;
  }

  .burger-menu-toggle {
    top: 6px;
    left: 8px;
    width: 40px;
    height: 40px;
  }

  .burger-icon {
    width: 20px;
    height: 14px;
  }

  .burger-icon span:nth-child(2) {
    top: 6px;
  }

  .burger-icon span:nth-child(3) {
    top: 12px;
  }

  .burger-menu-toggle.is-active .burger-icon span:nth-child(1),
  .burger-menu-toggle.is-active .burger-icon span:nth-child(3) {
    top: 6px;
  }

  .view-420 {
    max-width: 100%;
    padding-top: 56px;
  }

  .header-2-4 {
    height: 52px;
    padding-left: 56px;
  }

  .header-2-4 .text-416 {
    font-size: 14px;
  }

  .view-414 {
    padding-top: 52px;
  }

  .view-419 {
    min-height: 70px;
    padding: 12px;
  }

  .view-419 .text-192 {
    font-size: 16px;
  }

  .view-419 .text-191 {
    font-size: 11px;
  }
}

/* ========================================
     ЛАНДШАФТНАЯ ОРИЕНТАЦИЯ
     ======================================== */

@media (max-width: 768px) and (orientation: landscape) {
  .view-420 {
    width: 50vw;
    max-width: 300px;
  }

  .view-419 {
    min-height: 60px;
    padding: 10px 16px;
  }

  .view-415 {
    max-height: 50vh;
  }
}

/* ========================================
     БЕЗОПАСНЫЕ ЗОНЫ (iPhone)
     ======================================== */

@supports (padding: max(0px)) {
  @media (max-width: 768px) {
    .header-2-4 {
      padding-top: max(0px, env(safe-area-inset-top));
      height: calc(var(--header-height) + max(0px, env(safe-area-inset-top)));
    }

    .burger-menu-toggle {
      top: calc(8px + max(0px, env(safe-area-inset-top)));
    }

    .view-420 {
      padding-top: calc(60px + max(0px, env(safe-area-inset-top)));
      padding-left: max(12px, env(safe-area-inset-left));
      padding-bottom: max(24px, env(safe-area-inset-bottom));
    }

    .view-414 {
      padding-top: calc(
        var(--header-height) + max(0px, env(safe-area-inset-top))
      );
    }
  }
}

/* ========================================
     ДОСТУПНОСТЬ
     ======================================== */

@media (prefers-reduced-motion: reduce) {
  .view-404,
  .chat-expand-enter-active,
  .chat-expand-leave-active,
  .chat-collapse-enter-active,
  .chat-collapse-leave-active,
  .view-112-collapsed,
  .chat-toggle-trigger,
  .view-420,
  .sidebar-overlay,
  .burger-menu-toggle,
  .burger-icon span {
    transition: none !important;
    animation: none !important;
  }

  .view-420.is-open {
    transform: translateX(0);
  }
}

/* ========================================
     ПЕЧАТЬ
     ======================================== */

@media print {
  .burger-menu-toggle,
  .sidebar-overlay,
  .view-420,
  .header-2-4 {
    display: none !important;
  }

  .view-414 {
    position: static !important;
    padding: 0 !important;
    width: 100% !important;
  }
}
</style>

<style scoped>
/* ========================================
         ОСНОВНЫЕ СТИЛИ КОНТЕЙНЕРА
         ======================================== */

.screen8-container {
  align-items: flex-start;
  background-color: var(--white);
  display: flex;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-width: 1920px;
}

.screen8-content {
  position: relative;
  width: 100%;
}

/* ========================================
         ПРОГРЕСС-БАР МОДУЛЯ
         ======================================== */

.progress-indicators {
  position: relative;
  margin-top: 12px;
  width: 100%;
  max-width: 640px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 14px;
  padding: 10px 14px;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.progress-indicators--header {
  background: transparent;
  box-shadow: none;
  padding: 0;
  margin: 0;
  max-width: 100%;
}

.progress-indicators--header .progress-bar {
  height: 6px;
  margin-bottom: 4px;
}

.progress-indicators--header .progress-text {
  font-size: 12px;
}

.progress-indicators--header .progress-refresh-button {
  padding: 4px 10px;
  font-size: 11px;
}

.progress-indicators--header .progress-note {
  display: none;
}
.progress-bar {
  height: 10px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 8px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #10b981 0%, #34d399 50%, #6ee7b7 100%);
  border-radius: 10px;
  transition: width 0.5s ease;
  position: relative;
}

.progress-fill::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.progress-text {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #065f46;
  text-align: left;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.progress-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.progress-actions {
  display: flex;
  justify-content: flex-end;
}

.progress-refresh-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(16, 185, 129, 0.35);
  background: rgba(236, 253, 245, 0.95);
  color: #065f46;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.progress-refresh-button:hover {
  background: rgba(209, 250, 229, 0.95);
  box-shadow: 0 4px 10px rgba(6, 95, 70, 0.12);
  transform: translateY(-1px);
}

.progress-refresh-button:disabled {
  cursor: default;
  opacity: 0.6;
  box-shadow: none;
  transform: none;
}

.progress-note {
  margin-top: 6px;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}

/* ========================================
         СТАТУСЫ ЗАГРУЗКИ И ОШИБОК
         ======================================== */

.screen8-module-status {
  position: absolute;
  top: 160px;
  left: 50px;
  z-index: 6;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #d9d9d9;
  border-radius: 16px;
  padding: 16px 20px;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  color: #2b2b2b;
  max-width: 500px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.screen8-module-status--loading {
  border-color: #93c5fd;
  color: #1e40af;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
}

.screen8-module-status--error {
  border-color: #fca5a5;
  color: #991b1b;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
}

.screen8-module-status--empty {
  border-color: #fde68a;
  color: #92400e;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
}

.retry-button {
  margin-top: 12px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #0095ec 0%, #0077cc 100%);
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: "Poppins", Helvetica;
  font-size: 14px;
  font-weight: 600;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 149, 236, 0.3);
}

.retry-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 149, 236, 0.4);
}

.completion-error-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  padding: 16px 28px;
  border-radius: 14px;
  z-index: 1000;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.4);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* ========================================
         ЕДИНЫЙ СВЕТЛО-ГОЛУБОЙ ФОН ДЛЯ ВСЕГО КОНТЕНТА
         ======================================== */

.video-content-wrapper,
.article-content-wrapper,
.practice-content-wrapper,
.test-content-wrapper,
.homework-content-wrapper {
  position: relative;
  width: calc(100% - 10px);
  min-height: auto;
  padding: 20px var(--content-padding-horizontal) 80px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(180deg, #f0f7ff 0%, #f8fbff 50%, #ffffff 100%);
  overflow: visible;
  height: auto;
  max-height: none;
}


/* ========================================
         ВИДЕО КОНТЕНТ
         ======================================== */

.player-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto 32px;
  /* background: #ffffff; */
  /* border-radius: 20px; */
  /* box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), */
  /* 0 10px 30px -5px rgba(0, 0, 0, 0.12); */
  overflow: hidden;
  /* transition: transform 0.3s ease, box-shadow 0.3s ease; */
}

/* .player-container:hover {
	transform: translateY(-4px);
	box-shadow: 0 8px 12px -2px rgba(0, 0, 0, 0.12),
		0 20px 40px -10px rgba(0, 0, 0, 0.18);
} */

.player-container-collapsed {
  transform: none;
}

.video-content-header {
  width: 100%;
  max-width: 1400px;
  text-align: left;
  margin-bottom: 24px;
}

.video-content-title {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 16px;
  line-height: 1.3;
  text-align: left;
}

.video-content-description {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  color: #4a5568;
  line-height: 1.75;
  max-width: 1400px;
  text-align: justify;
}

.video-content-description :deep(p) {
  margin: 0 0 16px;
  text-align: justify;
}

.video-content-description :deep(a) {
  color: #0095ec;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s ease;
}

.video-content-description :deep(a:hover) {
  border-bottom-color: #0095ec;
}

.video-content-description :deep(ul),
.video-content-description :deep(ol) {
  margin: 0 0 16px;
  padding-left: 1.4em;
  list-style-position: outside;
}

.video-content-description :deep(ul) {
  list-style-type: disc;
}

.video-content-description :deep(ol) {
  list-style-type: decimal;
}

.video-content-description :deep(li) {
  margin: 0 0 6px;
}

.video-content-description :deep(em),
.video-content-description :deep(i) {
  font-style: italic !important;
}

/* Прогресс-бар для видео */
.video-progress-bar {
  position: relative;
  width: 100%;
  height: 6px;
  background: #e2e8f0;
  overflow: hidden;
}

.video-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #0095ec 0%, #00d4ff 100%);
  transition: width 0.1s linear;
  border-radius: 0 3px 3px 0;
}

/* ========================================
         СТАТЬЯ КОНТЕНТ
         ======================================== */

.article-content-header {
  width: 100%;
  max-width: 1000px;
  text-align: left;
  margin-bottom: 32px;
}

.article-content-title {
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  margin-bottom: 0;
  text-align: left;
}

.article-content-body {
  width: 100%;
  max-width: 1000px;
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  line-height: 1.5;
  color: #2d3748;
  background: #ffffff;
  padding: 48px 56px;
  border-radius: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 32px;
  overflow: visible;
  max-height: none;
  height: auto;
}


.article-content-body.collapsible-article {
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  line-height: 1.5;
  color: #2d3748;
}

.article-content-body-shell {
  width: 100%;
  max-width: 1000px;
  position: relative;
}

.article-content-body-shell .article-content-body {
  width: 100%;
  max-width: 1000px;
  min-width: 100%;
}

.article-content-toc-inline {
  width: 100%;
  max-width: 760px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  padding: 10px 12px 8px;
  margin-bottom: 12px;
}

.article-content-toc-inline__title {
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
}

.article-content-toc-inline__list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: min(48vh, 420px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 4px;
}

.article-content-toc-inline__item {
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 3px 5px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 400;
  color: #475569;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.article-content-toc-inline__item:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.article-content-toc-inline__item--level-3,
.article-content-toc-inline__item--level-4 {
  padding-left: 14px;
}

.article-content-toc-inline__item--level-3::before,
.article-content-toc-inline__item--level-4::before {
  content: "·";
  margin-right: 6px;
  color: #64748b;
}

.article-content-toc-inline__item--level-4 {
  font-size: 13px;
}

.article-content-toc-inline__toggle {
  border: none;
  background: transparent;
  padding: 4px 4px 0;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
}

.article-content-toc-inline__toggle:hover {
  color: #0f172a;
}

.article-content-toc-inline__empty {
  font-size: 12px;
  color: #64748b;
}

.article-content-nav-indicator {
  position: fixed;
  left: clamp(
    12px,
    calc(
      var(--sidebar-left-width) + var(--sidebar-left-offset) +
        var(--content-left-gap) + var(--content-padding-horizontal) + 200px
    ),
    520px
  );
  top: calc(var(--header-height) + 140px);
  z-index: 40;
  display: flex;
  align-items: flex-start;
  transition: opacity 0.18s ease;
}

.article-content-nav-indicator--hidden {
  opacity: 0;
  pointer-events: none;
}

.article-content-nav-indicator__headers {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 8px;
  max-height: calc(100vh - var(--header-height) - 180px);
  overflow-y: auto;
  overscroll-behavior: contain;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.84);
  border: 1px solid rgba(203, 213, 225, 0.7);
  backdrop-filter: blur(4px);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
}

.article-content-nav-indicator__line {
  width: 18px;
  height: 2px;
  border: none;
  border-radius: 999px;
  background: #64748b;
  cursor: pointer;
  opacity: 0.75;
  transform: scaleX(0.45);
  transform-origin: left center;
  transition: transform 0.22s ease, opacity 0.22s ease, background 0.22s ease;
}

.article-content-nav-indicator__line--show,
.article-content-nav-indicator__line:hover,
.article-content-nav-indicator__line:focus-visible {
  opacity: 1;
  transform: scaleX(1);
  background: #0284c7;
}

.article-content-nav-indicator__line:focus-visible {
  outline: 2px solid #7dd3fc;
  outline-offset: 2px;
}

.article-content-nav-indicator__line--level-3 {
  width: 13px;
}

.article-content-nav-indicator__line--level-4 {
  width: 10px;
}

.article-content-toc {
  text-align: left;
}

.article-content-toc--floating {
  position: absolute;
  left: 38px;
  top: -10px;
  width: min(430px, calc(100vw - 72px));
  background: #f8fafc;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.16);
  padding: 18px 14px;
  opacity: 0;
  pointer-events: none;
  transform: translateY(8px) scale(0.98);
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.article-content-toc--open {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0) scale(1);
}

.article-content-toc--mobile {
  width: 100%;
  max-width: 1000px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  padding: 24px 24px;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  margin-bottom: 24px;
  display: none;
}

.article-content-toc__title {
  font-family: "Poppins", sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 14px;
}

.article-content-toc__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: min(62vh, 520px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 4px;
}

.article-content-toc__item {
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 9px 10px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  color: #1e293b;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.article-content-toc__item:hover {
  background: #e5e7eb;
  color: #0f172a;
  transform: translateX(2px);
}

.article-content-toc__item:focus-visible {
  outline: 2px solid #7dd3fc;
  outline-offset: 2px;
}

.article-content-toc__item--level-2 {
  padding-left: 12px;
}

.article-content-toc__item--level-3,
.article-content-toc__item--level-4 {
  padding-left: 20px;
}

.article-content-toc__item--level-3::before,
.article-content-toc__item--level-4::before {
  content: "•";
  margin-right: 10px;
  color: #64748b;
}

.article-content-toc__item--level-4 {
  font-size: 14px;
  color: #64748b;
}

.article-content-toc__empty {
  font-size: 14px;
  color: #64748b;
}

/* Типографика статьи */
.article-content-body :deep(h1),
.article-content-body :deep(h2),
.article-content-body :deep(h3),
.article-content-body :deep(h4),
.article-content-body :deep(h5),
.article-content-body :deep(h6) {
  color: #1a202c;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 16px;
  line-height: 1.4;
  text-align: left;
}

.article-content-body :deep(h1) {
  font-size: 28px;
}

.article-content-body :deep(h2) {
  font-size: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e2e8f0;
}

.article-content-body :deep(h3) {
  font-size: 20px;
}

.article-content-body :deep(h4) {
  font-size: 18px;
}

.article-content-body :deep(p) {
  margin: 0;
  line-height: 1.5;
}

.article-content-body :deep(ul),
.article-content-body :deep(ol) {
  margin: 0;
  padding: 0;
  text-align: left;
}

.article-content-body :deep(li) {
  margin-bottom: 0;
  padding-left: 0;
  text-indent: 0;
}

.article-content-body :deep(blockquote) {
  margin: 24px 0;
  padding: 20px 24px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-left: 4px solid #0095ec;
  border-radius: 0 12px 12px 0;
  font-style: italic;
  color: #334155;
  text-indent: 0;
}

.article-content-body :deep(blockquote p) {
  text-indent: 0;
}

.article-content-body :deep(code) {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: "Monaco", "Consolas", "Courier New", monospace;
  font-size: 14px;
  color: #e11d48;
}

.article-content-body :deep(pre) {
  background: #1e293b;
  color: #e2e8f0;
  padding: 20px 24px;
  border-radius: 12px;
  overflow-x: auto;
  margin: 24px 0;
  text-align: left;
}

.article-content-body :deep(pre code) {
  background: none;
  color: inherit;
  padding: 0;
}

.article-content-body :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  margin: 24px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.article-content-body :deep(a) {
  color: #0095ec;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s ease;
}

.article-content-body :deep(a:hover) {
  border-bottom-color: #0095ec;
}

.article-content-body :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 24px 0;
  border-radius: 0;
  overflow: visible;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.article-content-body :deep(th),
.article-content-body :deep(td) {
  padding: 14px 18px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  text-indent: 0;
}

.article-content-body :deep(th) {
  background: #f8fafc;
  font-weight: 600;
  color: #1a202c;
}

.article-content-body :deep(tr:last-child td) {
  border-bottom: none;
}

.article-content-body :deep(tr:hover td) {
  background: #f8fafc;
}

.article-content-body :deep(strong),
.article-content-body :deep(b) {
  font-weight: 600;
  color: #1a202c;
}

.article-content-body :deep(em),
.article-content-body :deep(i) {
  font-style: italic;
}

.article-content-body :deep(mark) {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  padding: 2px 6px;
  border-radius: 4px;
}

.article-content-body :deep(hr) {
  border: none;
  height: 2px;
  background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  margin: 32px 0;
}

.article-content-body :deep(.article-heading-highlight) {
  background: #fff7d6;
  border-radius: 6px;
  transition: background 0.2s ease;
}

/* Поддержка inline-стилей из CKEditor */
/* Приоритет у форматирования редактора */
.article-content-body :deep(p[style*="text-align:center"]),
.article-content-body :deep(p[style*="text-align: center"]) {
  text-align: center !important;
}

.article-content-body :deep(p[style*="text-align:right"]),
.article-content-body :deep(p[style*="text-align: right"]) {
  text-align: right !important;
}

.article-content-body :deep(p[style*="text-align:left"]),
.article-content-body :deep(p[style*="text-align: left"]) {
  text-align: left !important;
}

.article-content-body :deep(p[style*="text-align:justify"]),
.article-content-body :deep(p[style*="text-align: justify"]) {
  text-align: justify !important;
}

/* Сохраняем inline-типографику из редактора (font-size/font-family и др.) */

/* ========================================
         ПРАКТИКА КОНТЕНТ
         ======================================== */

.practice-content-header {
  width: 100%;
  max-width: 1400px;
  text-align: left;
  margin-bottom: 32px;
}

.practice-content-title {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  text-align: left;
}

.practice-content-body {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.practice-split {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.practice-split-main,
.practice-split-aside {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.practice-split-aside .practice-test-section {
  width: 100%;
  max-width: 100%;
  align-self: stretch;
}

.practice-section {
  background: #ffffff;
  padding: 28px 32px;
}

.rich-text-content {
  color: #374151;
  font-size: 16px;
  line-height: 1.7;
}

.rich-text-content :deep(p) {
  margin: 0 0 14px;
}

.rich-text-content :deep(p:last-child) {
  margin-bottom: 0;
}

.rich-text-content :deep(ul),
.rich-text-content :deep(ol) {
  margin: 0 0 14px;
  padding-left: 1.4em;
  list-style-position: outside;
}

.rich-text-content :deep(ul) {
  list-style-type: disc;
}

.rich-text-content :deep(ol) {
  list-style-type: decimal;
}

.rich-text-content :deep(li) {
  margin: 0 0 6px;
}

.rich-text-content :deep(a) {
  color: #1d4ed8;
  text-decoration: underline;
}

.rich-text-content :deep(em),
.rich-text-content :deep(i) {
  font-style: italic !important;
}

.rich-text-content :deep(strong),
.rich-text-content :deep(b) {
  font-weight: 700 !important;
}

.rich-text-content :deep(u) {
  text-decoration: underline !important;
}

.rich-text-content :deep(s),
.rich-text-content :deep(del) {
  text-decoration: line-through !important;
}

.rich-text-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 0 0 14px;
}

.rich-text-content :deep(th),
.rich-text-content :deep(td) {
  border: 1px solid #d1d5db;
  padding: 8px 10px;
  vertical-align: top;
}

.practice-section.materials-section {
  background: #ffffff;
  padding: 24px 28px;
  border-radius: 20px;
  border: 1px solid #dbeafe;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.06);
  width: 100%;
  max-width: 1000px;
  align-self: flex-start;
}

.practice-section.materials-section .practice-section-title {
  font-size: 18px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.practice-section.materials-section .material-download-button {
  background: transparent;
  box-shadow: none;
  color: #1f2937;
  padding: 0;
  font-size: 14px;
}

.practice-section.materials-section .material-download-button:hover {
  color: #0f172a;
  text-decoration: underline;
}

.practice-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #d1fae5;
}

.practice-list {
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: practice-counter;
}

.practice-list li {
  position: relative;
  margin-bottom: 14px;
  padding-left: 48px;
  font-size: 15px;
  line-height: 1.7;
  color: #4a5568;
  counter-increment: practice-counter;
}

.practice-list li::before {
  content: counter(practice-counter);
  position: absolute;
  left: 0;
  top: 0;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

/* ========================================
         ТЕСТ ВНУТРИ ПРАКТИКИ
         ======================================== */

.practice-test-section {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  border: 2px solid #7dd3fc;
  border-left: 4px solid #0284c7;
  border-radius: 20px;
  padding: 24px 26px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 4px 16px rgba(14, 165, 233, 0.15);
}

.practice-test-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.screen8-inline-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.screen8-inline-icon--book {
  width: 22px;
  height: 22px;
}

.screen8-inline-icon--file {
  width: 18px;
  height: 18px;
}

.screen8-inline-icon--flask,
.screen8-inline-icon--check-circle,
.screen8-inline-icon--lock {
  width: 22px;
  height: 22px;
}

.screen8-inline-icon--upload {
  width: 38px;
  height: 38px;
  display: block;
  margin: 0 auto 10px;
}

.practice-test-title {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #0c4a6e;
  display: flex;
  align-items: center;
  gap: 10px;
}

.practice-test-title::before {
  content: "";
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M9 2h6v2l-1 1v4.2l4.9 8.1A3 3 0 0 1 16.3 22H7.7a3 3 0 0 1-2.6-4.7L10 9.2V5L9 4V2Zm-.3 9.2-2.9 4.8h12.4l-2.9-4.8H8.7Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M9 2h6v2l-1 1v4.2l4.9 8.1A3 3 0 0 1 16.3 22H7.7a3 3 0 0 1-2.6-4.7L10 9.2V5L9 4V2Zm-.3 9.2-2.9 4.8h12.4l-2.9-4.8H8.7Z' fill='black'/%3E%3C/svg%3E");
}

.practice-test-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 14px;
  color: #0c4a6e;
}

.practice-test-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  /* background: rgba(255, 255, 255, 0.15); */
  border-radius: 10px;
  font-size: 13px;
}

.open-test-button {
  padding: 14px 28px;
  border-radius: 14px;
  border: none;
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: #ffffff;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 14px rgba(14, 165, 233, 0.4);
}

.open-test-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(14, 165, 233, 0.5);
}

.open-test-button:active {
  transform: translateY(0);
}

.open-test-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.practice-test-inline {
  /* background: linear-gradient(180deg, #559de6 0%, #3c76c3 100%); */
  color: #ffffff;
}

.practice-test-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.practice-test-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  /* background: rgba(255, 255, 255, 0.2); */
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  color: #0c4a6e;
}

.practice-test-duration {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  /* background: rgba(255, 255, 255, 0.15); */
  border-radius: 10px;
  font-size: 13px;
  color: #0c4a6e;
}

.practice-test-note {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(12, 74, 110, 0.08);
  border-radius: 10px;
  font-weight: 600;
  color: #0c4a6e;
}

/* ========================================
       PRACTICE QUIZ - IMPROVED DESIGN WITH SCROLL
       ======================================== */

/* Quiz Container with Scroll */
.practice-quiz-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;

  /* Скролл для показа 2 вопросов */
  max-height: 680px;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  padding-right: 12px;
  margin-right: -12px;

  /* Плавное появление тени при скролле */
  mask-image: linear-gradient(
    to bottom,
    transparent 0,
    black 8px,
    black calc(100% - 8px),
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0,
    black 8px,
    black calc(100% - 8px),
    transparent 100%
  );
}


/* Кастомный скроллбар для Quiz */
.practice-quiz-body::-webkit-scrollbar {
  width: 8px;
}

.practice-quiz-body::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  margin: 8px 0;
}

.practice-quiz-body::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: padding-box;
  transition: background 0.3s ease;
}

.practice-quiz-body::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #5a67d8 0%, #6b46a3 100%);
  background-clip: padding-box;
}

/* Firefox scrollbar */
.practice-quiz-body {
  scrollbar-width: thin;
  scrollbar-color: #667eea rgba(255, 255, 255, 0.3);
}

/* Индикатор скролла */
.practice-quiz-scroll-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.1) 0%,
    rgba(118, 75, 162, 0.1) 100%
  );
  border-radius: 12px;
  margin-top: 8px;
  color: #667eea;
  font-size: 13px;
  font-weight: 500;
  animation: pulseScroll 2s ease-in-out infinite;
}

@keyframes pulseScroll {
  0%,
  100% {
    opacity: 0.7;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

.practice-quiz-scroll-indicator svg {
  animation: bounceArrow 1.5s ease-in-out infinite;
}

@keyframes bounceArrow {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(4px);
  }
}

/* Question Card */
.practice-quiz-question {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border: 2px solid #e2e8f0;
  border-radius: 20px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  min-height: 280px;
}

.practice-quiz-question::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px 0 0 4px;
}

.practice-quiz-question.is-correct {
  background: linear-gradient(145deg, #ecfdf5 0%, #d1fae5 100%);
  border-color: #10b981;
}

.practice-quiz-question.is-correct::before {
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
}

.practice-quiz-question.is-wrong {
  background: linear-gradient(145deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #ef4444;
}

.practice-quiz-question.is-wrong::before {
  background: linear-gradient(180deg, #ef4444 0%, #dc2626 100%);
}

/* Question Header */
.practice-quiz-question-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.practice-quiz-question-number {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.practice-quiz-question.is-correct .practice-quiz-question-number {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.practice-quiz-question.is-wrong .practice-quiz-question-number {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.practice-quiz-question-type {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.practice-quiz-question.is-correct .practice-quiz-question-type {
  background: rgba(16, 185, 129, 0.15);
  color: #059669;
}

.practice-quiz-question.is-wrong .practice-quiz-question-type {
  background: rgba(239, 68, 68, 0.15);
  color: #dc2626;
}

/* Question Title */
.practice-quiz-question-title {
  font-weight: 600;
  font-size: 17px;
  line-height: 1.6;
  color: #1e293b;
  padding-left: 4px;
}

/* Answers Container */
.practice-quiz-answers {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Answer Item */
.practice-quiz-answer {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
  position: relative;
}

.practice-quiz-answer:hover:not(.is-disabled) {
  border-color: #cbd5e1;
  background: #f8fafc;
  transform: translateX(4px);
}

.practice-quiz-answer.is-selected {
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  border-color: #818cf8;
}

.practice-quiz-answer.is-correct-answer {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-color: #10b981;
}

.practice-quiz-answer.is-wrong-answer {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #ef4444;
}

.practice-quiz-answer.is-disabled {
  cursor: default;
}

/* Hidden native input */
.practice-quiz-input-hidden {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
}

/* Custom Radio */
.practice-quiz-answer-radio {
  width: 22px;
  height: 22px;
  border: 2px solid #cbd5e1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  background: #ffffff;
}

.practice-quiz-answer.is-selected .practice-quiz-answer-radio {
  border-color: #818cf8;
  background: #ffffff;
}

.practice-quiz-answer.is-correct-answer .practice-quiz-answer-radio {
  border-color: #10b981;
}

.practice-quiz-answer.is-wrong-answer .practice-quiz-answer-radio {
  border-color: #ef4444;
}

.practice-quiz-answer-radio-dot {
  width: 10px;
  height: 10px;
  background: #818cf8;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0);
  transition: all 0.2s ease;
}

.practice-quiz-answer.is-selected .practice-quiz-answer-radio-dot {
  opacity: 1;
  transform: scale(1);
}

.practice-quiz-answer.is-correct-answer .practice-quiz-answer-radio-dot {
  background: #10b981;
  opacity: 1;
  transform: scale(1);
}

.practice-quiz-answer.is-wrong-answer .practice-quiz-answer-radio-dot {
  background: #ef4444;
  opacity: 1;
  transform: scale(1);
}

/* Custom Checkbox */
.practice-quiz-answer-checkbox {
  width: 22px;
  height: 22px;
  border: 2px solid #cbd5e1;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
  background: #ffffff;
  color: #ffffff;
}

.practice-quiz-answer.is-selected .practice-quiz-answer-checkbox {
  border-color: #818cf8;
  background: #818cf8;
}

.practice-quiz-answer.is-correct-answer .practice-quiz-answer-checkbox {
  border-color: #10b981;
  background: #10b981;
}

.practice-quiz-answer.is-wrong-answer .practice-quiz-answer-checkbox {
  border-color: #ef4444;
  background: #ef4444;
}

/* Answer Text */
.practice-quiz-answer-text {
  flex: 1;
  font-size: 15px;
  line-height: 1.5;
  color: #334155;
}

/* Answer Status Icon */
.practice-quiz-answer-status {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.practice-quiz-answer-status--correct {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
}

.practice-quiz-answer-status--wrong {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

/* Text Answer */
.practice-quiz-text-answer {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.practice-quiz-text-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.practice-quiz-text-input {
  width: 100%;
  padding: 16px 50px 16px 18px;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  background: #ffffff;
  color: #1e293b;
  font-size: 15px;
  font-family: inherit;
  transition: all 0.25s ease;
  box-sizing: border-box;
}

.practice-quiz-text-input::placeholder {
  color: #94a3b8;
}

.practice-quiz-text-input:focus {
  outline: none;
  border-color: #818cf8;
  box-shadow: 0 0 0 4px rgba(129, 140, 248, 0.15);
}

.practice-quiz-text-input:disabled {
  background: #f8fafc;
  cursor: not-allowed;
}

.practice-quiz-text-input.is-correct {
  border-color: #10b981;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
}

.practice-quiz-text-input.is-wrong {
  border-color: #ef4444;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
}

.practice-quiz-text-status {
  position: absolute;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.practice-quiz-text-status--correct {
  color: #10b981;
}

.practice-quiz-text-status--wrong {
  color: #ef4444;
}

.practice-quiz-correct-answer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border-radius: 12px;
  border-left: 4px solid #10b981;
  font-size: 14px;
  color: #065f46;
}

.practice-quiz-correct-answer svg {
  color: #10b981;
  flex-shrink: 0;
}

/* Explanation Block */
.practice-quiz-explanation {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 14px;
  padding: 16px 20px;
  margin-top: 4px;
}

.practice-quiz-question.is-correct .practice-quiz-explanation {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-color: #86efac;
}

.practice-quiz-question.is-wrong .practice-quiz-explanation {
  background: linear-gradient(135deg, #fef2f2 0%, #fecaca 100%);
  border-color: #fca5a5;
}

.practice-quiz-explanation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #0369a1;
  font-weight: 600;
  font-size: 14px;
}

.practice-quiz-question.is-correct .practice-quiz-explanation-header {
  color: #059669;
}

.practice-quiz-question.is-wrong .practice-quiz-explanation-header {
  color: #dc2626;
}

.practice-quiz-explanation-content {
  font-size: 14px;
  line-height: 1.7;
  color: #334155;
}

.practice-quiz-explanation-empty {
  font-style: italic;
  color: #94a3b8;
}

/* Quiz Actions */
.practice-quiz-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.practice-quiz-actions-left,
.practice-quiz-actions-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Result Block */
.practice-quiz-result {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  border-radius: 16px;
  transition: all 0.3s ease;
}

.practice-quiz-result--success {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 2px solid #10b981;
  color: #065f46;
}

.practice-quiz-result--warning {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 2px solid #f59e0b;
  color: #92400e;
}

.practice-quiz-result--fail {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 2px solid #ef4444;
  color: #991b1b;
}

.practice-quiz-result-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.practice-quiz-result-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.practice-quiz-result-title {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}

.practice-quiz-result-score {
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-weight: 700;
}

.practice-quiz-result-value {
  font-size: 24px;
}

.practice-quiz-result-separator {
  font-size: 18px;
  opacity: 0.5;
}

.practice-quiz-result-total {
  font-size: 18px;
  opacity: 0.7;
}

.practice-quiz-result-percent {
  font-size: 14px;
  opacity: 0.6;
  margin-left: 4px;
}

/* Buttons */
.practice-quiz-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 28px;
  border-radius: 14px;
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
}

.practice-quiz-btn--check {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.practice-quiz-btn--check:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 28px rgba(102, 126, 234, 0.5);
}

.practice-quiz-btn--check:active {
  transform: translateY(-1px);
}

.practice-quiz-btn--reset {
  background: #ffffff;
  color: #667eea;
  border: 2px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.practice-quiz-btn--reset:hover {
  border-color: #667eea;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

/* Practice Quiz Large Screens */
@media (min-width: 1440px) {
  .practice-test-section {
    max-width: 100%;
    align-self: stretch;
    padding: 18px 20px;
    gap: 12px;
  }

  .practice-test-title {
    font-size: 16px;
  }

  .practice-test-meta {
    gap: 8px;
    font-size: 13px;
  }

  .practice-test-meta-item,
  .practice-test-label,
  .practice-test-duration {
    padding: 4px 10px;
    font-size: 12px;
  }

  .practice-quiz-body {
    gap: 14px;
    margin-top: 16px;
    max-height: 560px;
    padding-right: 8px;
    margin-right: -8px;
  }

  .practice-quiz-question {
    padding: 18px;
    border-radius: 16px;
    min-height: 220px;
    gap: 12px;
  }

  .practice-quiz-question-number {
    width: 32px;
    height: 32px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
  }

  .practice-quiz-question-title {
    font-size: 15px;
  }

  .practice-quiz-answers {
    gap: 8px;
  }

  .practice-quiz-answer {
    padding: 10px 14px;
    gap: 10px;
    border-radius: 12px;
  }

  .practice-quiz-answer-text {
    font-size: 14px;
  }

  .practice-quiz-answer-status {
    width: 24px;
    height: 24px;
  }

  .practice-quiz-text-input {
    padding: 12px 42px 12px 14px;
    font-size: 14px;
    border-radius: 12px;
  }

  .practice-quiz-explanation {
    padding: 12px 16px;
    border-radius: 12px;
  }

  .practice-quiz-actions {
    gap: 16px;
  }

  .practice-quiz-result {
    padding: 12px 18px;
    border-radius: 14px;
  }

  .practice-quiz-result-value {
    font-size: 20px;
  }

  .practice-quiz-btn {
    padding: 10px 18px;
    font-size: 14px;
    border-radius: 12px;
  }

  .practice-quiz-btn--check {
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
  }

  .practice-quiz-btn--check:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.3);
  }
}

@media (min-width: 1200px) {
  .practice-split {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(360px, 560px);
    align-items: start;
  }

  .practice-split.practice-split--single {
    grid-template-columns: minmax(0, 1fr);
  }
}
/* Practice Quiz Responsive */
@media (max-width: 768px) {
  .practice-quiz-body {
    max-height: 520px;
    padding-right: 8px;
    margin-right: -8px;
  }

  .practice-quiz-question {
    padding: 18px;
    border-radius: 16px;
    min-height: 220px;
  }

  .practice-quiz-question-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .practice-quiz-answer {
    padding: 12px 14px;
    gap: 12px;
  }

  .practice-quiz-actions {
    flex-direction: column;
    align-items: stretch;
    padding: 18px;
  }

  .practice-quiz-actions-left,
  .practice-quiz-actions-right {
    justify-content: center;
  }

  .practice-quiz-btn {
    width: 100%;
    justify-content: center;
  }

  .practice-quiz-result {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .practice-quiz-body {
    max-height: 450px;
  }

  .practice-quiz-question {
    padding: 14px;
    min-height: 180px;
  }

  .practice-quiz-question-number {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  .practice-quiz-question-title {
    font-size: 15px;
  }

  .practice-quiz-answer-text {
    font-size: 14px;
  }

  .practice-quiz-result-value {
    font-size: 20px;
  }
}

/* ========================================
         ТЕСТ КОНТЕНТ
         ======================================== */

.test-content-header {
  width: 100%;
  max-width: 1400px;
  text-align: left;
  margin-bottom: 32px;
}

.test-content-title {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  text-align: left;
}

.final-test-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #7c2d12;
  background: #ffedd5;
  border: 1px solid #fed7aa;
}

.test-content-body {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 0;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  padding: 28px 32px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.test-section {
  background: transparent;
  padding: 20px 0;
  border-radius: 0;
  box-shadow: none;
  border: none;
}

.test-section + .test-section {
  border-top: 1px solid #e2e8f0;
}

.test-section:first-child {
  padding-top: 0;
}

.test-section:last-child {
  padding-bottom: 0;
}

.test-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.test-section-title::before {
  content: none;
}

/* Мета-информация теста */
.test-meta {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.test-meta li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: background 0.2s ease;
}

.test-meta li:hover {
  background: #f1f5f9;
}

.test-meta-label {
  font-weight: 500;
  color: #64748b;
  font-size: 13px;
}

.test-meta-value {
  font-weight: 600;
  color: #0f172a;
  font-size: 15px;
}

/* Результаты теста */
.test-results-block {
  margin: 0;
  padding: 24px 28px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
}

.test-results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.test-section + .test-results-block {
  margin-top: 20px;
}

.test-results-block + .test-section {
  border-top: 1px solid #e2e8f0;
}

.test-results-title {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #0f172a;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.test-results-title::before {
  content: "";
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: inline-block;
  color: #10b981;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.8 6.8a1 1 0 0 0-1.4 0l-4.8 4.8-1.9-1.9a1 1 0 1 0-1.4 1.4l2.6 2.6a1 1 0 0 0 1.4 0l5.5-5.5a1 1 0 0 0 0-1.4Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.8 6.8a1 1 0 0 0-1.4 0l-4.8 4.8-1.9-1.9a1 1 0 1 0-1.4 1.4l2.6 2.6a1 1 0 0 0 1.4 0l5.5-5.5a1 1 0 0 0 0-1.4Z' fill='black'/%3E%3C/svg%3E");
}

.test-results-refresh {
  border: 1px solid #cbd5f5;
  border-radius: 10px;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 12px;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;
}

.test-results-refresh:hover {
  border-color: #94a3f5;
  color: #1d4ed8;
  background: #eef2ff;
}

.test-results-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f1f5f9;
}

.test-results-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.test-results-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 12px 14px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.test-results-label {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.test-results-value {
  font-weight: 500;
  color: #0f172a;
  font-size: 16px;
}

.test-results-value--success {
  color: #059669;
  font-weight: 600;
}

.test-results-value--fail {
  color: #dc2626;
  font-weight: 600;
}

/* ========================================
         ДОМАШНЕЕ ЗАДАНИЕ КОНТЕНТ
         ======================================== */

.homework-content-header {
  width: 100%;
  max-width: 1400px;
  text-align: left;
  margin-bottom: 32px;
}

.homework-content-title {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
  text-align: left;
}

.homework-content-body {
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 0;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #e2e8f0;
  border-radius: 22px;
  padding: 24px 28px;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.05);
}

.homework-section {
  background: transparent;
  padding: 18px 0;
  border-radius: 0;
  box-shadow: none;
  border: none;
}

.homework-section + .homework-section {
  border-top: 1px solid #e2e8f0;
}

.homework-section:first-child {
  padding-top: 0;
}

.homework-section:last-child {
  padding-bottom: 0;
}

.homework-section--description {
  font-size: 16px;
  line-height: 1.75;
  color: #374151;
}

.homework-section--description :deep(p) {
  margin: 0 0 16px;
}

.homework-section--description :deep(p:last-child) {
  margin-bottom: 0;
}

.homework-section--revision-upload {
  margin-top: 8px;
  padding: 20px 22px;
  border-radius: 18px;
  border: 1px solid rgba(59, 130, 246, 0.25);
  background: linear-gradient(
    180deg,
    rgba(219, 234, 254, 0.45),
    rgba(255, 255, 255, 0.95)
  );
  box-shadow: 0 10px 22px rgba(59, 130, 246, 0.08);
}

.homework-section--revision-upload .homework-section-title {
  color: #1d4ed8;
}

.homework-section--revision-upload .homework-upload {
  background: transparent;
}

.homework-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 12px;
  padding-bottom: 0;
  border-bottom: none;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.homework-section-title::before {
  content: none;
}

.homework-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.homework-list li {
  position: relative;
  margin-bottom: 10px;
  padding: 0 0 0 18px;
  background: transparent;
  border-radius: 0;
  border-bottom: none;
  font-size: 15px;
  line-height: 1.65;
  color: #4b5563;
  transition: color 0.2s ease;
}

.homework-list li:hover {
  color: #1f2937;
}

.homework-list li:last-child {
  margin-bottom: 0;
}

.homework-list li::before {
  content: "-";
  position: absolute;
  left: 4px;
  top: 10px;
  font-size: 18px;
}

/* Мета-информация домашки */
.homework-meta {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px 18px;
}

.homework-meta li {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  background: transparent;
  border-radius: 0;
  border: none;
  font-size: 14px;
}

.homework-meta-label {
  font-weight: 500;
  color: #64748b;
}

.homework-meta-value {
  font-weight: 600;
  color: #0f172a;
}

/* Состояние ответа */
.homework-status-table,
.homework-review-table {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}

.homework-status-table table,
.homework-review-table table {
  width: 100%;
  border-collapse: collapse;
}

.homework-review-row--grade th,
.homework-review-row--grade td {
  background: #eaf7ec;
}

.test-review-row--low th,
.test-review-row--low td {
  background: #fde2e2;
}
.homework-review-feedback {
  white-space: pre-wrap;
  color: #334155;
}

.homework-status-table th,
.homework-status-table td,
.homework-review-table th,
.homework-review-table td {
  padding: 12px 16px;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid #e2e8f0;
  font-size: 14px;
  color: #0f172a;
}

.homework-status-table th,
.homework-review-table th {
  width: 260px;
  background: #f8fafc;
  color: #334155;
  font-weight: 600;
}

.homework-status-table tr:last-child th,
.homework-status-table tr:last-child td,
.homework-review-table tr:last-child th,
.homework-review-table tr:last-child td {
  border-bottom: none;
}

.homework-status-row--late th,
.homework-status-row--late td {
  background: #fef2f2;
}

.homework-status-row--on-time th,
.homework-status-row--on-time td {
  background: #ecfdf3;
}

.homework-status-files {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.homework-status-file {
  display: flex;
  align-items: center;
  gap: 6px;
}

.homework-status-file-link {
  color: #0f172a;
  text-decoration: underline;
}

.homework-status-file-link:hover {
  color: #111827;
}

.homework-status-file-name {
  color: #0f172a;
}

.homework-status-empty {
  color: #94a3b8;
  font-size: 13px;
}

.homework-status-comments {
  color: #0f172a;
  font-weight: 600;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  text-align: left;
}

.homework-status-comments:hover {
  color: #2563eb;
}

.homework-comment-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.homework-comment-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
}

.homework-comment-modal__card {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.2);
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.homework-comment-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.homework-comment-modal__header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #0f172a;
}

.homework-comment-modal__close {
  border: none;
  background: #f1f5f9;
  color: #475569;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
}

.homework-comment-modal__textarea {
  width: 100%;
  min-height: 140px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px;
  font-size: 14px;
  resize: vertical;
}

.homework-comment-modal__textarea:disabled {
  background: #f8fafc;
  color: #94a3b8;
}

.homework-comment-modal__note {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.homework-comment-modal__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.homework-comment-modal__cancel {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
}

.homework-comment-modal__submit {
  border: none;
  background: #2563eb;
  color: #ffffff;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
}

.homework-comment-modal__submit:disabled {
  opacity: 0.6;
  cursor: default;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Загрузка файлов */
.homework-upload {
  margin-top: 0;
  padding: 0;
  border-radius: 0;
  border: none;
  /* border-top: 1px solid #e2e8f0; */
  background: transparent;
}

.homework-upload-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.homework-upload-deadline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #0369a1;
  padding: 8px 14px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  width: fit-content;
}

.homework-upload-deadline::before {
  content: "";
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M11 4h2v2h-2V4Zm1 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm1 3h-2v4.4l3.5 2.1 1-1.7-2.5-1.5V10Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M11 4h2v2h-2V4Zm1 3a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm1 3h-2v4.4l3.5 2.1 1-1.7-2.5-1.5V10Z' fill='black'/%3E%3C/svg%3E");
}

.homework-upload-late {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #b91c1c;
  padding: 8px 14px;
  background: #fee2e2;
  border-radius: 8px;
  width: fit-content;
}

.homework-upload-late::before {
  content: "";
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 3 1.8 20.5c-.5.8.1 1.5 1 1.5h18.4c.9 0 1.5-.7 1-1.5L12 3Zm-1 6h2v6h-2V9Zm0 8h2v2h-2v-2Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 3 1.8 20.5c-.5.8.1 1.5 1 1.5h18.4c.9 0 1.5-.7 1-1.5L12 3Zm-1 6h2v6h-2V9Zm0 8h2v2h-2v-2Z' fill='black'/%3E%3C/svg%3E");
}

.homework-upload-blocked {
  padding: 16px 18px;
  border-radius: 12px;
  background: #fef2f2;
  color: #991b1b;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.homework-upload-blocked::before {
  content: "";
  width: 24px;
  height: 24px;
  margin-right: 10px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a5 5 0 0 1 5 5v3h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h1V7a5 5 0 0 1 5-5Zm3 8V7a3 3 0 0 0-6 0v3h6Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a5 5 0 0 1 5 5v3h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h1V7a5 5 0 0 1 5-5Zm3 8V7a3 3 0 0 0-6 0v3h6Z' fill='black'/%3E%3C/svg%3E");
}

.homework-upload-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.homework-file-input {
  display: none;
}

.homework-upload-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.homework-upload-button {
  background: #ffffff;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 10px 18px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  box-shadow: none;
}

.homework-upload-button:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.homework-upload-hint {
  color: #64748b;
  font-size: 13px;
}

.homework-upload-formats {
  margin: 10px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.45;
}

.homework-upload-zone {
  padding: 26px 20px;
  border-radius: 12px;
  border: 1px dashed #cbd5e1;
  text-align: center;
  font-size: 14px;
  color: #475569;
  background: #f8fafc;
  transition: all 0.2s ease;
  cursor: pointer;
}

.homework-upload-zone::before {
  content: "";
  display: block;
  width: 40px;
  height: 40px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 12px;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M11 3h2v9.2l2.8-2.8 1.4 1.4-5.2 5.2-5.2-5.2 1.4-1.4 2.8 2.8V3Zm-7 14h16v4H4v-4Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M11 3h2v9.2l2.8-2.8 1.4 1.4-5.2 5.2-5.2-5.2 1.4-1.4 2.8 2.8V3Zm-7 14h16v4H4v-4Z' fill='black'/%3E%3C/svg%3E");
}

.homework-upload-zone--drag {
  border-color: #0ea5e9;
  background: #e0f2fe;
  transform: none;
}

/* Список файлов */
.homework-files-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.homework-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-radius: 0;
  background: transparent;
  border-bottom: 1px solid #e2e8f0;
  transition: color 0.2s ease;
}

.homework-file-item:hover {
  transform: none;
}

.homework-file-name {
  flex: 1;
  font-size: 14px;
  color: #4a5568;
  word-break: break-all;
  display: flex;
  align-items: center;
  gap: 10px;
}

.homework-file-name::before {
  content: "";
  width: 18px;
  height: 18px;
  display: inline-block;
  flex-shrink: 0;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M6 2h8l4 4v16H6V2Zm8 1.5V7h3.5L14 3.5Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M6 2h8l4 4v16H6V2Zm8 1.5V7h3.5L14 3.5Z' fill='black'/%3E%3C/svg%3E");
}

.homework-file-link {
  color: #0f172a;
  text-decoration: none;
  font-size: 14px;
  word-break: break-all;
  transition: color 0.2s ease;
}

.homework-file-link:hover {
  color: #111827;
  text-decoration: underline;
}

.homework-file-remove {
  border: none;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.homework-file-remove:hover {
  background: #fee2e2;
}

.homework-existing-files {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
  padding: 14px 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.homework-existing-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 12px;
  color: #64748b;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.homework-existing-title::before {
  content: "";
  width: 16px;
  height: 16px;
  margin-right: 6px;
  display: inline-block;
  vertical-align: text-bottom;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M3 5h7l2 2h9v12a2 2 0 0 1-2 2H3V5Zm0 4v10h16V9H3Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M3 5h7l2 2h9v12a2 2 0 0 1-2 2H3V5Zm0 4v10h16V9H3Z' fill='black'/%3E%3C/svg%3E");
}

.homework-submitted-at {
  font-size: 13px;
  color: #059669;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}

.homework-submitted-at::before {
  content: "";
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.8 6.8a1 1 0 0 0-1.4 0l-4.8 4.8-1.9-1.9a1 1 0 1 0-1.4 1.4l2.6 2.6a1 1 0 0 0 1.4 0l5.5-5.5a1 1 0 0 0 0-1.4Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.8 6.8a1 1 0 0 0-1.4 0l-4.8 4.8-1.9-1.9a1 1 0 1 0-1.4 1.4l2.6 2.6a1 1 0 0 0 1.4 0l5.5-5.5a1 1 0 0 0 0-1.4Z' fill='black'/%3E%3C/svg%3E");
}

.homework-upload-status {
  min-height: 20px;
  display: flex;
  align-items: center;
}

.homework-upload-error {
  color: #dc2626;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.homework-upload-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.homework-upload-cancel {
  background: #ffffff;
  color: #0f172a;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 10px 18px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.homework-upload-cancel:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.homework-upload-error::before {
  content: "";
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.7 6.7-1.4-1.4L12 10.6 8.7 7.3 7.3 8.7l3.3 3.3-3.3 3.3 1.4 1.4 3.3-3.3 3.3 3.3 1.4-1.4-3.3-3.3 3.3-3.3Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.7 6.7-1.4-1.4L12 10.6 8.7 7.3 7.3 8.7l3.3 3.3-3.3 3.3 1.4 1.4 3.3-3.3 3.3 3.3 1.4-1.4-3.3-3.3 3.3-3.3Z' fill='black'/%3E%3C/svg%3E");
}

.homework-upload-success {
  color: #059669;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.homework-upload-success::before {
  content: "";
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.8 6.8a1 1 0 0 0-1.4 0l-4.8 4.8-1.9-1.9a1 1 0 1 0-1.4 1.4l2.6 2.6a1 1 0 0 0 1.4 0l5.5-5.5a1 1 0 0 0 0-1.4Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20Zm4.8 6.8a1 1 0 0 0-1.4 0l-4.8 4.8-1.9-1.9a1 1 0 1 0-1.4 1.4l2.6 2.6a1 1 0 0 0 1.4 0l5.5-5.5a1 1 0 0 0 0-1.4Z' fill='black'/%3E%3C/svg%3E");
}

.homework-submit-button {
  align-self: flex-start;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #ffffff;
  border: none;
  border-radius: 14px;
  padding: 14px 32px;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
}

.homework-submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(5, 150, 105, 0.4);
}

.homework-submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.homework-upload-compact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.homework-upload-compact-text {
  font-size: 14px;
  color: #475569;
}

.homework-upload-secondary {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.homework-upload-secondary:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.homework-file-item:last-child {
  border-bottom: none;
}

.homework-list li::before {
  content: "-";
  position: absolute;
  left: 0;
  top: 0;
  font-size: 16px;
  color: #0f172a;
}

/* ========================================
         МАТЕРИАЛЫ - ОБЩИЕ СТИЛИ
         ======================================== */

.lesson-materials-block {
  width: 100%;
  max-width: 1000px;
  margin: 24px 0 0;
  padding: 24px 28px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  align-self: flex-start;
}

.materials-section {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 20px 0;
  background: transparent;
  border-radius: 0;
}

.lesson-materials-group {
  background: transparent;
  border-radius: 0;
  padding: 16px 0;
  border: none;
  box-shadow: none;
}

.lesson-materials-group + .lesson-materials-group {
  border-top: 1px solid #e2e8f0;
}

.lesson-materials-group--additional {
  background: transparent;
  border-color: transparent;
}

.lesson-materials-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.lesson-materials-header .materials-title {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.materials-subtitle {
  font-size: 13px;
  color: #4b5563;
}

.materials-restriction {
  align-self: flex-start;
  font-size: 12px;
  font-weight: 600;
  color: #0369a1;
  background: #e0f2fe;
  border: 1px dashed #7dd3fc;
  padding: 4px 10px;
  border-radius: 999px;
}

.materials-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 10px;
  padding-bottom: 0;
  border-bottom: none;
}

.materials-title::before {
  content: "";
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: inline-block;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M3 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v14H5a2 2 0 0 0-2 2V5Zm11-1h5a2 2 0 0 1 2 2v15a2 2 0 0 0-2-2h-5V4Zm-9 2v11h7V6H5Zm11 0v11h3V6h-3Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M3 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v14H5a2 2 0 0 0-2 2V5Zm11-1h5a2 2 0 0 1 2 2v15a2 2 0 0 0-2-2h-5V4Zm-9 2v11h7V6H5Zm11 0v11h3V6h-3Z' fill='black'/%3E%3C/svg%3E");
}

.materials-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.materials-item {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 0;
  background: transparent;
  border-radius: 0;
  border-bottom: 1px solid #e2e8f0;
  transition: background 0.2s ease;
}

.materials-item:last-child {
  border-bottom: none;
}

.material-name {
  flex: 0 1 auto;
  font-size: 15px;
  color: #334155;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.material-name--link {
  color: #1d4ed8;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.material-name--link:hover {
  color: #1e40af;
}

.material-name::before {
  content: "";
  width: 18px;
  height: 18px;
  display: inline-block;
  flex-shrink: 0;
  background-color: currentColor;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M6 2h8l4 4v16H6V2Zm8 1.5V7h3.5L14 3.5Z' fill='black'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M6 2h8l4 4v16H6V2Zm8 1.5V7h3.5L14 3.5Z' fill='black'/%3E%3C/svg%3E");
}

.practice-test-title::before,
.test-results-title::before,
.homework-upload-blocked::before,
.homework-upload-zone::before,
.homework-file-name::before,
.homework-existing-title::before,
.homework-submitted-at::before,
.homework-upload-error::before,
.materials-title::before,
.material-name::before {
  content: none !important;
  display: none !important;
}

.material-download-button {
  background: linear-gradient(135deg, #0095ec 0%, #0077cc 100%);
  color: #000000ab;
  text-decoration: none;
  border-radius: 10px;
  padding: 10px 20px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 149, 236, 0.25);
  white-space: nowrap;
  flex-shrink: 0;
}

.material-download-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 149, 236, 0.35);
}

.lesson-materials-block .materials-list {
  gap: 0;
}

.lesson-materials-block .materials-item {
  background: transparent;
  border: none;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: none;
}

.lesson-materials-block .materials-item:hover {
  transform: none;
  background: rgba(15, 23, 42, 0.03);
}

.lesson-materials-block .materials-item:last-child {
  border-bottom: none;
}

.lesson-materials-block .material-download-button {
  border-radius: 12px;
  padding: 10px 22px;
  background: linear-gradient(135deg, #00a1ff 0%, #0086d6 100%);
  box-shadow: 0 6px 16px rgba(0, 149, 236, 0.3);
}

.lesson-materials-block .material-download-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 149, 236, 0.4);
}

/* ========================================
         КНОПКИ ДЕЙСТВИЙ
         ======================================== */

.lesson-actions {
  width: 100%;
  max-width: 1400px;
  margin: 28px auto 0;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.lesson-complete-button {
  background: #eef4fb;
  color: #1f4f78;
  border: 1px solid #cfe0f2;
  border-radius: 12px;
  padding: 10px 18px;
  font-family: "Poppins", sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
}

.lesson-complete-button:hover {
  background: #e3edf8;
  border-color: #c2d6ec;
}

.lesson-complete-button:active {
  background: #d8e8f6;
}

.lesson-complete-button:disabled {
  background: #f3f4f6;
  color: #94a3b8;
  border-color: #e2e8f0;
  cursor: not-allowed;
  box-shadow: none;
}

.test-attempts-info {
  font-size: 14px;
  font-weight: 500;
  color: #1f4f78;
  opacity: 0.8;
}

.final-test-access {
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #7c2d12;
  box-shadow: 0 8px 18px rgba(124, 45, 18, 0.08);
}

.final-test-access__title {
  font-weight: 600;
  margin-bottom: 6px;
}

.final-test-access__list {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.final-test-access__items {
  font-weight: 600;
}

/* Спиннер загрузки */
.loading-spinner-small {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(31, 79, 120, 0.25);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ========================================
         ФОКУС ДЛЯ ДОСТУПНОСТИ
         ======================================== */

.lesson-complete-button:focus-visible,
.material-download-button:focus-visible,
.retry-button:focus-visible,
.progress-refresh-button:focus-visible,
.homework-upload-button:focus-visible,
.homework-submit-button:focus-visible,
.homework-file-remove:focus-visible,
.open-test-button:focus-visible,
.practice-quiz-btn:focus-visible {
  outline: 3px solid #0095ec;
  outline-offset: 3px;
}

/* ========================================
         ОБЩИЕ АДАПТИВНЫЕ СТИЛИ
         ======================================== */

@media (max-width: 1024px) {
  .video-content-wrapper,
  .article-content-wrapper,
  .practice-content-wrapper,
  .test-content-wrapper,
  .homework-content-wrapper {
    padding: 160px 24px 60px;
  }

  .video-content-title,
  .practice-content-title,
  .test-content-title,
  .homework-content-title {
    font-size: 28px;
  }

  .article-content-title {
    font-size: 32px;
  }

  .article-content-body {
    padding: 36px 40px;
  }

  .article-content-body-shell {
    max-width: 1000px;
  }

  .article-content-body-shell .article-content-body {
    width: 100%;
  }

  .article-content-nav-indicator {
    display: none;
  }

  .article-content-toc--mobile {
    display: block;
    padding: 20px 24px;
  }
}

@media (max-width: 768px) {
  .video-content-wrapper,
  .article-content-wrapper,
  .practice-content-wrapper,
  .test-content-wrapper,
  .homework-content-wrapper {
    padding: 140px 16px 40px;
  }

  .video-content-title,
  .practice-content-title,
  .test-content-title,
  .homework-content-title {
    font-size: 24px;
  }

  .article-content-title {
    font-size: 28px;
  }

  .article-content-body {
    padding: 24px 20px;
    font-size: 15px;
  }

  .article-content-toc--mobile {
    padding: 18px 20px;
  }

  .article-content-toc__item {
    font-size: 13px;
  }

  .test-content-body,
  .homework-content-body {
    padding: 20px 20px;
  }

  .practice-section,
  .test-section,
  .homework-section,
  .materials-section {
    padding: 18px 0;
  }

  .lesson-materials-block {
    padding: 20px 20px;
  }

  .lesson-materials-group {
    padding: 14px 0;
  }

  .lesson-complete-button {
    width: 100%;
    justify-content: center;
    padding: 16px 24px;
    font-size: 16px;
  }

  .materials-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .material-download-button {
    width: 100%;
    text-align: center;
  }

  .practice-section.materials-section {
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .video-content-title,
  .practice-content-title,
  .test-content-title,
  .homework-content-title {
    font-size: 20px;
  }

  .article-content-title {
    font-size: 24px;
  }

  .progress-indicators {
    max-width: 100%;
    padding: 0 16px;
    left: 0;
  }

  .test-meta,
  .test-results-grid {
    grid-template-columns: 1fr;
  }

  .homework-upload {
    padding: 0;
  }

  .homework-upload-zone {
    padding: 24px 16px;
  }
}

/* ===== АДАПТИВНОСТЬ SCREEN8 ПОД ДЕСКТОПНЫЕ ДИАПАЗОНЫ ===== */
/* Точечная настройка без body zoom: управляем отступами и ширинами внутри компонента. */

@media (min-width: 769px) and (max-width: 1366px) {
  .u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 {
    --sidebar-left-width: 280px;
    --sidebar-left-offset: 10px;
    --content-left-gap: 10px;
    --content-padding-horizontal: 24px;
  }

  .view-414 {
    left: auto !important;
    width: 100% !important;
  }

  .view-419 {
    max-width: calc(100% - 16px);
    margin-left: 0;
  }

  .video-content-wrapper,
  .article-content-wrapper,
  .practice-content-wrapper,
  .test-content-wrapper,
  .homework-content-wrapper {
    width: 100%;
    min-height: auto;
    padding: 20px var(--content-padding-horizontal) 56px;
    margin-left: 0;
  }
}

@media (min-width: 1367px) and (max-width: 1600px) {
  .u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 {
    --sidebar-left-width: 300px;
    --sidebar-left-offset: 12px;
    --content-left-gap: 12px;
    --content-padding-horizontal: 32px;
  }

  .view-419 {
    max-width: calc(100% - 20px);
  }

  .video-content-wrapper,
  .article-content-wrapper,
  .practice-content-wrapper,
  .test-content-wrapper,
  .homework-content-wrapper {
    width: calc(100% - 6px);
    padding: 20px var(--content-padding-horizontal) 64px;
  }
}

/* FullHD 1920px при масштабе Windows 125% -> ~1536px по CSS */
@media (min-width: 1500px) and (max-width: 1600px) and (max-height: 920px) {
  .u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 {
    --sidebar-left-width: 332px;
    --sidebar-left-offset: 8px;
    --content-left-gap: 10px;
    --content-padding-horizontal: 28px;
  }

  .header-2-4 {
    left: 0;
    right: 0;
    width: auto;
    height: 56px;
    display: flex;
    align-items: center;
    padding: 0 18px;
    box-sizing: border-box;
    overflow: visible;
  }

  .header-2-4 .rectangle-207-5 {
    left: 0;
    top: 0;
    width: 100%;
    height: 56px;
  }

  .header-2-4 .text-415 {
    display: none !important;
  }

  .header-2-4 > a {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    position: relative;
    z-index: 3;
  }

  .header-2-4 .text-416 {
    position: static;
    top: auto;
    left: auto;
    max-width: 320px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    line-height: 1.2;
  }

  .header-2-4 .text-416::before {
    content: "\2190";
    margin-right: 8px;
    font-weight: 700;
  }

  .header-2-4 .header-progress {
    position: static;
    margin-left: auto;
    width: min(460px, 46vw);
  }

  .header-2-4 .progress-meta {
    flex-wrap: nowrap;
    gap: 8px;
  }

  .header-2-4 .progress-text,
  .header-2-4 .progress-refresh-button {
    white-space: nowrap;
  }

  .view-419 {
    height: 92px;
    max-width: calc(100% - 14px);
  }

  .video-content-wrapper,
  .article-content-wrapper,
  .practice-content-wrapper,
  .test-content-wrapper,
  .homework-content-wrapper {
    padding: 16px var(--content-padding-horizontal) 48px;
  }

  .player-container {
    margin-bottom: 24px;
  }
}

@media (min-width: 1601px) and (max-width: 1800px) {
  .u1089u1090u1088u1072u1085u1080u1094u1072-u1074u1080u1076u1077u1086-u1091u1088u1086u1082u1086u1074 {
    --sidebar-left-width: 320px;
    --sidebar-left-offset: 14px;
    --content-left-gap: 14px;
    --content-padding-horizontal: 40px;
  }

  .view-419 {
    max-width: calc(100% - 24px);
  }

  .video-content-wrapper,
  .article-content-wrapper,
  .practice-content-wrapper,
  .test-content-wrapper,
  .homework-content-wrapper {
    width: calc(100% - 8px);
    padding: 20px var(--content-padding-horizontal) 72px;
  }
}
</style>
